import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const LinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 6a4 4 0 01.2 8H12a.75.75 0 01-.1-1.5H14a2.5 2.5 0 00.16-5H12a.75.75 0 01-.1-1.5H14zM8 6a.75.75 0 01.1 1.5H6a2.5 2.5 0 00-.16 5H8a.75.75 0 01.1 1.5H6a4 4 0 01-.2-8H8zM6.25 9.25h7.5a.75.75 0 01.1 1.5h-7.6a.75.75 0 01-.1-1.5h7.6-7.5z",
    fill: primaryFill
  }));
};

export const LinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LinkFilledIcon({}), 'LinkFilled');

const LinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 6a.5.5 0 01.09 1H6a3 3 0 00-.2 6H8a.5.5 0 01.09 1H6a4 4 0 01-.22-8H8zm6 0a4 4 0 01.22 8H12a.5.5 0 01-.09-1H14a3 3 0 00.2-6H12a.5.5 0 01-.09-1H14zM6 9.5h8a.5.5 0 01.09 1H6a.5.5 0 01-.09-1H14 6z",
    fill: primaryFill
  }));
};

export const LinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LinkRegularIcon({}), 'LinkRegular');

const LinkDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 4a4 4 0 013.52 5.9c-.42-.27-.87-.5-1.36-.64a2.5 2.5 0 00-2-3.75L14 5.5h-2a.75.75 0 01-.1-1.5H14zM8 4a.75.75 0 01.1 1.5H6a2.5 2.5 0 00-.16 5H8a.75.75 0 01.1 1.5H6a4 4 0 01-.2-8H8zM6.25 7.25h7.5a.75.75 0 01.1 1.5h-7.6a.75.75 0 01-.1-1.5h.1zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.73-1.06a.5.5 0 00-.7-.7l-1.07 1.05-1.06-1.06a.5.5 0 00-.7.7l1.05 1.07-1.06 1.06a.5.5 0 00.7.7l1.07-1.05 1.06 1.06a.5.5 0 00.7-.7l-1.05-1.07 1.06-1.06z",
    fill: primaryFill
  }));
};

export const LinkDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LinkDismissFilledIcon({}), 'LinkDismissFilled');

const LinkDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 4a.5.5 0 01.09 1H6a3 3 0 00-.2 6H8a.5.5 0 01.09 1H6a4 4 0 01-.22-8H8zm6 0a4 4 0 013.52 5.9 5.49 5.49 0 00-.88-.47 3 3 0 00-2.44-4.42L14 5h-2a.5.5 0 01-.09-1H14zM6 7.5h8a.5.5 0 01.09 1H6a.5.5 0 01-.09-1H6zm13 7a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.73-1.06a.5.5 0 00-.7-.7l-1.07 1.05-1.06-1.06a.5.5 0 00-.7.7l1.05 1.07-1.06 1.06a.5.5 0 00.7.7l1.07-1.05 1.06 1.06a.5.5 0 00.7-.7l-1.05-1.07 1.06-1.06z",
    fill: primaryFill
  }));
};

export const LinkDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LinkDismissRegularIcon({}), 'LinkDismissRegular');

const LinkEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 8a4 4 0 00-4-4h-2.1a.75.75 0 00.1 1.5h2.16A2.5 2.5 0 0116.5 8v.02c.52.07 1.02.28 1.45.63.03-.21.05-.43.05-.65zM8.75 4.75A.75.75 0 008 4H5.8a4 4 0 00.2 8h2.1a.75.75 0 00-.1-1.5H5.84a2.5 2.5 0 01.16-5h2.1a.75.75 0 00.65-.75zm5 2.5h-7.6a.75.75 0 00.1 1.5h7.6a.75.75 0 00-.1-1.5zm-3.77 7.13l4.83-4.83a1.87 1.87 0 012.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01z",
    fill: primaryFill
  }));
};

export const LinkEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LinkEditFilledIcon({}), 'LinkEditFilled');

const LinkEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 4.5A.5.5 0 008 4H5.78A4 4 0 006 12h2.09a.5.5 0 00-.1-1H5.8A3 3 0 016 5h2.09a.5.5 0 00.4-.5zM18 8a4 4 0 00-4-4h-2.1a.5.5 0 00.1 1h2.2A3 3 0 0117 8.14c.33.1.66.28.95.52.03-.21.05-.43.05-.65zm-4-.5H5.9a.5.5 0 00.09 1h8.09a.5.5 0 00-.1-1zm-4.02 6.88l4.83-4.83a1.87 1.87 0 012.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01z",
    fill: primaryFill
  }));
};

export const LinkEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LinkEditRegularIcon({}), 'LinkEditRegular');

const LinkSquareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25H6V13H4.75A2.75 2.75 0 012 10.25v-5.5A2.75 2.75 0 014.75 2h5.5A2.75 2.75 0 0113 4.75v5.5A2.75 2.75 0 0110.25 13H9.5v-1.5h.75c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25h-5.5zM7 9.75A2.75 2.75 0 019.75 7h1v1.5h-1c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25h-1.5V7h1.5A2.75 2.75 0 0118 9.75v5.5A2.75 2.75 0 0115.25 18h-5.5A2.75 2.75 0 017 15.25v-5.5z",
    fill: primaryFill
  }));
};

export const LinkSquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LinkSquareFilledIcon({}), 'LinkSquareFilled');

const LinkSquareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H6v1H4.5A2.5 2.5 0 012 10.5v-6A2.5 2.5 0 014.5 2h6A2.5 2.5 0 0113 4.5v6a2.5 2.5 0 01-2.5 2.5H9v-1h1.5c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-6zm5 4H11v1H9.5C8.67 8 8 8.67 8 9.5v6c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H14V7h1.5A2.5 2.5 0 0118 9.5v6a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 017 15.5v-6A2.5 2.5 0 019.5 7z",
    fill: primaryFill
  }));
};

export const LinkSquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LinkSquareRegularIcon({}), 'LinkSquareRegular');

const LinkToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.75 4.75A.75.75 0 008 4H5.8a4 4 0 00.2 8h2.1a.75.75 0 00-.1-1.5H5.84a2.5 2.5 0 01.16-5h2.1a.75.75 0 00.65-.75zM18 8a4 4 0 00-4-4h-2.1a.75.75 0 00.1 1.5h2.16a2.5 2.5 0 012.08 3.61c.5.16.93.46 1.24.86.33-.58.52-1.25.52-1.97zM6.25 7.25h7.5a.75.75 0 01.1 1.5h-7.6a.75.75 0 01-.1-1.5h.1zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const LinkToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LinkToolboxFilledIcon({}), 'LinkToolboxFilled');

const LinkToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 4a.5.5 0 01.09 1H6a3 3 0 00-.2 6H8a.5.5 0 01.09 1H6a4 4 0 01-.22-8H8zm6 0a4 4 0 013.48 5.97c-.21-.27-.48-.5-.78-.66A3 3 0 0014.2 5L14 5h-2a.5.5 0 01-.09-1H14zM6 7.5h8a.5.5 0 01.09 1H6a.5.5 0 01-.09-1H6zm6 4.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const LinkToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LinkToolboxRegularIcon({}), 'LinkToolboxRegular');

const ListFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.26 15.02a.75.75 0 01.1 1.49H2.83a.75.75 0 01-.1-1.49h9.53zm5.02-5.52a.75.75 0 01.1 1.49H2.83a.75.75 0 01-.1-1.49H17.27zm-4.02-6.05a.75.75 0 01.1 1.5H2.83a.75.75 0 01-.1-1.5h10.53z",
    fill: primaryFill
  }));
};

export const ListFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ListFilledIcon({}), 'ListFilled');

const ListRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 15a.5.5 0 01.09 1H2.5a.5.5 0 01-.09-1H12.5zm5-6a.5.5 0 01.09 1H2.5a.5.5 0 01-.09-.98l.1-.01H17.5zm-4-6a.5.5 0 01.09 1H2.5a.5.5 0 01-.09-1H13.5z",
    fill: primaryFill
  }));
};

export const ListRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ListRegularIcon({}), 'ListRegular');

const LiveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.45 4.17a.73.73 0 00-1.02-.01 8.23 8.23 0 00.17 11.86c.3.27.74.24 1.01-.03a.78.78 0 00-.02-1.11 6.73 6.73 0 01-.15-9.62c.3-.3.32-.78.01-1.1zm1.76 1.76a.71.71 0 00-1-.02 5.73 5.73 0 00.18 8.35c.3.27.73.23.99-.03.32-.33.26-.85-.04-1.14a4.24 4.24 0 01-.14-6.05c.29-.3.33-.8.01-1.11zm5.58 0a.71.71 0 011-.02 5.73 5.73 0 01-.18 8.35.71.71 0 01-.99-.03c-.32-.33-.26-.85.04-1.14a4.24 4.24 0 00.14-6.05c-.29-.3-.33-.8-.01-1.11zm1.76-1.76a.73.73 0 011.02-.01 8.23 8.23 0 01-.17 11.86.73.73 0 01-1.01-.03.78.78 0 01.02-1.11 6.73 6.73 0 00.15-9.62.78.78 0 01-.01-1.1zM10 8.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const LiveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LiveFilledIcon({}), 'LiveFilled');

const LiveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.35 4.33a.48.48 0 01.68.01c.2.2.19.54-.02.75a6.98 6.98 0 00.15 9.97c.22.2.23.55.03.75a.48.48 0 01-.67.02 7.98 7.98 0 01-.17-11.5zM15 5.1a.53.53 0 01-.02-.75c.19-.18.5-.2.68 0a7.98 7.98 0 01-.17 11.5.48.48 0 01-.67-.03.53.53 0 01.03-.75 6.98 6.98 0 00.15-9.97zm-8.86 1a.46.46 0 01.66.02c.2.2.19.55-.02.76a4.49 4.49 0 00.14 6.4c.22.21.25.57.04.78a.46.46 0 01-.64.03 5.49 5.49 0 01-.18-7.99zm7.1.78c-.2-.21-.23-.56-.02-.76.18-.19.48-.2.66-.02a5.48 5.48 0 01-.18 7.99.46.46 0 01-.64-.03c-.21-.21-.18-.57.04-.78a4.49 4.49 0 00.14-6.4zM10 8.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z",
    fill: primaryFill
  }));
};

export const LiveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LiveRegularIcon({}), 'LiveRegular');

const LiveOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l1.8 1.81a8.22 8.22 0 00.65 11.36c.3.27.74.24 1.01-.03a.78.78 0 00-.02-1.11 6.73 6.73 0 01-.57-9.15l.71.71a5.73 5.73 0 00.66 7.82c.3.27.73.23.99-.03.32-.33.26-.85-.04-1.14a4.24 4.24 0 01-.54-5.58l1.85 1.84a1.5 1.5 0 002 2l6.5 6.5a.5.5 0 00.7-.7l-1.8-1.81-1.07-1.07-.71-.71-1.07-1.07-1.85-1.84-2-2L7.4 6.69l-.94-.94-.82-.82L4.7 4 2.85 2.15zm13.8 12.38a8.21 8.21 0 00-1.08-10.37.73.73 0 00-1.02 0c-.31.32-.28.8 0 1.1a6.73 6.73 0 011.01 8.18l1.09 1.09zm-1.82-1.83a5.73 5.73 0 00-1.04-6.79.71.71 0 00-1 .02c-.32.32-.28.82.01 1.11a4.24 4.24 0 01.9 4.54l1.13 1.12z",
    fill: primaryFill
  }));
};

export const LiveOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LiveOffFilledIcon({}), 'LiveOffFilled');

const LiveOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L4 4.71a7.97 7.97 0 00.52 11.12c.2.18.48.17.67-.02.2-.2.19-.55-.03-.75a6.98 6.98 0 01-.45-9.64l1.06 1.06a5.48 5.48 0 00.54 7.6c.18.17.46.15.64-.03.21-.21.18-.57-.04-.78a4.49 4.49 0 01-.43-6.08l2.36 2.35a1.25 1.25 0 001.62 1.62l6.69 6.7a.5.5 0 00.7-.71L16 15.29l-.7-.7-1.07-1.07-.71-.71-2.36-2.35-1.62-1.62-6.69-6.7zM16.62 14.5a7.96 7.96 0 00-.97-10.17.48.48 0 00-.68.01c-.2.2-.19.54.02.75a6.98 6.98 0 01.9 8.68l.73.73zm-1.82-1.82a5.47 5.47 0 00-.93-6.59.46.46 0 00-.66.02c-.2.2-.19.55.02.76a4.49 4.49 0 01.83 5.07l.74.74z",
    fill: primaryFill
  }));
};

export const LiveOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LiveOffRegularIcon({}), 'LiveOffRegular');

const LocalLanguageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.74 1.99a.75.75 0 100 1.5h2.76v1.26c0 .55-.2.98-.48 1.27-.29.29-.71.48-1.27.48a.75.75 0 000 1.5c.92 0 1.74-.32 2.33-.92.6-.6.92-1.42.92-2.33v-2a.75.75 0 00-.75-.75l-3.5-.01zM8.2 5.46a.75.75 0 00-1.38 0l-3.3 7.98-.01.03-1.44 3.5a.75.75 0 001.38.57l1.26-3.05h5.6l1.26 3.04a.75.75 0 001.38-.57L8.2 5.46zM9.7 13H5.31L7.5 7.71 9.68 13zM15.74 2c.42 0 .75.34.75.75V6h.76a.75.75 0 010 1.5h-.76v5.75a.75.75 0 01-1.5 0V2.75c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const LocalLanguageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocalLanguageFilledIcon({}), 'LocalLanguageFilled');

const LocalLanguageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 2a.5.5 0 000 1H13v1.86C13 6.03 11.83 7 10.5 7a.5.5 0 000 1C12.21 8 14 6.74 14 4.86V2.5a.5.5 0 00-.5-.5h-4zM7.96 5.3a.5.5 0 00-.92 0l-5 12a.5.5 0 10.92.4L4.5 14h6l1.54 3.7a.5.5 0 10.92-.39l-1.66-3.99v-.02l-3.34-8zm2.12 7.7H4.92L7.5 6.8l2.58 6.2zM15.5 2c.28 0 .5.22.5.5V6h1.5a.5.5 0 010 1H16v6.5a.5.5 0 11-1 0v-11c0-.28.23-.5.5-.5z",
    fill: primaryFill
  }));
};

export const LocalLanguageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocalLanguageRegularIcon({}), 'LocalLanguageRegular');

const LocationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 13.96a7 7 0 10-9.9 0l1.52 1.5 2.04 1.98.14.12a2 2 0 002.64-.12l2.43-2.37 1.13-1.12zM10 12a3 3 0 110-6 3 3 0 010 6z",
    fill: primaryFill
  }));
};

export const LocationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationFilledIcon({}), 'LocationFilled');

const LocationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 9a3 3 0 11-6 0 3 3 0 016 0zm-1 0a2 2 0 10-4 0 2 2 0 004 0zm2.95 4.96a7 7 0 10-9.9 0l1.52 1.5 2.04 1.98.14.12a2 2 0 002.64-.12l2.43-2.37 1.13-1.12zm-9.2-9.2a6 6 0 018.67 8.3l-.18.19-1.32 1.3-2.23 2.17-.09.08a1 1 0 01-1.2 0l-.1-.08-2.97-2.9-.58-.57-.17-.18a6 6 0 01.17-8.31z",
    fill: primaryFill
  }));
};

export const LocationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationRegularIcon({}), 'LocationRegular');

const LocationAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 4.05a7 7 0 010 9.9l-1.13 1.12-2.43 2.37a2 2 0 01-2.64.12l-.14-.12-2.04-1.99-1.52-1.5a7 7 0 019.9-9.9zM10 5a.5.5 0 00-.5.5V8H7a.5.5 0 000 1h2.5v2.5a.5.5 0 001 0V9H13a.5.5 0 000-1h-2.5V5.5A.5.5 0 0010 5z",
    fill: primaryFill
  }));
};

export const LocationAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationAddFilledIcon({}), 'LocationAddFilled');

const LocationAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 8.5c0-.28.22-.5.5-.5h2.5V5.5a.5.5 0 011 0V8H13a.5.5 0 010 1h-2.5v2.5a.5.5 0 01-1 0V9H7a.5.5 0 01-.5-.5zm8.45 5.46a7 7 0 10-9.9 0l1.52 1.5 2.04 1.98.14.12a2 2 0 002.64-.12l2.43-2.37 1.13-1.12zm-9.2-9.2a6 6 0 018.67 8.3l-.18.19-1.32 1.3-2.23 2.17-.09.08a1 1 0 01-1.2 0l-.1-.08-2.97-2.9-.58-.57-.17-.18a6 6 0 01.17-8.31z",
    fill: primaryFill
  }));
};

export const LocationAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationAddRegularIcon({}), 'LocationAddRegular');

const LocationAddLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 13.96a7 7 0 10-9.9 0l1.52 1.5 2.04 1.98.14.12a2 2 0 002.64-.12l2.43-2.37 1.13-1.12zm-5.1-7.6L8.21 8H13a.5.5 0 010 1H8.2l1.65 1.65a.5.5 0 01-.7.7l-2.5-2.5a.5.5 0 010-.7l2.5-2.5a.5.5 0 11.7.7z",
    fill: primaryFill
  }));
};

export const LocationAddLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationAddLeftFilledIcon({}), 'LocationAddLeftFilled');

const LocationAddLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 4.05a7 7 0 010 9.9l-1.13 1.12-2.43 2.37a2 2 0 01-2.64.12l-.14-.12-2.04-1.99-1.52-1.5a7 7 0 019.9-9.9zm-.7.7a6 6 0 00-8.67 8.32l.17.18.58.57 2.98 2.9.09.08a1 1 0 001.2 0l.1-.08 2.22-2.17 1.32-1.3.18-.18a6 6 0 00-.18-8.31zm-4.4 1.6a.5.5 0 00-.7-.7l-2.5 2.5a.5.5 0 000 .7l2.5 2.5a.5.5 0 00.7-.7L8.21 9H13a.5.5 0 000-1H8.2l1.65-1.65z",
    fill: primaryFill
  }));
};

export const LocationAddLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationAddLeftRegularIcon({}), 'LocationAddLeftRegular');

const LocationAddRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 13.96a7 7 0 10-9.9 0l1.52 1.5 2.04 1.98.14.12a2 2 0 002.64-.12l2.43-2.37 1.13-1.12zm-4.8-7.6a.5.5 0 01.7-.71l2.5 2.5a.5.5 0 010 .7l-2.5 2.5a.5.5 0 01-.7-.7L11.79 9H7a.5.5 0 010-1h4.8l-1.65-1.65z",
    fill: primaryFill
  }));
};

export const LocationAddRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationAddRightFilledIcon({}), 'LocationAddRightFilled');

const LocationAddRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 4.05a7 7 0 010 9.9l-1.13 1.12-2.43 2.37a2 2 0 01-2.64.12l-.14-.12-2.04-1.99-1.52-1.5a7 7 0 019.9-9.9zm-.7.7a6 6 0 00-8.67 8.32l.17.18.58.57 2.98 2.9.09.08a1 1 0 001.2 0l.1-.08 2.22-2.17 1.32-1.3.18-.18a6 6 0 00-.18-8.31zm-4.1 1.6a.5.5 0 01.7-.7l2.5 2.5a.5.5 0 010 .7l-2.5 2.5a.5.5 0 01-.7-.7L11.79 9H7a.5.5 0 010-1h4.8l-1.65-1.65z",
    fill: primaryFill
  }));
};

export const LocationAddRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationAddRightRegularIcon({}), 'LocationAddRightRegular');

const LocationAddUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 13.96a7 7 0 10-9.9 0l1.52 1.5 2.04 1.98.14.12a2 2 0 002.64-.12l2.43-2.37 1.13-1.12zm-2.8-5.6L10.5 6.7v4.79a.5.5 0 01-1 0V6.7L7.85 8.36a.5.5 0 11-.7-.7l2.5-2.5a.5.5 0 01.7 0l2.5 2.5a.5.5 0 01-.7.7z",
    fill: primaryFill
  }));
};

export const LocationAddUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationAddUpFilledIcon({}), 'LocationAddUpFilled');

const LocationAddUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 4.05a7 7 0 010 9.9l-1.13 1.12-2.43 2.37a2 2 0 01-2.64.12l-.14-.12-2.04-1.99-1.52-1.5a7 7 0 019.9-9.9zm-.7.7a6 6 0 00-8.67 8.32l.17.18.58.57 2.98 2.9.09.08a1 1 0 001.2 0l.1-.08 2.22-2.17 1.32-1.3.18-.18a6 6 0 00-.18-8.31zm-2.1 3.6a.5.5 0 00.7-.7l-2.5-2.5a.5.5 0 00-.7 0l-2.5 2.5a.5.5 0 10.7.7L9.5 6.71v4.79a.5.5 0 001 0V6.7l1.65 1.65z",
    fill: primaryFill
  }));
};

export const LocationAddUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationAddUpRegularIcon({}), 'LocationAddUpRegular');

const LocationDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 4.05a7 7 0 010 9.9l-1.13 1.12-2.43 2.37a2 2 0 01-2.64.12l-.14-.12-2.04-1.99-1.52-1.5a7 7 0 019.9-9.9zm-7.8 2.1a.5.5 0 000 .7L9.29 9l-2.14 2.15a.5.5 0 00.7.7L10 9.71l2.15 2.14a.5.5 0 00.7-.7L10.71 9l2.14-2.15a.5.5 0 00-.7-.7L10 8.29 7.85 6.15a.5.5 0 00-.7 0z",
    fill: primaryFill
  }));
};

export const LocationDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationDismissFilledIcon({}), 'LocationDismissFilled');

const LocationDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 13.96a7 7 0 10-9.9 0l1.52 1.5 2.04 1.98.14.12a2 2 0 002.64-.12l2.43-2.37 1.13-1.12zm-9.2-9.2a6 6 0 018.67 8.3l-.18.19-1.32 1.3-2.23 2.17-.09.08a1 1 0 01-1.2 0l-.1-.08-2.97-2.9-.58-.57-.17-.18a6 6 0 01.17-8.31zm1.4 1.39c.2-.2.5-.2.7 0L10 8.29l2.15-2.14a.5.5 0 01.7.7L10.71 9l2.14 2.15a.5.5 0 01-.7.7L10 9.71l-2.15 2.14a.5.5 0 01-.7-.7L9.29 9 7.15 6.85a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const LocationDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationDismissRegularIcon({}), 'LocationDismissRegular');

const LocationLiveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.53 3.01L9 3a7 7 0 016.98 7.47.5.5 0 101 .07L17 10A8 8 0 008.46 2a.5.5 0 10.07 1zM8 4.98a.5.5 0 01.52-.47 6.25 6.25 0 015.97 5.97.5.5 0 11-1 .04A5.25 5.25 0 008.49 5.5.5.5 0 018 4.98zM6.04 16.4l1.1 1.1c.2.2.52.2.71 0L9 16.37l1.7-1.69a4.5 4.5 0 10-6.37 0l1.72 1.72zm1.46-3.78a1.13 1.13 0 110-2.25 1.13 1.13 0 010 2.25z",
    fill: primaryFill
  }));
};

export const LocationLiveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationLiveFilledIcon({}), 'LocationLiveFilled');

const LocationLiveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.53 3.01L9 3a7 7 0 016.98 7.47.5.5 0 101 .07L17 10A8 8 0 008.46 2a.5.5 0 10.07 1zM8 4.98a.5.5 0 01.52-.47 6.25 6.25 0 015.97 5.97.5.5 0 11-1 .04A5.25 5.25 0 008.49 5.5.5.5 0 018 4.98zm-.5 7.64a1.13 1.13 0 100-2.25 1.13 1.13 0 000 2.25zm-3.18 2.06l2.83 2.83a.5.5 0 00.7 0l2.83-2.83a4.5 4.5 0 10-6.36 0zm.7-.7a3.5 3.5 0 114.95 0L7.5 16.44l-2.47-2.48z",
    fill: primaryFill
  }));
};

export const LocationLiveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationLiveRegularIcon({}), 'LocationLiveRegular');

const LocationOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l2.12 2.13a7 7 0 00.78 8.98l1.52 1.5 2.04 1.98.14.12a2 2 0 002.64-.12l2.43-2.37.27-.27 3.06 3.05a.5.5 0 00.7-.7l-15-15zm8.23 9.63A2.98 2.98 0 017 9c0-.38.07-.74.2-1.07l3.87 3.86zM12.99 9c0 .54-.14 1.05-.4 1.49l2.9 2.88a7 7 0 00-9.85-9.84L8.52 6.4A3 3 0 0113 9z",
    fill: primaryFill
  }));
};

export const LocationOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationOffFilledIcon({}), 'LocationOffFilled');

const LocationOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 01-.7.7l-3.06-3.05-.27.27-2.43 2.37a2 2 0 01-2.64.12l-.14-.12-2.04-1.99-1.52-1.5a7 7 0 01-.78-8.97L2.15 2.85a.5.5 0 010-.7zm8.93 9.63A2.98 2.98 0 017 9c0-.38.07-.74.2-1.07L4.99 5.7a6.01 6.01 0 00.59 7.37l.17.18.58.57 2.98 2.9.09.08a1 1 0 001.2 0l.1-.08 2.22-2.17.47-.45-2.31-2.32zm.77-2.05l.75.75A3 3 0 008.52 6.4l.74.74A1.99 1.99 0 0112 8.99a2 2 0 01-.15.74zm-5.5-5.5a6 6 0 018.42 8.42l.71.71a7 7 0 00-9.84-9.84l.71.71z",
    fill: primaryFill
  }));
};

export const LocationOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LocationOffRegularIcon({}), 'LocationOffRegular');

const LockClosedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a3 3 0 013 3v1h1a2 2 0 012 2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V8c0-1.1.9-2 2-2h1V5a3 3 0 013-3zm0 8.5a1 1 0 100 2 1 1 0 000-2zM10 4a1 1 0 00-1 1v1h2V5a1 1 0 00-1-1z",
    fill: primaryFill
  }));
};

export const LockClosedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LockClosedFilledIcon({}), 'LockClosedFilled');

const LockClosedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a3 3 0 013 3v1h1a2 2 0 012 2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V8c0-1.1.9-2 2-2h1V5a3 3 0 013-3zm4 5H6a1 1 0 00-1 1v7a1 1 0 001 1h8a1 1 0 001-1V8a1 1 0 00-1-1zm-4 3.5a1 1 0 110 2 1 1 0 010-2zM10 3a2 2 0 00-2 2v1h4V5a2 2 0 00-2-2z",
    fill: primaryFill
  }));
};

export const LockClosedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LockClosedRegularIcon({}), 'LockClosedRegular');

const LockMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 3a2 2 0 012 2v1H7V5c0-1.1.9-2 2-2zm3 3V5a3 3 0 10-6 0v1h-.5C4.67 6 4 6.67 4 7.5v6c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H12zM6.09 16c.2.58.76 1 1.41 1h5a3.5 3.5 0 003.5-3.5v-4c0-.65-.42-1.2-1-1.41v5.41a2.5 2.5 0 01-2.5 2.5H6.1zM10 10.5a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const LockMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LockMultipleFilledIcon({}), 'LockMultipleFilled');

const LockMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 3a2 2 0 012 2v1H7V5c0-1.1.9-2 2-2zM6 5v1h-.5C4.67 6 4 6.67 4 7.5v6c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H12V5a3 3 0 10-6 0zM5 7.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v6a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-6zM7.5 17a1.5 1.5 0 01-1.41-1h6.41a2.5 2.5 0 002.5-2.5V8.09c.58.2 1 .76 1 1.41v4a3.5 3.5 0 01-3.5 3.5h-5zM9 11.5a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const LockMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LockMultipleRegularIcon({}), 'LockMultipleRegular');

const LockOpenFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c1.3 0 2.42.8 2.84 2a.75.75 0 01-1.38.59l-.04-.1c-.2-.59-.77-.99-1.42-.99-.78 0-1.42.6-1.5 1.36V7H14a2 2 0 012 2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V9c0-1.1.9-2 2-2h1V5a3 3 0 013-3zm0 9.5a1 1 0 100 2 1 1 0 000-2z",
    fill: primaryFill
  }));
};

export const LockOpenFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LockOpenFilledIcon({}), 'LockOpenFilled');

const LockOpenRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a3 3 0 012.94 2.4.5.5 0 11-.98.2A2 2 0 008 4.85V7h6a2 2 0 012 2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V9c0-1.1.9-2 2-2h1V5a3 3 0 013-3zm4 6H6a1 1 0 00-1 1v7a1 1 0 001 1h8a1 1 0 001-1V9a1 1 0 00-1-1zm-4 3.5a1 1 0 110 2 1 1 0 010-2z",
    fill: primaryFill
  }));
};

export const LockOpenRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LockOpenRegularIcon({}), 'LockOpenRegular');

const LockShieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a3 3 0 013 3v1h1a2 2 0 012 2v1.23c-.33-.19-.66-.45-1-.8a1.39 1.39 0 00-2 0 3.5 3.5 0 01-2.6 1.24c-.81 0-1.4.67-1.4 1.41v2.8c.04 1.16.3 2.2.82 3.12H6a2 2 0 01-2-2V8c0-1.1.9-2 2-2h1V5a3 3 0 013-3zm0 2a1 1 0 00-1 1v1h2V5a1 1 0 00-1-1zm4.28 5.12c.54.57 1.11.97 1.72 1.23a4.06 4.06 0 001.6.32c.2 0 .35.14.4.33v2.58c0 2.69-1.31 4.51-3.87 5.4a.39.39 0 01-.26 0A6.66 6.66 0 0112 18c-.39-.3-.72-.63-.99-1a5.5 5.5 0 01-1-3.15l-.01-.27v-2.5a.4.4 0 01.4-.41 4.5 4.5 0 003.32-1.55.39.39 0 01.56 0z",
    fill: primaryFill
  }));
};

export const LockShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LockShieldFilledIcon({}), 'LockShieldFilled');

const LockShieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a3 3 0 013 3v1h1a2 2 0 012 2v1.23c-.33-.19-.66-.45-1-.8V8a1 1 0 00-1-1H6a1 1 0 00-1 1v7a1 1 0 001 1h3.38c.11.35.26.68.44 1H6a2 2 0 01-2-2V8c0-1.1.9-2 2-2h1V5a3 3 0 013-3zm0 1a2 2 0 00-2 2v1h4V5a2 2 0 00-2-2zm5 6.76a4.63 4.63 0 002 .86c.2.03.4.05.6.05.2 0 .35.14.4.33v2.58c0 2.69-1.31 4.51-3.87 5.4a.39.39 0 01-.26 0A6.66 6.66 0 0112 18a4.96 4.96 0 01-1.56-2 6.05 6.05 0 01-.44-2.15v-2.77a.4.4 0 01.4-.41 4.5 4.5 0 003.32-1.55.39.39 0 01.56 0c.24.25.48.46.72.64z",
    fill: primaryFill
  }));
};

export const LockShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LockShieldRegularIcon({}), 'LockShieldRegular');

const LotteryFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.44 3.25c-.98.32-1.83.94-2.44 1.75a5.01 5.01 0 00-2.44-1.75 3 3 0 014.88 0zm-8.81 7.97a6.5 6.5 0 015.85-5.2 4 4 0 10-5.85 5.2zm12.74 0a4 4 0 10-5.85-5.2 6.5 6.5 0 015.85 5.2zm-.87 1.28a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-7.5-2c0 .28.22.5.5.5h2.24l-.32.48a7.65 7.65 0 00-1.17 2.96.5.5 0 101 .12c.1-.9.56-1.82 1.02-2.54a11.1 11.1 0 01.84-1.17l.01-.02a.5.5 0 00-.37-.83H8.5a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const LotteryFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LotteryFilledIcon({}), 'LotteryFilled');

const LotteryRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3.67a2 2 0 013 0c.3-.17.6-.31.94-.42a3 3 0 00-4.88 0c.33.1.65.25.95.42zM3 8a3 3 0 015.4-1.8c.35-.09.7-.15 1.08-.18a4 4 0 10-5.85 5.2c.07-.36.17-.71.3-1.05A3 3 0 013 8zm11-4a4 4 0 00-3.48 2.02c.37.03.73.09 1.08.18a3 3 0 114.47 3.97c.13.34.23.69.3 1.05A4 4 0 0014 4zm-8.5 8.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM10 7a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm-1.5 3a.5.5 0 000 1h2.24l-.32.48a7.65 7.65 0 00-1.17 2.96.5.5 0 101 .12c.1-.9.56-1.82 1.02-2.54a11.1 11.1 0 01.84-1.17l.01-.02a.5.5 0 00-.37-.83H8.5z",
    fill: primaryFill
  }));
};

export const LotteryRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LotteryRegularIcon({}), 'LotteryRegular');

const LuggageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2a.5.5 0 000 1H7v1h-.5A2.5 2.5 0 004 6.5v8a2.5 2.5 0 002 2.45v.55a.5.5 0 001 0V17h6v.5a.5.5 0 001 0v-.55a2.5 2.5 0 002-2.45v-8A2.5 2.5 0 0013.5 4H13V3h.5a.5.5 0 000-1h-7zM12 3v1H8V3h4zM6.5 8.5c0-.28.22-.5.5-.5h6a.5.5 0 010 1H7a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const LuggageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LuggageFilledIcon({}), 'LuggageFilled');

const LuggageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2a.5.5 0 000 1H7v1h-.5A2.5 2.5 0 004 6.5v8a2.5 2.5 0 002 2.45v.55a.5.5 0 001 0V17h6v.5a.5.5 0 001 0v-.55a2.5 2.5 0 002-2.45v-8A2.5 2.5 0 0013.5 4H13V3h.5a.5.5 0 000-1h-7zM12 3v1H8V3h4zM6.5 5h7c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 14.5v-8C5 5.67 5.67 5 6.5 5zm0 3.5c0-.28.22-.5.5-.5h6a.5.5 0 010 1H7a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const LuggageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LuggageRegularIcon({}), 'LuggageRegular');

const MailFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 7.37v7.13a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0L18 7.37zM15.5 4a2.5 2.5 0 012.48 2.22L10 10.92l-7.98-4.7A2.5 2.5 0 014.5 4h11z",
    fill: primaryFill
  }));
};

export const MailFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailFilledIcon({}), 'MailFilled');

const MailRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 4A2.5 2.5 0 0118 6.5v8a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h11zM17 7.96l-6.75 3.97a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V7.96zM15.5 5h-11C3.67 5 3 5.67 3 6.5v.3l7 4.12 7-4.12v-.3c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const MailRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailRegularIcon({}), 'MailRegular');

const MailAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4z",
    fill: primaryFill
  }));
};

export const MailAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailAddFilledIcon({}), 'MailAddFilled');

const MailAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm2 11v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5z",
    fill: primaryFill
  }));
};

export const MailAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailAddRegularIcon({}), 'MailAddRegular');

const MailAlertFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 4a3 3 0 016 0v2l1.32 1.12a.5.5 0 01-.33.88H10.5a.5.5 0 01-.32-.88L11.5 6V4zm3 6a1.5 1.5 0 01-1.42-1h2.83c-.2.58-.76 1-1.41 1zm-4-4.46l-.97.82A1.5 1.5 0 0010.5 9h1.52l.12.33.11.27L10 10.92l-7.98-4.7A2.5 2.5 0 014.5 4h6v1.54zm-.25 6.4l2.62-1.55a2.49 2.49 0 003.99-1.06l.11-.33H18v5.5a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0z",
    fill: primaryFill
  }));
};

export const MailAlertFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailAlertFilledIcon({}), 'MailAlertFilled');

const MailAlertRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 4a3 3 0 016 0v2l1.32 1.12a.5.5 0 01-.33.88H10.5a.5.5 0 01-.32-.88L11.5 6V4zm3 6a1.5 1.5 0 01-1.42-1h2.83c-.2.58-.76 1-1.41 1zm-10-5h6V4h-6A2.5 2.5 0 002 6.5v8A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5V9h-1v5.5c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 14.5V7.96l6.75 3.97.08.04c.14.05.3.04.42-.04l2.62-1.54a2.5 2.5 0 01-.62-.8L10 10.93 3 6.8v-.3C3 5.67 3.67 5 4.5 5z",
    fill: primaryFill
  }));
};

export const MailAlertRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailAlertRegularIcon({}), 'MailAlertRegular');

const MailAllReadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 17a2.5 2.5 0 01-2-1h9a3.5 3.5 0 003.5-3.5v-6c.6.46 1 1.18 1 2v4a4.5 4.5 0 01-4.5 4.5h-7zM9.24 2.06a.5.5 0 00-.48 0l-5.7 3.07a2 2 0 00-.76.71l.42.2L9 8.95l6.28-2.89.41-.22a2 2 0 00-.74-.7L9.24 2.06zM16 6.8l-.26.14a.5.5 0 01-.03.01l-6.5 3a.5.5 0 01-.42 0l-6.5-3h-.01L2 6.8V12.5A2.5 2.5 0 004.5 15h9a2.5 2.5 0 002.5-2.5V6.9v-.1z",
    fill: primaryFill
  }));
};

export const MailAllReadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailAllReadFilledIcon({}), 'MailAllReadFilled');

const MailAllReadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.76 2.06a.5.5 0 01.48 0l5.7 3.07A2 2 0 0116 6.9v5.6a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 012 12.5V6.9a2 2 0 011.05-1.77l5.71-3.07zm.24 1L3.53 6.03a1 1 0 00-.32.26L9 8.95l5.79-2.67a1 1 0 00-.32-.26L9 3.07zm6 4.22L9.21 9.95a.5.5 0 01-.42 0L3 7.28v5.22c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V7.28zM6.5 17a2.5 2.5 0 01-2-1h9a3.5 3.5 0 003.5-3.5v-6c.6.46 1 1.18 1 2v4a4.5 4.5 0 01-4.5 4.5h-7z",
    fill: primaryFill
  }));
};

export const MailAllReadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailAllReadRegularIcon({}), 'MailAllReadRegular');

const MailAllUnreadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-3.16-4H4.5a2.5 2.5 0 00-2.48 2.22L9 8.92l3.26-1.73A3.5 3.5 0 0111.34 3zm1.97 4.8L9.25 9.92a.5.5 0 01-.5 0L2 6.37v6.13A2.5 2.5 0 004.5 15h9a2.5 2.5 0 002.5-2.5V7.66a3.49 3.49 0 01-2.7.13zM6.5 17a2.5 2.5 0 01-2-1h9a3.5 3.5 0 003.5-3.5v-5c.6.46 1 1.18 1 2v3a4.5 4.5 0 01-4.5 4.5h-7z",
    fill: primaryFill
  }));
};

export const MailAllUnreadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailAllUnreadFilledIcon({}), 'MailAllUnreadFilled');

const MailAllUnreadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-3.16-4H4.5A2.5 2.5 0 002 5.5v7A2.5 2.5 0 004.5 15h9a2.5 2.5 0 002.5-2.5V7.66c-.31.15-.65.25-1 .3v4.54c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 013 12.5V6.96l5.75 2.97.08.04c.14.05.3.04.42-.04l4.1-2.12a3.5 3.5 0 01-1.06-.6L9 8.92 3 5.8v-.3C3 4.67 3.67 4 4.5 4h6.54c.05-.35.15-.69.3-1zM6.5 17a2.5 2.5 0 01-2-1h9a3.5 3.5 0 003.5-3.5v-5c.6.46 1 1.18 1 2v3a4.5 4.5 0 01-4.5 4.5h-7z",
    fill: primaryFill
  }));
};

export const MailAllUnreadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailAllUnreadRegularIcon({}), 'MailAllUnreadRegular');

const MailArrowDoubleBackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 11c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4zm10 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1.15-6.35c.2.2.2.5 0 .7L12.21 5.5l1.14 1.15a.5.5 0 01-.7.7l-1.5-1.5a.5.5 0 010-.7l1.5-1.5c.2-.2.5-.2.7 0zm2.5.7l-.64.65H17a1 1 0 011 1v.5a.5.5 0 01-1 0V6h-1.8l.65.65a.5.5 0 01-.7.7l-1.5-1.5a.5.5 0 010-.7l1.5-1.5a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const MailArrowDoubleBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailArrowDoubleBackFilledIcon({}), 'MailArrowDoubleBackFilled');

const MailArrowDoubleBackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5zM14.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1.15-6.35c.2.2.2.5 0 .7L12.21 5.5l1.14 1.15a.5.5 0 01-.7.7l-1.5-1.5a.5.5 0 010-.7l1.5-1.5c.2-.2.5-.2.7 0zm2.5.7l-.64.65H17a1 1 0 011 1v.5a.5.5 0 01-1 0V6h-1.8l.65.65a.5.5 0 01-.7.7l-1.5-1.5a.5.5 0 010-.7l1.5-1.5a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const MailArrowDoubleBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailArrowDoubleBackRegularIcon({}), 'MailArrowDoubleBackRegular');

const MailArrowDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 11c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4zm10 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2.35-4.15a.5.5 0 01.7-.7L14 6.29V3.5a.5.5 0 011 0v2.8l1.15-1.15a.5.5 0 01.7.7l-2 2a.5.5 0 01-.35.15.5.5 0 01-.35-.14l-2-2z",
    fill: primaryFill
  }));
};

export const MailArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailArrowDownFilledIcon({}), 'MailArrowDownFilled');

const MailArrowDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5zM14.5 10a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.15l2 2a.5.5 0 00.35.15.5.5 0 00.35-.15l2-2a.5.5 0 00-.7-.7L15 6.29V3.5a.5.5 0 00-1 0v2.8l-1.15-1.15a.5.5 0 00-.7.7z",
    fill: primaryFill
  }));
};

export const MailArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailArrowDownRegularIcon({}), 'MailArrowDownRegular');

const MailArrowForwardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 11c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4zM10 5.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 010 .7L16.1 7.1a.5.5 0 01-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 01-1 0v-.25a2.75 2.75 0 012.75-2.75h1.54l-.9-.9a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const MailArrowForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailArrowForwardFilledIcon({}), 'MailArrowForwardFilled');

const MailArrowForwardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5zm-7-9a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 010 .7L16.1 7.1a.5.5 0 01-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 01-1 0v-.25a2.75 2.75 0 012.75-2.75h1.54l-.9-.9a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const MailArrowForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailArrowForwardRegularIcon({}), 'MailArrowForwardRegular');

const MailArrowUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.15-2.35A.5.5 0 0014.5 3a.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L14 4.71V7.5a.5.5 0 101 0V4.7l1.15 1.15a.5.5 0 10.7-.7l-2-2zM14.5 11c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4z",
    fill: primaryFill
  }));
};

export const MailArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailArrowUpFilledIcon({}), 'MailArrowUpFilled');

const MailArrowUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.15-2.35A.5.5 0 0014.5 3a.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L14 4.71V7.5a.5.5 0 101 0V4.7l1.15 1.15a.5.5 0 10.7-.7l-2-2zM17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5z",
    fill: primaryFill
  }));
};

export const MailArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailArrowUpRegularIcon({}), 'MailArrowUpRegular');

const MailAttachFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.3 8.7c.2.2.44.32.7.39-.21.43-.29.91-.23 1.38l-.77.45-7.98-4.7A2.5 2.5 0 014.5 4h8.37L10.3 6.58a1.5 1.5 0 000 2.12zm.78 2.74a2.57 2.57 0 004.04.55L18 9.12v5.38a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l.83-.49zm4.15-6.96a1.62 1.62 0 012.3 2.3h-.02l-3.85 3.85h-.01a.56.56 0 11-.78-.8l3.48-3.48a.5.5 0 10-.7-.7l-3.5 3.49-.02.02a1.56 1.56 0 002.21 2.2l.01-.01 3.88-3.87.01-.01a2.63 2.63 0 00-3.72-3.7l-3.57 3.57a.5.5 0 00.7.7l3.58-3.56z",
    fill: primaryFill
  }));
};

export const MailAttachFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailAttachFilledIcon({}), 'MailAttachFilled');

const MailAttachRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.77 10.47l-.77.45L3 6.8v-.3C3 5.67 3.67 5 4.5 5h7.38l1-1H4.5A2.5 2.5 0 002 6.5v8A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5V9.12l-1 1v4.38c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 14.5V7.96l6.75 3.97.08.04c.14.05.3.04.42-.04l.83-.49c-.17-.3-.28-.63-.31-.97zm4.46-6a1.62 1.62 0 012.3 2.3l-.02.01-3.85 3.85h-.01a.56.56 0 11-.78-.8l3.48-3.48a.5.5 0 10-.7-.7l-3.5 3.49-.02.02a1.56 1.56 0 002.21 2.2l.01-.01 3.88-3.87.01-.01a2.63 2.63 0 00-3.72-3.7l-3.57 3.57a.5.5 0 00.7.7l3.58-3.56z",
    fill: primaryFill
  }));
};

export const MailAttachRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailAttachRegularIcon({}), 'MailAttachRegular');

const MailCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 11c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4zm10 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm2.35-5.65l-3 3a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 2.65-2.64a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const MailCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailCheckmarkFilledIcon({}), 'MailCheckmarkFilled');

const MailCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5zM14.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm2.35-5.65l-3 3a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 2.65-2.64a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const MailCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailCheckmarkRegularIcon({}), 'MailCheckmarkRegular');

const MailClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 3a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1V3.5a.5.5 0 00-.5-.5zm0 8c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4z",
    fill: primaryFill
  }));
};

export const MailClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailClockFilledIcon({}), 'MailClockFilled');

const MailClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 3a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1V3.5a.5.5 0 00-.5-.5zM17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5z",
    fill: primaryFill
  }));
};

export const MailClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailClockRegularIcon({}), 'MailClockRegular');

const MailCopyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 12.5V6.37l6.75 3.56c.15.1.35.1.5 0L18 6.37v6.13a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 014 12.5zm.02-7.28A2.5 2.5 0 016.5 3h9a2.5 2.5 0 012.48 2.22L11 8.92l-6.98-3.7zM13.5 17c.82 0 1.54-.4 2-1h-9A3.5 3.5 0 013 12.5v-7c-.6.46-1 1.18-1 2v5A4.5 4.5 0 006.5 17h7z",
    fill: primaryFill
  }));
};

export const MailCopyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailCopyFilledIcon({}), 'MailCopyFilled');

const MailCopyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5.5A2.5 2.5 0 016.5 3h9A2.5 2.5 0 0118 5.5v7a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 014 12.5v-7zm6.75 4.43L5 6.96v5.54c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V6.96l-5.75 2.97-.08.04a.5.5 0 01-.42-.04zM15.5 4h-9C5.67 4 5 4.67 5 5.5v.3l6 3.12 6-3.12v-.3c0-.83-.67-1.5-1.5-1.5zm-2 13c.82 0 1.54-.4 2-1h-9A3.5 3.5 0 013 12.5v-7c-.6.46-1 1.18-1 2v5A4.5 4.5 0 006.5 17h7z",
    fill: primaryFill
  }));
};

export const MailCopyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailCopyRegularIcon({}), 'MailCopyRegular');

const MailDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L15.21 5.5l1.14-1.15zM14.5 11c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4z",
    fill: primaryFill
  }));
};

export const MailDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailDismissFilledIcon({}), 'MailDismissFilled');

const MailDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L15.21 5.5l1.14-1.15zM17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5z",
    fill: primaryFill
  }));
};

export const MailDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailDismissRegularIcon({}), 'MailDismissRegular');

const MailEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 6.37v2.76a2.87 2.87 0 00-2.9.71l-4.83 4.83a3.2 3.2 0 00-.8 1.33H4.5A2.5 2.5 0 012 13.5V6.37l7.75 4.56c.15.1.35.1.5 0L18 6.37zM15.5 3a2.5 2.5 0 012.48 2.22L10 9.92l-7.98-4.7A2.5 2.5 0 014.5 3h11zm-4.52 12.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const MailEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailEditFilledIcon({}), 'MailEditFilled');

const MailEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 3A2.5 2.5 0 0118 5.5v3.63c-.32-.1-.66-.14-1-.13V6.96l-6.75 3.97a.5.5 0 01-.42.04l-.08-.04L3 6.96v6.54c0 .83.67 1.5 1.5 1.5h5.48c-.22.3-.4.64-.5 1H4.5A2.5 2.5 0 012 13.5v-8A2.5 2.5 0 014.5 3h11zm0 1h-11C3.67 4 3 4.67 3 5.5v.3l7 4.12 7-4.12v-.3c0-.83-.67-1.5-1.5-1.5zm-4.52 11.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const MailEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailEditRegularIcon({}), 'MailEditRegular');

const MailErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 3a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.25zm0 2.87c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4z",
    fill: primaryFill
  }));
};

export const MailErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailErrorFilledIcon({}), 'MailErrorFilled');

const MailErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 3a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.25zM17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5z",
    fill: primaryFill
  }));
};

export const MailErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailErrorRegularIcon({}), 'MailErrorRegular');

const MailInboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm1 4h3.5c.28 0 .5.22.5.5v.01a1.64 1.64 0 00.03.3c.04.2.1.46.23.72.13.25.3.49.57.66.26.18.63.31 1.17.31.54 0 .9-.13 1.17-.3.26-.18.44-.42.57-.67A2.57 2.57 0 0012 10.5v-.01c0-.28.22-.5.5-.5H16V6a2 2 0 00-2-2H6a2 2 0 00-2 2v4zm4 .5z",
    fill: primaryFill
  }));
};

export const MailInboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxFilledIcon({}), 'MailInboxFilled');

const MailInboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zm10 7h-3.5a.5.5 0 00-.5.5v.01a1.75 1.75 0 01-.03.3c-.04.2-.1.46-.23.72-.13.25-.3.49-.57.66-.26.18-.63.31-1.17.31-.54 0-.9-.13-1.17-.3a1.7 1.7 0 01-.57-.67A2.57 2.57 0 018 10.5v-.01a.5.5 0 00-.5-.5H4V6c0-1.1.9-2 2-2h8a2 2 0 012 2v4zM4 11h3.05c.05.26.14.62.32.97.18.38.47.76.9 1.06.45.29 1.02.47 1.73.47s1.28-.18 1.72-.47c.44-.3.73-.68.91-1.06.18-.35.27-.7.32-.97H16v3a2 2 0 01-2 2H6a2 2 0 01-2-2v-3z",
    fill: primaryFill
  }));
};

export const MailInboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxRegularIcon({}), 'MailInboxRegular');

const MailInboxAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H13v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H14V3.5zm2 7.5v-.6c.36-.18.7-.4 1-.66V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h2.2c-.08.32-.15.66-.18 1H6a2 2 0 00-2 2v4h3.5c.28 0 .5.22.5.5v.01a1.64 1.64 0 00.03.3c.04.2.1.46.23.72.13.25.3.49.57.66.26.18.63.31 1.17.31.54 0 .9-.13 1.17-.3.26-.18.44-.42.57-.67A2.57 2.57 0 0012 11.5v-.01c0-.28.22-.5.5-.5H16z",
    fill: primaryFill
  }));
};

export const MailInboxAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxAddFilledIcon({}), 'MailInboxAddFilled');

const MailInboxAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H13v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H14V3.5zM6 5h2.02c.03-.34.1-.68.19-1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V9.74c-.3.26-.64.48-1 .66v.6h-3.5a.5.5 0 00-.5.5v.01a1.75 1.75 0 01-.03.3c-.04.2-.1.46-.23.72-.13.25-.3.49-.57.66-.26.18-.63.31-1.17.31-.54 0-.9-.13-1.17-.3a1.7 1.7 0 01-.57-.67A2.57 2.57 0 018 11.5v-.01a.5.5 0 00-.5-.5H4V7c0-1.1.9-2 2-2zm-2 7h3.05c.05.26.14.62.32.97.18.38.47.76.9 1.06.45.29 1.02.47 1.73.47s1.28-.18 1.72-.47c.44-.3.73-.68.91-1.06.18-.35.27-.7.32-.97H16v3a2 2 0 01-2 2H6a2 2 0 01-2-2v-3z",
    fill: primaryFill
  }));
};

export const MailInboxAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxAddRegularIcon({}), 'MailInboxAddRegular');

const MailInboxAllFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 5.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm0 2c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zM3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm1 4h3.5c.28 0 .5.22.5.5v.01a1.64 1.64 0 00.03.3c.04.2.1.46.23.72.13.25.3.49.57.66.26.18.63.31 1.17.31.54 0 .9-.13 1.17-.3.26-.18.44-.42.57-.67A2.57 2.57 0 0012 10.5v-.01c0-.28.22-.5.5-.5H16V6a2 2 0 00-2-2H6a2 2 0 00-2 2v4zm4 .5z",
    fill: primaryFill
  }));
};

export const MailInboxAllFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxAllFilledIcon({}), 'MailInboxAllFilled');

const MailInboxAllRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 5.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zM6.5 7a.5.5 0 000 1h7a.5.5 0 000-1h-7zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zm10 7h-3.5a.5.5 0 00-.5.5v.01a1.75 1.75 0 01-.03.3c-.04.2-.1.46-.23.72-.13.25-.3.49-.57.66-.26.18-.63.31-1.17.31-.54 0-.9-.13-1.17-.3a1.7 1.7 0 01-.57-.67A2.57 2.57 0 018 10.5v-.01a.5.5 0 00-.5-.5H4V6c0-1.1.9-2 2-2h8a2 2 0 012 2v4zM4 11h3.05c.05.26.14.62.32.97.18.38.47.76.9 1.06.45.29 1.02.47 1.73.47s1.28-.18 1.72-.47c.44-.3.73-.68.91-1.06.18-.35.27-.7.32-.97H16v3a2 2 0 01-2 2H6a2 2 0 01-2-2v-3z",
    fill: primaryFill
  }));
};

export const MailInboxAllRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxAllRegularIcon({}), 'MailInboxAllRegular');

const MailInboxArrowDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 10.4v.6h-3.5a.5.5 0 00-.5.5v.01a1.75 1.75 0 01-.03.3c-.04.2-.1.46-.23.72-.13.25-.3.49-.57.66-.26.18-.63.31-1.17.31-.54 0-.9-.13-1.17-.3a1.7 1.7 0 01-.57-.67A2.57 2.57 0 018 11.5v-.01a.5.5 0 00-.5-.5H4V7c0-1.1.9-2 2-2h2.02c.03-.34.1-.68.19-1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V9.74c-.3.26-.64.48-1 .66zm-2.5-.4a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2.35-4.15a.5.5 0 01.7-.7L13 6.29V3.5a.5.5 0 011 0v2.8l1.15-1.15a.5.5 0 01.7.7l-2 2a.5.5 0 01-.35.15.5.5 0 01-.35-.14l-2-2z",
    fill: primaryFill
  }));
};

export const MailInboxArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxArrowDownFilledIcon({}), 'MailInboxArrowDownFilled');

const MailInboxArrowDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.02 5H6a2 2 0 00-2 2v4h3.5c.28 0 .5.22.5.5v.01a1.68 1.68 0 00.03.3c.04.2.1.46.23.72.13.25.3.49.57.66.26.18.63.31 1.17.31.54 0 .9-.13 1.17-.3.26-.18.44-.42.57-.67A2.42 2.42 0 0012 11.5v-.01c0-.28.22-.5.5-.5H16v-.6c.36-.18.7-.4 1-.66V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h2.2c-.08.32-.15.66-.18 1zm-.97 7H4v3c0 1.1.9 2 2 2h8a2 2 0 002-2v-3h-3.05c-.05.26-.14.62-.32.97a2.7 2.7 0 01-.9 1.06c-.45.29-1.02.47-1.73.47s-1.28-.18-1.72-.47a2.7 2.7 0 01-.91-1.06c-.18-.35-.27-.7-.32-.97zm6.45-2a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2.35-4.15a.5.5 0 01.7-.7L13 6.29V3.5a.5.5 0 011 0v2.8l1.15-1.15a.5.5 0 01.7.7l-2 2a.5.5 0 01-.35.15.5.5 0 01-.35-.14l-2-2z",
    fill: primaryFill
  }));
};

export const MailInboxArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxArrowDownRegularIcon({}), 'MailInboxArrowDownRegular');

const MailInboxArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 11v-.6c.36-.18.7-.4 1-.66V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h2.2c-.08.32-.15.66-.18 1H6a2 2 0 00-2 2v4h3.5c.28 0 .5.22.5.5v.01a1.64 1.64 0 00.03.3c.04.2.1.46.23.72.13.25.3.49.57.66.26.18.63.31 1.17.31.54 0 .9-.13 1.17-.3.26-.18.44-.42.57-.67A2.57 2.57 0 0012 11.5v-.01c0-.28.22-.5.5-.5H16zm2-5.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-4.15 2.35a.5.5 0 01-.7-.7L14.29 6H11.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const MailInboxArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxArrowRightFilledIcon({}), 'MailInboxArrowRightFilled');

const MailInboxArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85A.5.5 0 0016 5.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L14.29 5H11.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2zM8.02 5H6a2 2 0 00-2 2v4h3.5c.28 0 .5.22.5.5v.01a1.64 1.64 0 00.03.3c.04.2.1.46.23.72.13.25.3.49.57.66.26.18.63.31 1.17.31.54 0 .9-.13 1.17-.3.26-.18.44-.42.57-.67A2.57 2.57 0 0012 11.5v-.01c0-.28.22-.5.5-.5H16v-.6c.36-.18.7-.4 1-.66V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h2.2c-.08.32-.15.66-.18 1zm-.97 7H4v3c0 1.1.9 2 2 2h8a2 2 0 002-2v-3h-3.05c-.05.26-.14.62-.32.97a2.7 2.7 0 01-.9 1.06c-.45.29-1.02.47-1.73.47s-1.28-.18-1.72-.47a2.7 2.7 0 01-.91-1.06c-.18-.35-.27-.7-.32-.97z",
    fill: primaryFill
  }));
};

export const MailInboxArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxArrowRightRegularIcon({}), 'MailInboxArrowRightRegular');

const MailInboxArrowUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.15-2.35A.5.5 0 0013.5 3a.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L13 4.71V7.5a.5.5 0 101 0V4.7l1.15 1.15a.5.5 0 10.7-.7l-2-2zM16 10.4v.6h-3.5a.5.5 0 00-.5.5v.01a1.75 1.75 0 01-.03.3c-.04.2-.1.46-.23.72-.13.25-.3.49-.57.66-.26.18-.63.31-1.17.31-.54 0-.9-.13-1.17-.3a1.7 1.7 0 01-.57-.67A2.57 2.57 0 018 11.5v-.01a.5.5 0 00-.5-.5H4V7c0-1.1.9-2 2-2h2.02c.03-.34.1-.68.19-1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V9.74c-.3.26-.64.48-1 .66z",
    fill: primaryFill
  }));
};

export const MailInboxArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxArrowUpFilledIcon({}), 'MailInboxArrowUpFilled');

const MailInboxArrowUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.15-2.35A.5.5 0 0013.5 3a.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L13 4.71V7.5a.5.5 0 101 0V4.7l1.15 1.15a.5.5 0 00.7-.7l-2-2zM8.02 5H6a2 2 0 00-2 2v4h3.5c.28 0 .5.22.5.5v.01a1.68 1.68 0 00.03.3c.04.2.1.46.23.72.13.25.3.49.57.66.26.18.63.31 1.17.31.54 0 .9-.13 1.17-.3.26-.18.44-.42.57-.67A2.42 2.42 0 0012 11.5v-.01c0-.28.22-.5.5-.5H16v-.6c.36-.18.7-.4 1-.66V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h2.2c-.08.32-.15.66-.18 1zm-.97 7H4v3c0 1.1.9 2 2 2h8a2 2 0 002-2v-3h-3.05c-.05.26-.14.62-.32.97a2.7 2.7 0 01-.9 1.06c-.45.29-1.02.47-1.73.47s-1.28-.18-1.72-.47a2.7 2.7 0 01-.91-1.06c-.18-.35-.27-.7-.32-.97z",
    fill: primaryFill
  }));
};

export const MailInboxArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxArrowUpRegularIcon({}), 'MailInboxArrowUpRegular');

const MailInboxCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.85-1.85L12.5 6.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 00-.7-.7zM16 10.4v.6h-3.5a.5.5 0 00-.5.5v.01a1.75 1.75 0 01-.03.3c-.04.2-.1.46-.23.72-.13.25-.3.49-.57.66-.26.18-.63.31-1.17.31-.54 0-.9-.13-1.17-.3a1.7 1.7 0 01-.57-.67A2.57 2.57 0 018 11.5v-.01a.5.5 0 00-.5-.5H4V7c0-1.1.9-2 2-2h2.02c.03-.34.1-.68.19-1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V9.74c-.3.26-.64.48-1 .66z",
    fill: primaryFill
  }));
};

export const MailInboxCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxCheckmarkFilledIcon({}), 'MailInboxCheckmarkFilled');

const MailInboxCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.85-1.85L12.5 6.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 00-.7-.7zM8.02 5H6a2 2 0 00-2 2v4h3.5c.28 0 .5.22.5.5v.01a1.64 1.64 0 00.03.3c.04.2.1.46.23.72.13.25.3.49.57.66.26.18.63.31 1.17.31.54 0 .9-.13 1.17-.3.26-.18.44-.42.57-.67A2.57 2.57 0 0012 11.5v-.01c0-.28.22-.5.5-.5H16v-.6c.36-.18.7-.4 1-.66V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h2.2c-.08.32-.15.66-.18 1zm-.97 7H4v3c0 1.1.9 2 2 2h8a2 2 0 002-2v-3h-3.05c-.05.26-.14.62-.32.97a2.7 2.7 0 01-.9 1.06c-.45.29-1.02.47-1.73.47s-1.28-.18-1.72-.47a2.7 2.7 0 01-.91-1.06c-.18-.35-.27-.7-.32-.97z",
    fill: primaryFill
  }));
};

export const MailInboxCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxCheckmarkRegularIcon({}), 'MailInboxCheckmarkRegular');

const MailInboxDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L13.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L14.21 5.5l1.14-1.15zM16 11v-.6c.36-.18.7-.4 1-.66V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h2.2c-.08.32-.15.66-.18 1H6a2 2 0 00-2 2v4h3.5c.28 0 .5.22.5.5v.01a1.64 1.64 0 00.03.3c.04.2.1.46.23.72.13.25.3.49.57.66.26.18.63.31 1.17.31.54 0 .9-.13 1.17-.3.26-.18.44-.42.57-.67A2.57 2.57 0 0012 11.5v-.01c0-.28.22-.5.5-.5H16z",
    fill: primaryFill
  }));
};

export const MailInboxDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxDismissFilledIcon({}), 'MailInboxDismissFilled');

const MailInboxDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L13.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L14.21 5.5l1.14-1.15zM6 5h2.02c.03-.34.1-.68.19-1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V9.74c-.3.26-.64.48-1 .66v.6h-3.5a.5.5 0 00-.5.5v.01a1.75 1.75 0 01-.03.3c-.04.2-.1.46-.23.72-.13.25-.3.49-.57.66-.26.18-.63.31-1.17.31-.54 0-.9-.13-1.17-.3a1.7 1.7 0 01-.57-.67A2.57 2.57 0 018 11.5v-.01a.5.5 0 00-.5-.5H4V7c0-1.1.9-2 2-2zm-2 7h3.05c.05.26.14.62.32.97.18.38.47.76.9 1.06.45.29 1.02.47 1.73.47s1.28-.18 1.72-.47c.44-.3.73-.68.91-1.06.18-.35.27-.7.32-.97H16v3a2 2 0 01-2 2H6a2 2 0 01-2-2v-3z",
    fill: primaryFill
  }));
};

export const MailInboxDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailInboxDismissRegularIcon({}), 'MailInboxDismissRegular');

const MailLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 3a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zM16 3a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm-3 0c0-.54.12-1.05.34-1.5H4.5a2.5 2.5 0 00-2.48 2.22l7.98 4.7L13.26 9h-.76A3.5 3.5 0 019 5.5zM16.5 9h-1.27l-4.98 2.93a.5.5 0 01-.5 0L2 7.37v7.13A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5V8.66c-.45.22-.96.34-1.5.34z",
    fill: primaryFill
  }));
};

export const MailLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailLinkFilledIcon({}), 'MailLinkFilled');

const MailLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 3a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zM16 3a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm-2 5.42L13.26 9h1.97l-4.98 2.93a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V8.96c.35-.05.69-.15 1-.3v5.84a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.84c-.15.31-.25.65-.3 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12z",
    fill: primaryFill
  }));
};

export const MailLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailLinkRegularIcon({}), 'MailLinkRegular');

const MailListFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.93 8h.57c.18 0 .34-.03.5-.09v6.59a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0L16.93 8zM11.1 4a1.5 1.5 0 00.3 1.5A1.5 1.5 0 0012.5 8h2.45L10 10.92l-7.98-4.7A2.5 2.5 0 014.5 4h6.59zm1.41-2a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 2a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 2a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const MailListFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailListFilledIcon({}), 'MailListFilled');

const MailListRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.09 4H4.5A2.5 2.5 0 002 6.5v8A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5V7.91a1.5 1.5 0 01-.5.09H17v6.5c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 14.5V7.96l6.75 3.97.08.04c.14.05.3.04.42-.04L16.93 8h-1.97L10 10.92 3 6.8v-.3C3 5.67 3.67 5 4.5 5h6.59a1.5 1.5 0 010-1zm1.41-2a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 2a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 2a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const MailListRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailListRegularIcon({}), 'MailListRegular');

const MailMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 12.5V6.37L9.25 9.93a.5.5 0 01-.5 0L2 6.37v6.13A2.5 2.5 0 004.5 15h9a2.5 2.5 0 002.5-2.5zm-.02-7.28A2.5 2.5 0 0013.5 3h-9a2.5 2.5 0 00-2.48 2.22L9 8.92l6.98-3.7zM6.5 17a2.5 2.5 0 01-2-1h9a3.5 3.5 0 003.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 01-4.5 4.5h-7z",
    fill: primaryFill
  }));
};

export const MailMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailMultipleFilledIcon({}), 'MailMultipleFilled');

const MailMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 5.5A2.5 2.5 0 0013.5 3h-9A2.5 2.5 0 002 5.5v7A2.5 2.5 0 004.5 15h9a2.5 2.5 0 002.5-2.5v-7zM9.25 9.93L15 6.96v5.54c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 013 12.5V6.96l5.75 2.97.08.04c.14.05.3.04.42-.04zM4.5 4h9c.83 0 1.5.67 1.5 1.5v.3L9 8.92 3 5.8v-.3C3 4.67 3.67 4 4.5 4zm2 13a2.5 2.5 0 01-2-1h9a3.5 3.5 0 003.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 01-4.5 4.5h-7z",
    fill: primaryFill
  }));
};

export const MailMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailMultipleRegularIcon({}), 'MailMultipleRegular');

const MailOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.5 4.21a2.5 2.5 0 00-1.48 2.01l7.98 4.7.13-.08.73.73-.6.36a.5.5 0 01-.51 0L2 7.37v7.13A2.5 2.5 0 004.5 17h11c.24 0 .47-.03.7-.1l.95.95a.5.5 0 00.7-.7l-15-15zm9.8 8.37l5.09 5.1c.17-.34.26-.72.26-1.12V7.37l-5.35 3.15zM6.12 4l5.8 5.8 6.06-3.58A2.5 2.5 0 0015.5 4H6.12z",
    fill: primaryFill
  }));
};

export const MailOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailOffFilledIcon({}), 'MailOffFilled');

const MailOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.5 4.21A2.5 2.5 0 002 6.5v8A2.5 2.5 0 004.5 17h11c.24 0 .47-.03.7-.1l.95.95a.5.5 0 00.7-.7l-15-15zM15.3 16H4.5A1.5 1.5 0 013 14.5V7.96l6.75 3.97.08.04c.14.05.3.04.42-.04l.61-.36L15.3 16zm-5.16-5.16l-.13.08L3 6.8v-.3c0-.76.57-1.4 1.3-1.49l5.83 5.83zM17 6.8l-5.09 3 .73.72L17 7.96v6.54c0 .12-.01.23-.04.34l.78.78c.17-.34.26-.72.26-1.12v-8A2.5 2.5 0 0015.5 4H6.12l1 1h8.38c.83 0 1.5.67 1.5 1.5v.3z",
    fill: primaryFill
  }));
};

export const MailOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailOffRegularIcon({}), 'MailOffRegular');

const MailOpenPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.74 2.07a.5.5 0 01.52 0l6.77 4.06a2 2 0 01.7.71L10 10.94l-7.73-4.1a2 2 0 01.7-.7l6.77-4.07zm3.14 8.47l-2.65 1.4a.5.5 0 01-.46 0L2 7.83v5.67A2.5 2.5 0 004.5 16h6.55a2.5 2.5 0 012.22-1.99 2.99 2.99 0 01-.4-3.47zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const MailOpenPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailOpenPersonFilledIcon({}), 'MailOpenPersonFilled');

const MailOpenPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3.08L3.49 7 3.47 7 10 10.92 16.53 7 10 3.08zM9.98 12a.5.5 0 01-.24-.07L3 7.88v5.62c0 .83.67 1.5 1.5 1.5h7c-.22.3-.38.63-.45 1H4.5A2.5 2.5 0 012 13.5V7.85a2 2 0 01.97-1.72l6.76-4.05a.5.5 0 01.53 0l6.93 4.15a.9.9 0 010 1.54l-2.1 1.26a3 3 0 00-2.02 1.21l-2.81 1.69a.5.5 0 01-.28.07zm7.52 0a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const MailOpenPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailOpenPersonRegularIcon({}), 'MailOpenPersonRegular');

const MailPauseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 11c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4zm10 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1-6.5v4a.5.5 0 01-1 0v-4a.5.5 0 011 0zm3 0v4a.5.5 0 01-1 0v-4a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const MailPauseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailPauseFilledIcon({}), 'MailPauseFilled');

const MailPauseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5zM14.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1-6.5v4a.5.5 0 01-1 0v-4a.5.5 0 011 0zm3 0v4a.5.5 0 01-1 0v-4a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const MailPauseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailPauseRegularIcon({}), 'MailPauseRegular');

const MailProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zM14.5 9c-.79 0-1.51-.26-2.1-.7l4.9-4.9A3.5 3.5 0 0114.5 9zm0 2c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4z",
    fill: primaryFill
  }));
};

export const MailProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailProhibitedFilledIcon({}), 'MailProhibitedFilled');

const MailProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zM14.5 9c-.79 0-1.51-.26-2.1-.7l4.9-4.9A3.5 3.5 0 0114.5 9zm2.5 5.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5z",
    fill: primaryFill
  }));
};

export const MailProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailProhibitedRegularIcon({}), 'MailProhibitedRegular');

const MailReadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.26 3.07a.5.5 0 00-.52 0L2.97 7.13a2 2 0 00-.7.71l7.73 4.1 7.73-4.1a2 2 0 00-.7-.7l-6.77-4.07zM18 8.83l-7.77 4.11a.5.5 0 01-.46 0L2 8.84v5.66A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5V8.85v-.02z",
    fill: primaryFill
  }));
};

export const MailReadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailReadFilledIcon({}), 'MailReadFilled');

const MailReadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.74 3.07a.5.5 0 01.52 0l6.77 4.06A2 2 0 0118 8.85v5.65a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V8.85a2 2 0 01.97-1.72l.21.36-.2-.36 6.76-4.06zM10 4.08L3.49 8 3.47 8 10 11.92 16.53 8h-.02L10 4.07zm7 4.8l-6.74 4.05a.5.5 0 01-.52 0L3 8.88v5.62c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V8.88z",
    fill: primaryFill
  }));
};

export const MailReadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailReadRegularIcon({}), 'MailReadRegular');

const MailSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 11c1.33 0 2.55-.47 3.5-1.26v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.23-1.31c.63.24 1.3.38 2.02.38zm-10-7h4.7a5.5 5.5 0 002.24 6.07l-1.44.85-7.98-4.7A2.5 2.5 0 014.5 4zm6.14.92a2 2 0 001.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.71 4.71 0 010-1.01l.46-.12zm4.86.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const MailSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailSettingsFilledIcon({}), 'MailSettingsFilled');

const MailSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5zm-6.36-9.58a2 2 0 001.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.71 4.71 0 010-1.01l.46-.12zm4.86.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const MailSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailSettingsRegularIcon({}), 'MailSettingsRegular');

const MailShieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 2.62a4.06 4.06 0 01-1-.27 5.16 5.16 0 01-1.72-1.23.39.39 0 00-.56 0 4.5 4.5 0 01-3.32 1.55.4.4 0 00-.4.41v2.77A5.5 5.5 0 0012.01 9c.27.37.6.7.99 1 .52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V3a.4.4 0 00-.4-.33c-.2 0-.4-.02-.6-.05zm-5.7 8.1l.1.07c.61.48 1.34.85 2.15 1.13.29.1.61.1.9 0A7.36 7.36 0 0018 10.47v4.03a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5V7.37l7.75 4.56c.15.1.35.1.5 0l2.05-1.2zM10 4V5.88a6.49 6.49 0 001.54 4.13l-1.54.91-7.98-4.7A2.5 2.5 0 014.5 4H10z",
    fill: primaryFill
  }));
};

export const MailShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailShieldFilledIcon({}), 'MailShieldFilled');

const MailShieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 2.62a4.06 4.06 0 01-1-.27 5.16 5.16 0 01-1.72-1.23.39.39 0 00-.56 0 4.5 4.5 0 01-3.32 1.55.4.4 0 00-.4.41v2.77A5.5 5.5 0 0012.01 9c.27.37.6.7.99 1 .52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V3a.4.4 0 00-.4-.33c-.2 0-.4-.02-.6-.05zM10 4H4.5A2.5 2.5 0 002 6.5v8A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5v-4.03c-.3.27-.64.52-1 .74v3.29c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 14.5V7.96l6.75 3.97.08.04c.14.05.3.04.42-.04l2.05-1.2a6.05 6.05 0 01-.76-.72l-1.54.91L3 6.8v-.3C3 5.67 3.67 5 4.5 5H10V4z",
    fill: primaryFill
  }));
};

export const MailShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailShieldRegularIcon({}), 'MailShieldRegular');

const MailTemplateFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v9A2.5 2.5 0 004.5 16h1.54a3.53 3.53 0 01-.04-.5v-4A3.5 3.5 0 019.5 8h6c.17 0 .34.01.5.04V4.5A2.5 2.5 0 0013.5 2h-9zM5 4.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm2 2c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm5.5 7.2l-5.3-3.17A2.5 2.5 0 019.5 9h6a2.5 2.5 0 012.3 1.53l-5.3 3.17zm.26 1L18 11.59v3.92a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 017 15.5v-3.92l5.24 3.13c.16.1.36.1.52 0z",
    fill: primaryFill
  }));
};

export const MailTemplateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailTemplateFilledIcon({}), 'MailTemplateFilled');

const MailTemplateRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 014.5 2h9A2.5 2.5 0 0116 4.5v3.54a3.53 3.53 0 00-.5-.04H15V4.5c0-.83-.67-1.5-1.5-1.5h-9C3.67 3 3 3.67 3 4.5v9c0 .83.67 1.5 1.5 1.5H6v.5c0 .17.01.34.04.5H4.5A2.5 2.5 0 012 13.5v-9zm11 3a.5.5 0 01-.5.5h-5a.5.5 0 010-1h5c.28 0 .5.22.5.5zm-8-2c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm2 6A2.5 2.5 0 019.5 9h6a2.5 2.5 0 012.5 2.5v4a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 017 15.5v-4zM9.5 10a1.5 1.5 0 00-1.48 1.23l4.48 2.69 4.48-2.69A1.5 1.5 0 0015.5 10h-6zM8 15.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-3.12l-4.24 2.55a.5.5 0 01-.52 0L8 12.38v3.12z",
    fill: primaryFill
  }));
};

export const MailTemplateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailTemplateRegularIcon({}), 'MailTemplateRegular');

const MailUnreadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.32 9h.36l.24-.03H17v3.83c0 1.1-.12 1.51-.33 1.92-.22.4-.54.73-.95.95-.4.21-.81.33-1.92.33H5.2c-1.1 0-1.51-.12-1.92-.33-.4-.22-.73-.54-.95-.95-.2-.38-.31-.76-.33-1.71V7.3l7.28 3.64c.14.07.3.07.44 0l4.94-2.47c.33.2.7.36 1.1.44l.24.04.13.02.2.02zM5 4h8.35l-.05.11-.07.17-.1.3-.05.22-.02.1-.01.1a3.54 3.54 0 00.66 2.6l.14.17L9.5 9.94 2.22 6.3a.5.5 0 00-.18-.05c.06-.45.15-.7.3-.97.21-.4.53-.73.94-.95.38-.2.76-.31 1.71-.33zM16.5 3a2.5 2.5 0 110 5 2.5 2.5 0 010-5z",
    fill: primaryFill
  }));
};

export const MailUnreadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailUnreadFilledIcon({}), 'MailUnreadFilled');

const MailUnreadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.34 4c-.15.31-.25.65-.3 1H5.02c-.72 0-1 .07-1.27.22-.23.12-.41.3-.53.53-.13.23-.19.46-.21.94L9.5 9.94l4.34-2.17c.23.28.51.52.82.7l-4.94 2.48a.5.5 0 01-.36.03l-.08-.03L3 7.8v5.17c0 .72.07 1 .22 1.27.12.23.3.41.53.53.25.14.5.2 1.1.22H14.15c.59-.02.84-.08 1.09-.22.23-.12.41-.3.53-.53.14-.25.2-.5.22-1.1V8.97a3.53 3.53 0 001 0v3.84c0 1.1-.12 1.51-.33 1.92-.22.4-.54.73-.95.95-.4.21-.81.33-1.92.33H5.2c-1.11 0-1.51-.12-1.92-.33-.4-.22-.73-.54-.95-.95-.2-.38-.31-.76-.33-1.71V7.2c0-1.12.12-1.52.33-1.93.22-.4.54-.73.95-.95.38-.2.76-.31 1.71-.33h8.35zm3.16-1a2.5 2.5 0 110 5 2.5 2.5 0 010-5z",
    fill: primaryFill
  }));
};

export const MailUnreadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailUnreadRegularIcon({}), 'MailUnreadRegular');

const MailWarningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.6 1.55l-3.5 7A1 1 0 0011 10h7a1 1 0 00.9-1.45l-3.5-7a1 1 0 00-1.8 0zM15 3.5v3a.5.5 0 11-1 0v-3a.5.5 0 111 0zM14.5 9a.5.5 0 110-1 .5.5 0 010 1zm3.5 2h-6.16l-1.59.93a.5.5 0 01-.5 0L2 7.37v7.13A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5V11zM9.22 8.1L11.27 4H4.5a2.5 2.5 0 00-2.48 2.22l7.98 4.7.17-.1a2 2 0 01-.95-2.72z",
    fill: primaryFill
  }));
};

export const MailWarningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailWarningFilledIcon({}), 'MailWarningFilled');

const MailWarningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.6 1.55l-3.5 7A1 1 0 0011 10h7a1 1 0 00.9-1.45l-3.5-7a1 1 0 00-1.8 0zM15 3.5v3a.5.5 0 11-1 0v-3a.5.5 0 111 0zM14.5 9a.5.5 0 110-1 .5.5 0 010 1zm-10-5h6.77l-.5 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12.17-.1a2 2 0 00.84.18h.83l-1.59.93a.5.5 0 01-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V11h1v3.5a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-8A2.5 2.5 0 014.5 4z",
    fill: primaryFill
  }));
};

export const MailWarningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MailWarningRegularIcon({}), 'MailWarningRegular');

const MapFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 16.8l-4-2.23V3.24l4 2.8V16.8zm1-.02l4.76-2.85a.5.5 0 00.24-.43v-10a.5.5 0 00-.79-.41L13 6.04v10.74zM2.22 6.59L7 3.24v11.33l-4.26 2.37A.5.5 0 012 16.5V7a.5.5 0 01.21-.41z",
    fill: primaryFill
  }));
};

export const MapFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MapFilledIcon({}), 'MapFilled');

const MapRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.73 3.06a.5.5 0 01.27.44v10a.5.5 0 01-.24.43l-5 3a.5.5 0 01-.5 0l-4.51-2.5a.46.46 0 00-.5 0l-4.5 2.5A.5.5 0 012 16.5V7a.5.5 0 01.21-.41l5-3.5a.5.5 0 01.58 0l4.71 3.3 4.71-3.3a.5.5 0 01.52-.03zM3 7.26v8.39l3.75-2.08c.08-.05.16-.1.25-.12V4.46l-4 2.8zm5.25 6.3l3.75 2.1v-8.4l-4-2.8v8.99c.08.03.17.07.25.12zM13 15.62l4-2.4V4.47l-4 2.8v8.35z",
    fill: primaryFill
  }));
};

export const MapRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MapRegularIcon({}), 'MapRegular');

const MapDriveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5c0-1.1.9-2 2-2h12a2 2 0 012 2v3.5a.5.5 0 01-.5.5h-7v2h1c.28 0 .5.22.5.5V13h1.5c.27 0 .5.22.5.5v1h3.5a.5.5 0 010 1H14v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1H2.5a.5.5 0 010-1H6v-1c0-.28.23-.5.5-.5H8v-1.5a.5.5 0 01.5-.5h1V9h-7a.5.5 0 01-.5-.5V5zm12.75 1.74a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const MapDriveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MapDriveFilledIcon({}), 'MapDriveFilled');

const MapDriveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.75 6.74a.75.75 0 100-1.5.75.75 0 000 1.5zM2 5c0-1.1.9-2 2-2h12a2 2 0 012 2v3.5a.5.5 0 01-.5.5h-7v2h1c.28 0 .5.22.5.5V13h1.5c.27 0 .5.22.5.5v1h3.5a.5.5 0 010 1H14v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1H2.5a.5.5 0 010-1H6v-1c0-.28.23-.5.5-.5H8v-1.5a.5.5 0 01.5-.5h1V9h-7a.5.5 0 01-.5-.5V5zm2-1a1 1 0 00-1 1v3h14V5a1 1 0 00-1-1H4zm7.47 12H13v-2h-1.5a.5.5 0 01-.5-.5V12H9v1.5a.5.5 0 01-.5.5H7v2h4.47z",
    fill: primaryFill
  }));
};

export const MapDriveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MapDriveRegularIcon({}), 'MapDriveRegular');

const MatchAppLayoutFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 7C2.67 7 2 7.67 2 8.5v3c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-3C9 7.67 8.33 7 7.5 7h-4zm9 0c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-4z",
    fill: primaryFill
  }));
};

export const MatchAppLayoutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MatchAppLayoutFilledIcon({}), 'MatchAppLayoutFilled');

const MatchAppLayoutRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 7C2.67 7 2 7.67 2 8.5v3c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-3C9 7.67 8.33 7 7.5 7h-4zM3 8.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-3zM12.5 7c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-4zM12 8.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-3z",
    fill: primaryFill
  }));
};

export const MatchAppLayoutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MatchAppLayoutRegularIcon({}), 'MatchAppLayoutRegular');

const MathFormatLinearFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.01 3.18c.28-.24.7-.24.98 0l1.75 1.5a.75.75 0 11-.98 1.14L9.5 4.74 8.24 5.82a.75.75 0 01-.98-1.14l1.75-1.5zm2.3 5.7c.36-.4.54-.38.56-.38.05 0 .15.05.26.2l1.32 2.05-3.21 2.98a.75.75 0 101.02 1.1l3-2.8 1.36 2.1v.02a1.92 1.92 0 003.27.01.75.75 0 10-1.28-.77.42.42 0 01-.51.14.59.59 0 01-.22-.21L15.38 11l2.88-2.67a.75.75 0 00-1.02-1.1L14.56 9.7l-1.18-1.84A1.93 1.93 0 0012.02 7c-.67-.07-1.3.27-1.84.9a.75.75 0 101.14.98zM7.68 7.86a2.11 2.11 0 00-1.52-.83c-.6-.07-1.26.03-1.92.3-1.33.56-2.6 1.86-3.12 4.08-.23.97-.1 1.84.35 2.54A3.32 3.32 0 003.3 15.3a4.5 4.5 0 004.47-1.09.75.75 0 10-1.07-1.04 3 3 0 01-2.95.7c-.47-.15-.82-.4-1.02-.73a1.5 1.5 0 01-.23-.7c2.13.26 3.63-.3 4.54-1.22.5-.52.8-1.12.91-1.7.1-.57.04-1.2-.28-1.67zm-1.7 2.31c-.49.5-1.46.99-3.17.8a3.77 3.77 0 012-2.26c.45-.18.86-.23 1.17-.19.32.04.44.16.46.18.04.06.1.25.05.55-.06.29-.21.62-.5.92z",
    fill: primaryFill
  }));
};

export const MathFormatLinearFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MathFormatLinearFilledIcon({}), 'MathFormatLinearFilled');

const MathFormatLinearRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.36 3.65a.5.5 0 00-.71 0l-1.5 1.5a.5.5 0 00.7.7L9 4.72l1.15 1.15a.5.5 0 10.7-.71l-1.5-1.5zM7.74 7.78a1.79 1.79 0 00-1.27-.75 3.26 3.26 0 00-1.74.24c-1.24.52-2.45 1.78-3.06 4.06a3.7 3.7 0 00.14 2.6c.35.72.96 1.2 1.67 1.42 1.42.45 3.21-.12 4.42-1.73a.5.5 0 00-.8-.6c-1 1.33-2.37 1.68-3.32 1.38a1.74 1.74 0 01-1.07-.9 2.48 2.48 0 01-.16-1.51c2.16.12 3.64-.47 4.51-1.32.9-.87 1.18-2.1.68-2.89zM6.36 9.95c-.6.59-1.71 1.1-3.55 1.05.58-1.64 1.5-2.47 2.3-2.8.46-.2.88-.23 1.2-.18.34.05.52.19.58.29.16.26.17.96-.53 1.64zm11.5-2.8c.19.2.19.5 0 .7l-3.09 3.08 1.64 2.76c.07.1.25.25.47.3.17.03.42.02.74-.35a.5.5 0 11.76.66c-.53.6-1.15.78-1.7.67-.51-.1-.9-.44-1.1-.72-.12-.18-.8-1.34-1.54-2.59l-3.19 3.2a.5.5 0 01-.7-.71l3.37-3.38a981.7 981.7 0 01-1.46-2.5.59.59 0 00-.41-.27c-.15-.01-.42.02-.75.47a.5.5 0 01-.8-.59c.49-.67 1.08-.94 1.66-.87.54.06.96.4 1.16.75l1.33 2.28 2.9-2.9c.2-.19.5-.19.7 0z",
    fill: primaryFill
  }));
};

export const MathFormatLinearRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MathFormatLinearRegularIcon({}), 'MathFormatLinearRegular');

const MathFormatProfessionalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.25 3.6c.44-.33 1-.65 1.65-.65l.12.01c.43.07.77.23 1.06.5.25.23.44.52.62.78l1.07-1.07a.75.75 0 111.06 1.06L14.5 5.57l.38.7c.08.16.18.24.38.3h.19l.1-.07a5 5 0 00.23-.23.75.75 0 011.06 1.06l-.03.03c-.17.17-.4.4-.69.55a1.78 1.78 0 01-1.2.12 2.02 2.02 0 01-1.38-1.1l-.14-.26-1.06 1.06a.75.75 0 11-1.06-1.06l1.35-1.35a3.01 3.01 0 00-.14-.2 3.34 3.34 0 00-.42-.56.42.42 0 00-.22-.1c-.15.01-.37.1-.7.34a.75.75 0 11-.9-1.2zM5.4 16.3H6c1.4-.1 2.8-.7 3.9-2 .3-.4.2-.8-.1-1.1-.3-.2-.8-.2-1.2.1-.9.7-1.9 1.4-3.1 1.4-.6 0-1.2-.5-1.3-1.1-.1-.5 0-1.1.2-1.6 1.6.1 3.8-.1 4.8-1.3.8-.9 1-2.4 0-3.3-.4-.4-.9-.5-1.4-.5-.9 0-1.8.5-2.6 1.3-1.3 1.3-2.6 3.5-2.4 5.6.1 1.5 1.4 2.4 2.6 2.5zm.8-7.1c.6-.5 1.1-.8 1.6-.8.2 0 .5.1.6.3.2.3 0 .8-.2 1-.5.5-1.8.8-3 .8.3-.5.6-.9 1-1.3z",
    fill: primaryFill
  }));
};

export const MathFormatProfessionalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MathFormatProfessionalFilledIcon({}), 'MathFormatProfessionalFilled');

const MathFormatProfessionalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.85 4.35c.2-.19.25-.24.35-.3a.9.9 0 01.92.17c.07.04.13.1.2.21l.1.17.01.03.14.22.3.54v.03l-1.72 1.73a.5.5 0 00.7.7l1.56-1.55.17.28.18.29.11.18c.1.16.23.36.38.5a1.6 1.6 0 002 .28c.26-.13.4-.28.59-.46l.01-.02a.5.5 0 10-.7-.7 1.28 1.28 0 01-.43.33c-.13.1-.46.17-.77-.13a8.08 8.08 0 01-.81-1.28l1.71-1.72a.5.5 0 00-.7-.7L13.6 4.68a7.66 7.66 0 01-.2-.36 3.42 3.42 0 01-.11-.2l-.02-.02a5.28 5.28 0 00-.12-.2c-.1-.17-.25-.36-.47-.5a1.9 1.9 0 00-1.91-.25c-.28.14-.43.29-.62.48l-.01.02a.5.5 0 00.7.7zM8.31 7c.46 0 .88.23 1.18.54.3.32.5.75.5 1.24.07.77-.2 1.4-.67 1.86-.45.46-1.07.76-1.7.96-1.17.37-2.52.44-3.42.41a3.54 3.54 0 00-.2 1.6 1.46 1.46 0 00.52.94c.27.27.6.35 1.1.46 1.34.16 2.64-.61 3.46-1.72a.5.5 0 01.8.59c-.95 1.3-2.6 2.35-4.4 2.12a.5.5 0 01-.04-.01H5.4c-.46-.1-1.08-.23-1.58-.73-.42-.38-.7-.87-.8-1.49a4.56 4.56 0 01.25-2.13l.13-.35a.5.5 0 01.02-.04v-.02c.07-.2.44-1.23 1.2-2.23.75-1 1.96-2.05 3.69-2zm-3.72 4.02c.8 0 1.84-.1 2.72-.37.55-.18 1-.41 1.3-.71A1.32 1.32 0 009 8.8c0-.2-.1-.41-.24-.57A.67.67 0 008.3 8h-.02c-1.26-.04-2.2.71-2.87 1.6-.38.5-.65 1.04-.82 1.42z",
    fill: primaryFill
  }));
};

export const MathFormatProfessionalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MathFormatProfessionalRegularIcon({}), 'MathFormatProfessionalRegular');

const MathFormulaFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.91 3.54c.3-.04.48-.03.62 0 .14.02.28.08.48.2a.75.75 0 10.78-1.28c-.3-.18-.6-.32-.97-.4a3.3 3.3 0 00-1.13 0h-.01c-.8.13-1.43.55-1.86 1.16a4.23 4.23 0 00-.67 2.18v.03a8.55 8.55 0 01-.02.36c0 .22-.02.52-.04.87v.09H4.8a.75.75 0 000 1.5H6a865.92 865.92 0 01-.35 5.49c-.1 1.28-.22 2.14-1.03 2.61-.4.23-1.01.21-1.68-.12a.75.75 0 00-.68 1.34c.93.46 2.11.65 3.11.08 1.54-.9 1.68-2.55 1.77-3.67v-.12c.07-.77.23-3.46.36-5.61h1.8a.75.75 0 000-1.5H7.58l.07-1.32c.04-.6.2-1.05.4-1.35.2-.28.47-.47.86-.54zm7.87 6.74a.75.75 0 10-1.06-1.06l-2.58 2.58a36.19 36.19 0 01-.76-1.36l-.07-.11c-.15-.25-.38-.61-.66-.87a1.6 1.6 0 00-.74-.4 1.55 1.55 0 00-1.1.18l-.03.02c-.08.06-.18.13-.28.23l-.13.15-.02.03-.17.19a.75.75 0 001.14.98l.17-.2.02-.03.07-.07.01-.01.04.03a7.8 7.8 0 01.47.66c.12.24.49.9.94 1.67l-2.82 2.83a.75.75 0 101.06 1.06l2.66-2.66a38.56 38.56 0 01.87 1.54c.13.22.35.6.64.87.18.17.42.34.73.42a1.6 1.6 0 001.06-.1c.35-.17.57-.4.8-.77a.75.75 0 00-1.28-.79.95.95 0 01-.13.18l-.03.02-.03.01-.03-.01a.39.39 0 01-.06-.05 6.01 6.01 0 01-.36-.52l-.06-.1c-.12-.23-.53-.96-1.02-1.8l2.74-2.74zm-6.18.24zm0 0z",
    fill: primaryFill
  }));
};

export const MathFormulaFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MathFormulaFilledIcon({}), 'MathFormulaFilled');

const MathFormulaRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.68 3.09c-.18-.04-.4-.04-.7 0-.52.08-.87.33-1.12.68-.26.37-.41.87-.46 1.45 0 .2-.04.87-.09 1.78H9.5a.5.5 0 010 1H7.26c-.13 2.25-.3 5.15-.36 5.94v.07c-.05.57-.11 1.25-.31 1.88-.21.67-.6 1.3-1.33 1.74-1.02.63-2.13.34-2.98-.08a.5.5 0 11.44-.9c.75.38 1.44.49 2.02.13v-.01c.47-.27.73-.68.9-1.18.16-.52.2-1.1.26-1.7v-.03c.06-.8.23-3.64.36-5.86H4.5a.5.5 0 110-1h1.81a75.96 75.96 0 00.1-1.84c.05-.7.24-1.4.63-1.96.4-.57 1-.97 1.78-1.1.4-.05.73-.05 1.05.01.33.06.6.2.89.36a.5.5 0 01-.52.86c-.22-.13-.39-.2-.56-.24zm7.17 6.06c.2.2.2.5 0 .7l-3.22 3.22a162.5 162.5 0 001.4 2.47l.04.07c.06.12.11.2.15.25.06.09.12.15.25.22.21.03.28-.01.3-.03a3.56 3.56 0 00.23-.27l.1-.13a.5.5 0 01.8.6l-.06.08c-.11.16-.28.39-.5.54-.31.22-.69.27-1.14.17a1.69 1.69 0 01-.79-.6c-.08-.1-.14-.22-.2-.33l-.05-.08-.19-.32-1.07-1.9-3.05 3.04a.5.5 0 01-.7-.7l3.24-3.25a149.94 149.94 0 00-1.47-2.57 1.14 1.14 0 00-.32-.32c-.07-.02-.12-.01-.21.04-.12.08-.25.21-.39.4a.5.5 0 11-.8-.6c.16-.2.38-.47.66-.65a1.21 1.21 0 011.16-.1c.3.16.53.4.7.63a131.74 131.74 0 011.4 2.44l3.03-3.02c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const MathFormulaRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MathFormulaRegularIcon({}), 'MathFormulaRegular');

const MathSymbolsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 5.25v2a.75.75 0 001.5 0v-2h2a.75.75 0 000-1.5h-2v-2a.75.75 0 00-1.5 0v2h-2a.75.75 0 000 1.5h2zM11 4.5c0-.41.34-.75.75-.75h5.5a.75.75 0 010 1.5h-5.5A.75.75 0 0111 4.5zm-8.78 6.78l2.22 2.22-2.22 2.22a.75.75 0 101.06 1.06l2.22-2.22 2.22 2.22a.75.75 0 001.06-1.06L6.56 13.5l2.22-2.22a.75.75 0 10-1.06-1.06L5.5 12.44l-2.22-2.22a.75.75 0 10-1.06 1.06zm9.53 1.47a.75.75 0 000 1.5h5.5a.75.75 0 000-1.5h-5.5zM15.5 11a1 1 0 11-2 0 1 1 0 012 0zm-1 6a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const MathSymbolsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MathSymbolsFilledIcon({}), 'MathSymbolsFilled');

const MathSymbolsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 5v2.5a.5.5 0 001 0V5h2.5a.5.5 0 000-1H6V1.5a.5.5 0 00-1 0V4H2.5a.5.5 0 000 1H5zm6-.5c0-.28.22-.5.5-.5h6a.5.5 0 010 1h-6a.5.5 0 01-.5-.5zM8.85 16.15L6.21 13.5l2.64-2.65a.5.5 0 00-.7-.7L5.5 12.79l-2.65-2.64a.5.5 0 00-.7.7l2.64 2.65-2.64 2.65a.5.5 0 00.7.7l2.65-2.64 2.65 2.64a.5.5 0 00.7-.7zM11.5 13a.5.5 0 000 1h6a.5.5 0 000-1h-6zm4-2a1 1 0 11-2 0 1 1 0 012 0zm-1 6a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const MathSymbolsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MathSymbolsRegularIcon({}), 'MathSymbolsRegular');

const MaximizeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.25C3 4.01 4 3 5.25 3h9.5C15.99 3 17 4 17 5.25v9.5c0 1.24-1 2.25-2.25 2.25h-9.5C4.01 17 3 16 3 14.75v-9.5zm2.25-.75a.75.75 0 00-.75.75v9.5c0 .41.34.75.75.75h9.5c.41 0 .75-.34.75-.75v-9.5a.75.75 0 00-.75-.75h-9.5z",
    fill: primaryFill
  }));
};

export const MaximizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MaximizeFilledIcon({}), 'MaximizeFilled');

const MaximizeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm2-1a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H5z",
    fill: primaryFill
  }));
};

export const MaximizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MaximizeRegularIcon({}), 'MaximizeRegular');

const MeetNowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.9 2.03a7.07 7.07 0 00-1.15.54h-.02v.01L6 3l-.28-.42a.5.5 0 00.56.84 1.87 1.87 0 01.22-.13A8.1 8.1 0 0110 2.5a8.1 8.1 0 013.5.79 3.69 3.69 0 01.22.12l.26-.39-.26.4a.5.5 0 10.56-.84L14 3l.28-.42h-.01l-.02-.01a2.83 2.83 0 00-.3-.17A9.1 9.1 0 0010 1.5a9.1 9.1 0 00-3.1.53zm-.62 1.39zm7.44 0zM6.9 17.97c.73.27 1.8.53 3.11.53a9.1 9.1 0 003.96-.9 4.63 4.63 0 00.29-.17h.02v-.01L14 17l.28.42a.5.5 0 00-.56-.84l.26.4-.26-.4a1.74 1.74 0 01-.22.13 8.1 8.1 0 01-3.5.79 8.1 8.1 0 01-3.5-.79 3.66 3.66 0 01-.22-.12.5.5 0 00-.56.83L6 17l-.28.42h.01l.02.01a2.64 2.64 0 00.3.17c.19.1.48.24.84.37zm-.61-1.39zm7.44 0zM2.5 7v6c0 1.1.9 2 2 2h6a2 2 0 002-2V7a2 2 0 00-2-2h-6a2 2 0 00-2 2zm11 4.55l2.78 2.26a.75.75 0 001.22-.59V6.78a.75.75 0 00-1.22-.59L13.5 8.45v3.1z",
    fill: primaryFill
  }));
};

export const MeetNowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MeetNowFilledIcon({}), 'MeetNowFilled');

const MeetNowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 5a2 2 0 00-2 2v6c0 1.1.9 2 2 2h6a2 2 0 002-2v-1.03l2.84 1.85a.75.75 0 001.16-.63V6.8c0-.6-.66-.95-1.16-.63L13 8.03V7a2 2 0 00-2-2H5zm8 4.22l3-1.95v5.46l-3-1.95V9.22zM12 7v6a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h6a1 1 0 011 1zM6.9 2.03a7.07 7.07 0 00-1.15.54h-.02v.01L6 3l-.28-.42a.5.5 0 00.56.84 1.87 1.87 0 01.22-.13A8.1 8.1 0 0110 2.5a8.1 8.1 0 013.5.79 3.69 3.69 0 01.22.12l.26-.39-.26.4a.5.5 0 10.56-.84L14 3l.28-.42h-.01l-.02-.01a2.83 2.83 0 00-.3-.17A9.1 9.1 0 0010 1.5a9.1 9.1 0 00-3.1.53zm-.62 1.39zm7.44 0zM6.9 17.97c.73.27 1.8.53 3.11.53a9.1 9.1 0 003.96-.9 4.63 4.63 0 00.29-.17h.02v-.01L14 17l.28.42a.5.5 0 00-.56-.84l.26.4-.26-.4a1.74 1.74 0 01-.22.13 8.1 8.1 0 01-3.5.79 8.1 8.1 0 01-3.5-.79 3.66 3.66 0 01-.22-.12.5.5 0 00-.56.83L6 17l-.28.42h.01l.02.01a2.64 2.64 0 00.3.17c.19.1.48.24.84.37zm-.61-1.39zm7.44 0z",
    fill: primaryFill
  }));
};

export const MeetNowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MeetNowRegularIcon({}), 'MeetNowRegular');

const MegaphoneFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.11 3.35A1.5 1.5 0 0118 4.8v10.31c0 1.03-1 1.75-1.97 1.43l-4.76-1.59A3.25 3.25 0 015 13.75v-.89l-1.97-.66A1.5 1.5 0 012 10.78V8.27c0-.68.46-1.28 1.11-1.45l13-3.47zM6 13.2v.56a2.25 2.25 0 004.32.88L6 13.2z",
    fill: primaryFill
  }));
};

export const MegaphoneFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MegaphoneFilledIcon({}), 'MegaphoneFilled');

const MegaphoneRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.8c0-.98-.93-1.7-1.89-1.45l-13 3.47A1.5 1.5 0 002 8.27v2.5c0 .65.41 1.23 1.03 1.43l1.97.66v.89a3.25 3.25 0 006.27 1.2l4.76 1.59A1.5 1.5 0 0018 15.1V4.81zm-7.68 9.83A2.25 2.25 0 016 13.75v-.56l4.32 1.44zm6.05-10.31a.5.5 0 01.63.48v10.31a.5.5 0 01-.66.48l-13-4.34a.5.5 0 01-.34-.47V8.27a.5.5 0 01.37-.48l13-3.47z",
    fill: primaryFill
  }));
};

export const MegaphoneRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MegaphoneRegularIcon({}), 'MegaphoneRegular');

const MegaphoneLoudFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.16 1.03c.26.08.4.37.31.63l-.5 1.5a.5.5 0 01-.94-.32l.5-1.5a.5.5 0 01.63-.31zm3.7 1.82a.5.5 0 10-.71-.7l-2 2a.5.5 0 00.7.7l2-2zm-10.25.3a2 2 0 013.26-.52l6.58 6.98a2 2 0 01-.64 3.2l-3.94 1.74a3.5 3.5 0 01-6.34 2.8l-1.2.52a1.5 1.5 0 01-1.67-.3l-1.22-1.22a1.5 1.5 0 01-.3-1.7l5.47-11.5zm-.16 13.78a2.5 2.5 0 004.5-1.97l-4.5 1.97zM17 6a.5.5 0 000 1h1.5a.5.5 0 100-1H17z",
    fill: primaryFill
  }));
};

export const MegaphoneLoudFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MegaphoneLoudFilledIcon({}), 'MegaphoneLoudFilled');

const MegaphoneLoudRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.16 1.03c.26.08.4.37.31.63l-.5 1.5a.5.5 0 01-.94-.32l.5-1.5a.5.5 0 01.63-.31zm3.7 1.82a.5.5 0 10-.71-.7l-2 2a.5.5 0 00.7.7l2-2zm-10.25.3a2 2 0 013.26-.52l6.58 6.98a2 2 0 01-.64 3.2l-3.94 1.74a3.5 3.5 0 01-6.34 2.8l-1.2.52a1.5 1.5 0 01-1.67-.3l-1.22-1.22a1.5 1.5 0 01-.3-1.7l5.47-11.5zm-.16 13.78a2.5 2.5 0 004.5-1.97l-4.5 1.97zm2.7-13.61a1 1 0 00-1.64.25l-5.46 11.5a.5.5 0 00.1.57l1.22 1.21a.5.5 0 00.55.1L16.4 11.9a1 1 0 00.33-1.6l-6.59-6.98zM17 6a.5.5 0 000 1h1.5a.5.5 0 100-1H17z",
    fill: primaryFill
  }));
};

export const MegaphoneLoudRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MegaphoneLoudRegularIcon({}), 'MegaphoneLoudRegular');

const MegaphoneOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L5.48 6.2l-2.37.63A1.5 1.5 0 002 8.27v2.5c0 .65.41 1.23 1.03 1.43l1.97.66v.89a3.25 3.25 0 006.27 1.2l4.46 1.49 1.42 1.41a.5.5 0 00.7-.7l-15-15zM6 13.19l4.32 1.44A2.25 2.25 0 016 13.75v-.56zm12 1.92c0 .23-.05.44-.14.63L7.71 5.6l8.4-2.24A1.5 1.5 0 0118 4.8v10.31z",
    fill: primaryFill
  }));
};

export const MegaphoneOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MegaphoneOffFilledIcon({}), 'MegaphoneOffFilled');

const MegaphoneOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L5.48 6.2l-2.37.63A1.5 1.5 0 002 8.27v2.5c0 .65.41 1.23 1.03 1.43l1.97.66v.89a3.25 3.25 0 006.27 1.2l4.46 1.49 1.42 1.41a.5.5 0 00.7-.7l-15-15zm11.3 12.7l-10.8-3.6a.5.5 0 01-.35-.47V8.27a.5.5 0 01.37-.48L6.3 7l7.85 7.86zm-3.83-.22A2.25 2.25 0 016 13.75v-.56l4.32 1.44zM17 4.8v10.08l.86.86c.1-.19.14-.4.14-.63V4.81c0-1-.93-1.71-1.89-1.46L7.71 5.6l.82.82 7.84-2.1a.5.5 0 01.63.5z",
    fill: primaryFill
  }));
};

export const MegaphoneOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MegaphoneOffRegularIcon({}), 'MegaphoneOffRegular');

const MentionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 1.75c4.56 0 8.25 3.7 8.25 8.25 0 2.83-1.22 4.75-3.25 4.75-1.2 0-2.12-.68-2.67-1.82a3.5 3.5 0 01-2.83 1.32c-2.3 0-3.75-1.82-3.75-4.25 0-2.46 1.41-4.25 3.75-4.25.9 0 1.66.26 2.25.72a.75.75 0 011.49-.08l.01.11V10c0 2.1.73 3.25 1.75 3.25s1.75-1.15 1.75-3.25a6.75 6.75 0 10-4.45 6.35.75.75 0 01.5 1.4A8.23 8.23 0 011.76 10c0-4.56 3.7-8.25 8.25-8.25zm-.5 5.5C8.08 7.25 7.25 8.3 7.25 10c0 1.67.87 2.75 2.25 2.75s2.25-1.08 2.25-2.75c0-1.7-.83-2.75-2.25-2.75z",
    fill: primaryFill
  }));
};

export const MentionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MentionFilledIcon({}), 'MentionFilled');

const MentionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 018 8c0 2.7-1.14 4.5-3 4.5-1.23 0-2.14-.78-2.62-2.09-.6.98-1.6 1.59-2.88 1.59C7.36 14 6 12.3 6 10c0-2.34 1.31-4 3.5-4 1.05 0 1.9.38 2.5 1.04V6.5a.5.5 0 011-.09V10c0 2.22.81 3.5 2 3.5s2-1.28 2-3.5a7 7 0 10-4.62 6.58.5.5 0 01.34.94A7.99 7.99 0 012 10a8 8 0 018-8zm-.5 5C7.92 7 7 8.17 7 10c0 1.8.97 3 2.5 3s2.5-1.2 2.5-3c0-1.83-.92-3-2.5-3z",
    fill: primaryFill
  }));
};

export const MentionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MentionRegularIcon({}), 'MentionRegular');

const MentionArrowDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM5.15 7.85A.5.5 0 005.5 8a.5.5 0 00.35-.15l2-2a.5.5 0 10-.7-.7L6 6.29V3.5a.5.5 0 00-1 0v2.8L3.85 5.14a.5.5 0 10-.7.7l2 2zm7.6-.38a3.51 3.51 0 00-1.9-.7 5.46 5.46 0 01-.6 1.5c.09-.02.17-.02.25-.02 1.42 0 2.25 1.05 2.25 2.75 0 1.67-.87 2.75-2.25 2.75S8.25 12.67 8.25 11c0-.28.02-.53.06-.77-.47.28-1 .5-1.56.63V11c0 2.43 1.46 4.25 3.75 4.25 1.2 0 2.17-.5 2.83-1.32.55 1.14 1.47 1.82 2.67 1.82 2.03 0 3.25-1.92 3.25-4.75a8.25 8.25 0 00-8.97-8.22c.26.45.46.95.58 1.47H11A6.75 6.75 0 0117.75 11c0 2.1-.73 3.25-1.75 3.25S14.25 13.1 14.25 11V7.4a.75.75 0 00-1.5.07zm-9.97 2.81c.45.26.95.46 1.47.58V11a6.75 6.75 0 009.05 6.35.75.75 0 01.5 1.4A8.23 8.23 0 012.76 11l.03-.72z",
    fill: primaryFill
  }));
};

export const MentionArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MentionArrowDownFilledIcon({}), 'MentionArrowDownFilled');

const MentionArrowDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM5.15 7.85A.5.5 0 005.5 8a.5.5 0 00.35-.15l2-2a.5.5 0 10-.7-.7L6 6.29V3.5a.5.5 0 00-1 0v2.8L3.85 5.14a.5.5 0 10-.7.7l2 2zm7.85.2A3.2 3.2 0 0010.79 7c-.1.35-.23.68-.4 1L10.5 8c1.58 0 2.5 1.17 2.5 3 0 1.8-.97 3-2.5 3S8 12.8 8 11c0-.22.01-.42.04-.62-.33.17-.68.3-1.04.41V11c0 2.3 1.36 4 3.5 4 1.28 0 2.28-.6 2.88-1.59.48 1.3 1.4 2.09 2.62 2.09 1.86 0 3-1.8 3-4.5a8 8 0 00-8.59-7.98c.16.31.29.64.38.98H11a7 7 0 017 7c0 2.22-.81 3.5-2 3.5s-2-1.28-2-3.5V7.41a.5.5 0 00-1 .09v.54zM3.02 10.4c.31.16.64.29.98.38V11a7 7 0 009.38 6.58.5.5 0 01.34.94 7.99 7.99 0 01-10.7-8.1z",
    fill: primaryFill
  }));
};

export const MentionArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MentionArrowDownRegularIcon({}), 'MentionArrowDownRegular');

const MentionBracketsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 2A2.75 2.75 0 002 4.75v10.5A2.75 2.75 0 004.75 18h1.5a.75.75 0 000-1.5h-1.5c-.69 0-1.25-.56-1.25-1.25V4.75c0-.69.56-1.25 1.25-1.25h1.5a.75.75 0 000-1.5h-1.5zm7 5.25c.41 0 .75.34.75.75v2.75a.75.75 0 001.5 0V10a4 4 0 10-4.24 4 4.1 4.1 0 001.29-.13c.35-.1.75.05.89.39.17.43-.03.93-.47 1.05A5.5 5.5 0 1115.5 10v.74c0 .46-.14.88-.37 1.24l-.13.3v-.13a2.25 2.25 0 01-3.58-.1 2.5 2.5 0 11-.37-4.33c.1-.28.38-.48.7-.48zM10 9a1 1 0 100 2 1 1 0 000-2zm8-4.25A2.75 2.75 0 0015.25 2h-1.5a.75.75 0 000 1.5h1.5c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25h-1.5a.75.75 0 000 1.5h1.5A2.75 2.75 0 0018 15.25V4.75z",
    fill: primaryFill
  }));
};

export const MentionBracketsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MentionBracketsFilledIcon({}), 'MentionBracketsFilled');

const MentionBracketsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v11c0 .83.67 1.5 1.5 1.5h2a.5.5 0 010 1h-2A2.5 2.5 0 012 15.5v-11A2.5 2.5 0 014.5 2h2a.5.5 0 010 1h-2zm11 14c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 010-1h2A2.5 2.5 0 0118 4.5v11a2.5 2.5 0 01-2.5 2.5h-2a.5.5 0 010-1h2zm-4-7a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM10 7.5c.56 0 1.08.19 1.5.5a.5.5 0 011 0v2.75a.75.75 0 001.5 0V10a4 4 0 10-4.24 4h.02a3.99 3.99 0 001.58-.23c.3-.1.64.11.64.43 0 .23-.14.45-.36.53A5 5 0 1115 10v.75a1.75 1.75 0 01-3.2.98A2.5 2.5 0 017.5 10 2.5 2.5 0 0110 7.5z",
    fill: primaryFill
  }));
};

export const MentionBracketsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MentionBracketsRegularIcon({}), 'MentionBracketsRegular');

const MergeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.75 5a.75.75 0 000 1.5h2.69l3.5 3.5-3.5 3.5H3.75a.75.75 0 000 1.5h3c.2 0 .39-.08.53-.22l4.03-4.03h4.13l-2.97 2.97a.75.75 0 101.06 1.06l4.25-4.25c.3-.3.3-.77 0-1.06l-4.25-4.25a.75.75 0 10-1.06 1.06l2.97 2.97H11.3L7.28 5.22A.75.75 0 006.75 5h-3z",
    fill: primaryFill
  }));
};

export const MergeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MergeFilledIcon({}), 'MergeFilled');

const MergeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 5a.5.5 0 000 1h2.54l4 4-4 4H3.5a.5.5 0 000 1h2.75a.5.5 0 00.35-.15l4.36-4.35h5.33l-3.64 3.65a.5.5 0 00.7.7l4.5-4.5a.5.5 0 000-.7l-4.5-4.5a.5.5 0 00-.7.7l3.64 3.65h-5.33L6.6 5.15A.5.5 0 006.25 5H3.5z",
    fill: primaryFill
  }));
};

export const MergeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MergeRegularIcon({}), 'MergeRegular');

const MicFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 10a.5.5 0 00-1 0 5.5 5.5 0 005 5.48v2.02a.5.5 0 001 0v-2.02c2.8-.26 5-2.61 5-5.48a.5.5 0 00-1 0 4.5 4.5 0 11-9 0zm7.5 0a3 3 0 01-6 0V5a3 3 0 016 0v5z",
    fill: primaryFill
  }));
};

export const MicFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicFilledIcon({}), 'MicFilled');

const MicRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 13a3 3 0 003-3V5a3 3 0 10-6 0v5a3 3 0 003 3zm0-1a2 2 0 01-2-2V5a2 2 0 114 0v5a2 2 0 01-2 2zM5 9.5c.28 0 .5.22.5.5a4.5 4.5 0 109 0 .5.5 0 011 0 5.5 5.5 0 01-5 5.48v2.02a.5.5 0 01-1 0v-2.02a5.5 5.5 0 01-5-5.48c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const MicRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicRegularIcon({}), 'MicRegular');

const MicOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 10a3 3 0 01-.1.78L7 4.88A3 3 0 0113 5v5zM7 7.7V10a3 3 0 004.74 2.45l1.07 1.07A4.5 4.5 0 015.5 10a.5.5 0 00-1.01 0 5.5 5.5 0 005 5.48v2.02a.5.5 0 001 0v-2.02a5.48 5.48 0 003.02-1.25l3.63 3.62a.5.5 0 00.7-.7l-15-15a.5.5 0 10-.7.7L7 7.71zm7.8 4.98c.45-.8.7-1.7.7-2.68a.5.5 0 00-1 0c0 .7-.16 1.35-.44 1.94l.74.74z",
    fill: primaryFill
  }));
};

export const MicOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicOffFilledIcon({}), 'MicOffFilled');

const MicOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 5v4.88l.9.9A3 3 0 0013 10V5a3 3 0 00-6-.12l1 1V5a2 2 0 114 0zM7 7.7L2.15 2.86a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-3.63-3.62a5.48 5.48 0 01-3.02 1.25v2.02a.5.5 0 01-1 0v-2.02a5.5 5.5 0 01-5-5.48.5.5 0 011 0 4.5 4.5 0 007.3 3.52l-1.06-1.07A3 3 0 017 10V7.7zm4.02 4.02L8 8.71V10a2 2 0 003.02 1.72zm3.78.96l-.74-.74c.28-.59.44-1.25.44-1.94a.5.5 0 011 0c0 .97-.25 1.89-.7 2.68z",
    fill: primaryFill
  }));
};

export const MicOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicOffRegularIcon({}), 'MicOffRegular');

const MicProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.2 13A5.51 5.51 0 0112 9.6V5a3 3 0 10-6 0v5a3 3 0 003.2 3zm.3 4.5v-.7c-.32-.7-.5-1.48-.5-2.3A4.5 4.5 0 014.5 10a.5.5 0 00-1 0 5.5 5.5 0 005 5.48v2.02a.5.5 0 001 0zm5 1.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-8a3.5 3.5 0 00-2.8 5.6l4.9-4.9a3.48 3.48 0 00-2.1-.7zm-2.1 6.3a3.5 3.5 0 004.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const MicProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicProhibitedFilledIcon({}), 'MicProhibitedFilled');

const MicProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 13h.2c.12-.4.27-.76.46-1.11A2 2 0 017 10V5a2 2 0 114 0v5c0 .1 0 .18-.02.27.31-.26.66-.48 1.02-.67V5a3 3 0 10-6 0v5a3 3 0 003 3zm-4.5-3A4.5 4.5 0 009 14.5c0 .82.18 1.6.5 2.3v.7a.5.5 0 01-1 0v-2.02a5.5 5.5 0 01-5-5.48.5.5 0 011 0zm10 9a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-8a3.5 3.5 0 00-2.8 5.6l4.9-4.9a3.48 3.48 0 00-2.1-.7zm-2.1 6.3a3.5 3.5 0 004.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const MicProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicProhibitedRegularIcon({}), 'MicProhibitedRegular');

const MicSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 13h.2A5.51 5.51 0 0112 9.6V5a3 3 0 10-6 0v5a3 3 0 003 3zm-4.5-3A4.5 4.5 0 009 14.5c0 .82.18 1.6.5 2.3v.7a.5.5 0 01-1 0v-2.02a5.5 5.5 0 01-5-5.48.5.5 0 011 0zm7.56 1.44a2 2 0 01-1.43 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const MicSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicSettingsFilledIcon({}), 'MicSettingsFilled');

const MicSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 13h.2c.12-.4.27-.76.46-1.11A2 2 0 017 10V5a2 2 0 114 0v5c0 .1 0 .18-.02.27.31-.26.66-.48 1.02-.67V5a3 3 0 10-6 0v5a3 3 0 003 3zm-4.5-3A4.5 4.5 0 009 14.5c0 .82.18 1.6.5 2.3v.7a.5.5 0 01-1 0v-2.02a5.5 5.5 0 01-5-5.48.5.5 0 011 0zm7.56 1.44a2 2 0 01-1.43 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const MicSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicSettingsRegularIcon({}), 'MicSettingsRegular');

const MicSparkleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 9.5c.28 0 .5.22.5.5a4.5 4.5 0 005.78 4.31 1.42 1.42 0 001.04.68c-.56.26-1.18.43-1.82.49v2.02a.5.5 0 01-1 0v-2.02a5.5 5.5 0 01-5-5.48c0-.28.22-.5.5-.5zm7.1 4.22a.42.42 0 00.8 0l.35-1.07a2.2 2.2 0 011.4-1.4l1.07-.35a.42.42 0 000-.8h-.02l-1.08-.35a2.2 2.2 0 01-1.4-1.4l-.34-1.07a.42.42 0 00-.8 0l-.35 1.07a2.2 2.2 0 01-1.38 1.4l-1.07.35a.42.42 0 000 .8l1.07.34a2.2 2.2 0 011.4 1.4l.35 1.08zM12.48 6c.18 0 .35.03.52.1V5a3 3 0 10-6 0v5a3 3 0 003.78 2.9 1.2 1.2 0 00-.74-.7l-1.08-.36h-.01a1.42 1.42 0 010-2.68h.01l1.08-.36a1.2 1.2 0 00.74-.76l.35-1.08v-.01A1.42 1.42 0 0112.49 6zm5.54 8.96l.76.25h.02a.3.3 0 01.14.47.3.3 0 01-.14.1l-.77.26a1.58 1.58 0 00-1 1l-.24.76a.3.3 0 01-.58 0l-.24-.77a1.57 1.57 0 00-1-1l-.77-.25a.3.3 0 01-.14-.46.3.3 0 01.14-.1l.77-.26a1.58 1.58 0 00.98-1l.25-.76a.3.3 0 01.57 0l.25.77a1.58 1.58 0 001 1z",
    fill: primaryFill
  }));
};

export const MicSparkleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicSparkleFilledIcon({}), 'MicSparkleFilled');

const MicSparkleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.23 8.35l-.35-1.07a.42.42 0 00-.8 0l-.35 1.07a2.2 2.2 0 01-1.38 1.4l-1.07.35a.42.42 0 000 .8l1.07.34a2.2 2.2 0 011.4 1.4l.35 1.08a.42.42 0 00.8 0l.35-1.07a2.2 2.2 0 011.4-1.4l1.07-.35a.42.42 0 000-.8h-.02l-1.08-.35a2.2 2.2 0 01-1.4-1.4zM10 14.5c.45 0 .88-.06 1.28-.19a1.42 1.42 0 001.04.68c-.56.26-1.18.43-1.82.49v2.02a.5.5 0 01-1 0v-2.02a5.5 5.5 0 01-5-5.48.5.5 0 011 0 4.5 4.5 0 004.5 4.5zm0-1.5a3 3 0 00.78-.1 1.2 1.2 0 00-.74-.7l-1.08-.36h-.01a1.42 1.42 0 01-.93-1.57A2.02 2.02 0 018 10V5a2 2 0 114 0v1.08a1.42 1.42 0 011 .02V5a3 3 0 10-6 0v5a3 3 0 003 3zm8.02 1.96l.76.25h.02a.3.3 0 010 .58l-.77.25a1.58 1.58 0 00-1 1l-.24.76a.3.3 0 01-.58 0l-.24-.77a1.58 1.58 0 00-1-1l-.77-.25a.3.3 0 010-.57l.77-.25a1.58 1.58 0 00.98-1l.25-.76a.3.3 0 01.57 0l.25.77a1.58 1.58 0 001 1z",
    fill: primaryFill
  }));
};

export const MicSparkleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicSparkleRegularIcon({}), 'MicSparkleRegular');

const MicSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 10a.5.5 0 00-1 0 5.5 5.5 0 005 5.48v2.02a.5.5 0 001 0v-.7c-.32-.7-.5-1.48-.5-2.3A4.5 4.5 0 014.5 10zM12 5v4.6A5.51 5.51 0 009.2 13 3.02 3.02 0 016 10V5a3 3 0 016 0zm-2 9.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const MicSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicSyncFilledIcon({}), 'MicSyncFilled');

const MicSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 13h.2c.12-.4.27-.76.46-1.11A2 2 0 017 10V5a2 2 0 114 0v5c0 .1 0 .18-.02.27.31-.26.66-.48 1.02-.67V5a3 3 0 10-6 0v5a3 3 0 003 3zm-4.5-3A4.5 4.5 0 009 14.5c0 .82.18 1.6.5 2.3v.7a.5.5 0 01-1 0v-2.02a5.5 5.5 0 01-5-5.48.5.5 0 011 0zm5.5 4.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const MicSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicSyncRegularIcon({}), 'MicSyncRegular');

const MicroscopeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V3h.5c.28 0 .5.22.5.5v1.53A6.5 6.5 0 0113.96 17h2.54a.5.5 0 010 1h-13a.5.5 0 010-1h7A5.5 5.5 0 0011 6.02v5.48a.5.5 0 01-.5.5H10v.5a1.5 1.5 0 01-3 0V12h-.5a.5.5 0 01-.5-.5v-8c0-.28.22-.5.5-.5H7v-.5zM8 12v.5a.5.5 0 001 0V12H8zm-2.5 3a.5.5 0 000 1h6a.5.5 0 000-1h-6z",
    fill: primaryFill
  }));
};

export const MicroscopeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicroscopeFilledIcon({}), 'MicroscopeFilled');

const MicroscopeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V3h.5c.28 0 .5.22.5.5v1.53A6.5 6.5 0 0113.96 17h2.54a.5.5 0 010 1h-13a.5.5 0 010-1h7A5.5 5.5 0 0011 6.02v5.48a.5.5 0 01-.5.5H10v.5a1.5 1.5 0 01-3 0V12h-.5a.5.5 0 01-.5-.5v-8c0-.28.22-.5.5-.5H7v-.5zM8 12v.5a.5.5 0 001 0V12H8zm-1-1h3V4H7v7zm-1.5 4a.5.5 0 000 1h6a.5.5 0 000-1h-6z",
    fill: primaryFill
  }));
};

export const MicroscopeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicroscopeRegularIcon({}), 'MicroscopeRegular');

const MidiFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 4a.5.5 0 00-.5.5v11c0 .28.22.5.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5h-15zm.5 6h2v3.5a.5.5 0 001 0V10h2v3.5a.5.5 0 001 0V10h2v3.5a.5.5 0 001 0V10h2v3.5a.5.5 0 001 0V10h2v5H3v-5zm2.75-2.5a.75.75 0 110-1.5.75.75 0 010 1.5zm6.25-1c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm-3 .25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const MidiFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MidiFilledIcon({}), 'MidiFilled');

const MidiRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 6a.5.5 0 000 1h2a.5.5 0 000-1h-2zM5.75 7.5a.75.75 0 100-1.5.75.75 0 000 1.5zM9 6.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM2 4.5c0-.28.22-.5.5-.5h15c.28 0 .5.22.5.5v11a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-11zM3 5v4h14V5H3zm5 5H6v3.5a.5.5 0 01-1 0V10H3v5h14v-5h-2v3.5a.5.5 0 01-1 0V10h-2v3.5a.5.5 0 01-1 0V10H9v3.5a.5.5 0 01-1 0V10z",
    fill: primaryFill
  }));
};

export const MidiRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MidiRegularIcon({}), 'MidiRegular');

const MobileOptimizedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1H4V2.5c0-.28.22-.5.5-.5zm11 0c.28 0 .5.22.5.5V4h1.5a.5.5 0 010 1h-2a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5zm-11 16a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2a.5.5 0 000 1H4v1.5c0 .28.22.5.5.5zm11 0a.5.5 0 00.5-.5V16h1.5a.5.5 0 000-1h-2a.5.5 0 00-.5.5v2c0 .28.22.5.5.5zM6 6a1 1 0 011-1h6a1 1 0 011 1v8a1 1 0 01-1 1H7a1 1 0 01-1-1V6zm2 2.5c0 .28.22.5.5.5h3a.5.5 0 000-1h-3a.5.5 0 00-.5.5zm0 2c0 .28.22.5.5.5h2a.5.5 0 000-1h-2a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const MobileOptimizedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MobileOptimizedFilledIcon({}), 'MobileOptimizedFilled');

const MobileOptimizedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2.5a.5.5 0 00-1 0V4H2.5a.5.5 0 000 1h2a.5.5 0 00.5-.5v-2zm11 0a.5.5 0 00-1 0v2c0 .28.22.5.5.5h2a.5.5 0 000-1H16V2.5zM7 5a1 1 0 00-1 1v8a1 1 0 001 1h6a1 1 0 001-1V6a1 1 0 00-1-1H7zm0 1h6v8H7V6zM4.5 18a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2a.5.5 0 000 1H4v1.5c0 .28.22.5.5.5zm11 0a.5.5 0 00.5-.5V16h1.5a.5.5 0 000-1h-2a.5.5 0 00-.5.5v2c0 .28.22.5.5.5zm-7-10a.5.5 0 000 1h3a.5.5 0 000-1h-3zm0 2a.5.5 0 000 1h2a.5.5 0 000-1h-2z",
    fill: primaryFill
  }));
};

export const MobileOptimizedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MobileOptimizedRegularIcon({}), 'MobileOptimizedRegular');

const MoleculeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 6a4 4 0 01-7.33 2.22l-1.66.84a3.49 3.49 0 01.82 3.5l2.7 1.4a2.5 2.5 0 11-.44.89l-2.7-1.38A3.5 3.5 0 117.1 8.39l2.13-1.06A4 4 0 1117 6z",
    fill: primaryFill
  }));
};

export const MoleculeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoleculeFilledIcon({}), 'MoleculeFilled');

const MoleculeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 10a4 4 0 10-3.77-2.67L7.1 8.39a3.5 3.5 0 101.3 5.08l2.69 1.38a2.5 2.5 0 10.44-.9l-2.7-1.38a3.5 3.5 0 00-.82-3.51l1.66-.84A4 4 0 0013 10zm0-1a3 3 0 110-6 3 3 0 010 6zm-7.5 5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm9.5 1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: primaryFill
  }));
};

export const MoleculeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoleculeRegularIcon({}), 'MoleculeRegular');

const MoneyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11zM6 5v1a2 2 0 01-2 2H3V7h1a1 1 0 001-1V5h1zm3 5.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM3 11v-1h1a2 2 0 012 2v1H5v-1a1 1 0 00-1-1H3zm11 0a1 1 0 00-1 1v1h-1v-1c0-1.1.9-2 2-2h1v1h-1zm0-4h1v1h-1a2 2 0 01-2-2V5h1v1a1 1 0 001 1zm3 5.5a2.5 2.5 0 01-2.5 2.5H4.09c.2.58.76 1 1.41 1h9a3.5 3.5 0 003.5-3.5v-5c0-.65-.42-1.2-1-1.41v6.41z",
    fill: primaryFill
  }));
};

export const MoneyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyFilledIcon({}), 'MoneyFilled');

const MoneyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 9a2 2 0 114 0 2 2 0 01-4 0zm2-1a1 1 0 100 2 1 1 0 000-2zM3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11zM3 5.5c0-.28.22-.5.5-.5H5v1a1 1 0 01-1 1H3V5.5zM3 8h1a2 2 0 002-2V5h6v1c0 1.1.9 2 2 2h1v2h-1a2 2 0 00-2 2v1H6v-1a2 2 0 00-2-2H3V8zm10-3h1.5c.28 0 .5.22.5.5V7h-1a1 1 0 01-1-1V5zm2 6v1.5a.5.5 0 01-.5.5H13v-1a1 1 0 011-1h1zM5 13H3.5a.5.5 0 01-.5-.5V11h1a1 1 0 011 1v1zm12-.5a2.5 2.5 0 01-2.5 2.5H4.09c.2.58.76 1 1.41 1h9a3.5 3.5 0 003.5-3.5v-5c0-.65-.42-1.2-1-1.41v6.41z",
    fill: primaryFill
  }));
};

export const MoneyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyRegularIcon({}), 'MoneyRegular');

const MoneyCalculatorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h11c.83 0 1.5.67 1.5 1.5V8h-3a2 2 0 00-2 2v3H3.5A1.5 1.5 0 012 11.5v-7zM4 7a2 2 0 002-2V4H5v1a1 1 0 01-1 1H3v1h1zm3.25 1a1.75 1.75 0 103.5 0 1.75 1.75 0 00-3.5 0zM3 9v1h1a1 1 0 011 1v1h1v-1a2 2 0 00-2-2H3zm12-2V6h-1a1 1 0 01-1-1V4h-1v1c0 1.1.9 2 2 2h1zm2 1V5.09c.58.2 1 .76 1 1.41V8h-1zm-6 6v1H5.5a1.5 1.5 0 01-1.41-1H11zm2.5-5c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-4zm0 4h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zM13 10.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const MoneyCalculatorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyCalculatorFilledIcon({}), 'MoneyCalculatorFilled');

const MoneyCalculatorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 6a2 2 0 100 4 2 2 0 000-4zM8 8a1 1 0 112 0 1 1 0 01-2 0zM2 4.5C2 3.67 2.67 3 3.5 3h11c.83 0 1.5.67 1.5 1.5V8h-1V7h-1a2 2 0 01-2-2V4H6v1a2 2 0 01-2 2H3v2h1a2 2 0 012 2v1h5v1H3.5A1.5 1.5 0 012 11.5v-7zM3.5 4a.5.5 0 00-.5.5V6h1a1 1 0 001-1V4H3.5zm11 0H13v1a1 1 0 001 1h1V4.5a.5.5 0 00-.5-.5zm-11 8H5v-1a1 1 0 00-1-1H3v1.5c0 .28.22.5.5.5zM17 8V5.09c.58.2 1 .76 1 1.41V8h-1zm-6 6v1H5.5a1.5 1.5 0 01-1.41-1H11zm2.5-5c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-4zm0 4h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zM13 10.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const MoneyCalculatorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyCalculatorRegularIcon({}), 'MoneyCalculatorRegular');

const MoneyDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52A5.5 5.5 0 0116 9.2V5.5c0-.83-.67-1.5-1.5-1.5h-11zM6 6a2 2 0 01-2 2H3V7h1a1 1 0 001-1V5h1v1zm3 4.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM3 11v-1h1a2 2 0 012 2v1H5v-1a1 1 0 00-1-1H3zm10-5a1 1 0 001 1h1v1h-1a2 2 0 01-2-2V5h1v1zm-8.91 9h4.93c.03.34.1.68.19 1H5.5a1.5 1.5 0 01-1.41-1zM18 7.5v2.76a5.5 5.5 0 00-1-.66V6.09c.58.2 1 .76 1 1.41zm1 7a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-3.8 0l1.15-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15z",
    fill: primaryFill
  }));
};

export const MoneyDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyDismissFilledIcon({}), 'MoneyDismissFilled');

const MoneyDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 9a2 2 0 114 0 2 2 0 01-4 0zm2-1a1 1 0 100 2 1 1 0 000-2zM3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52c.03-.34.1-.68.19-1H6v-1a2 2 0 00-2-2H3V8h1a2 2 0 002-2V5h6v1c0 1.1.9 2 2 2h1v1.02c.34.03.68.1 1 .19V5.5c0-.83-.67-1.5-1.5-1.5h-11zM3 5.5c0-.28.22-.5.5-.5H5v1a1 1 0 01-1 1H3V5.5zM13 5h1.5c.28 0 .5.22.5.5V7h-1a1 1 0 01-1-1V5zm-8 8H3.5a.5.5 0 01-.5-.5V11h1a1 1 0 011 1v1zm-.91 2h4.93c.03.34.1.68.19 1H5.5a1.5 1.5 0 01-1.41-1zM18 7.5v2.76a5.5 5.5 0 00-1-.66V6.09c.58.2 1 .76 1 1.41zm1 7a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-3.8 0l1.15-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15z",
    fill: primaryFill
  }));
};

export const MoneyDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyDismissRegularIcon({}), 'MoneyDismissRegular');

const MoneyHandFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v1.8l3.27 3.26c.47.47.73 1.1.73 1.77v7.17a.5.5 0 01-1 0v-7.17c0-.4-.16-.78-.44-1.06L13 6.7v3.08l.85.86a.5.5 0 01-.7.7l-3-3c-.43-.42-.66-.4-.76-.38-.18.05-.33.19-.54.4-.1.09-.15.18-.13.32.03.18.17.49.63.96.98.97 1.1 1.1 1.22 1.2l.28.3c.1.09.15.22.15.35 0 .77 0 1.55.22 2.14.1.28.24.49.42.62.18.14.45.24.86.24.28 0 .5.22.5.5v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 013 16.5v-13zm5 4a2.5 2.5 0 101.9 4.12l-.04-.05-1.21-1.22a2.85 2.85 0 01-.91-1.51c-.08-.52.13-.93.41-1.2l.04-.04.1-.08L8 7.5zm2 9v.5h1v-.5c0-.28.22-.5.5-.5h.5v-.54c-.37-.06-.68-.2-.95-.4-.6.2-1.05.77-1.05 1.44zM4 5h.5C5.33 5 6 4.33 6 3.5V3H5v.5a.5.5 0 01-.5.5H4v1zm6-1.5c0 .83.67 1.5 1.5 1.5h.5V4h-.5a.5.5 0 01-.5-.5V3h-1v.5zm-4 13c0-.83-.67-1.5-1.5-1.5H4v1h.5c.28 0 .5.22.5.5v.5h1v-.5z",
    fill: primaryFill
  }));
};

export const MoneyHandFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyHandFilledIcon({}), 'MoneyHandFilled');

const MoneyHandRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V15a.5.5 0 00-.5-.5c-.41 0-.68-.1-.86-.24a1.3 1.3 0 01-.42-.62A6.69 6.69 0 0111 11.5a.5.5 0 00-.15-.35l-.28-.3-1.22-1.2c-.46-.47-.6-.78-.63-.96-.02-.14.03-.23.13-.33.21-.2.36-.34.54-.39.1-.02.33-.04.76.38l3 3a.5.5 0 00.7-.7L13 9.79V6.71l2.56 2.56c.28.28.44.66.44 1.06v7.17a.5.5 0 001 0v-7.17c0-.66-.26-1.3-.73-1.77L13 5.3V3.5c0-.83-.67-1.5-1.5-1.5h-7zM12 5.5v3.3l-1.15-1.15c-.57-.58-1.15-.78-1.7-.65-.11.03-.22.07-.31.12A3 3 0 1010 12.23c.01.58.07 1.21.27 1.75.15.41.38.8.76 1.08h.01c-.6.2-1.05.77-1.05 1.44v.5H6v-.5c0-.83-.67-1.5-1.5-1.5H4V5h.5C5.33 5 6 4.33 6 3.5V3h4v.5c0 .83.67 1.5 1.5 1.5h.5v.5zm0 11a.5.5 0 01-.5.5H11v-.5c0-.28.22-.5.5-.5h.5v.5zM6 10a2 2 0 011.87-2c-.12.23-.18.51-.13.84.07.48.37.98.9 1.51l.91.91A2 2 0 016 10zM5 3v.5a.5.5 0 01-.5.5H4v-.5c0-.28.22-.5.5-.5H5zM4 16h.5c.28 0 .5.22.5.5v.5h-.5a.5.5 0 01-.5-.5V16zm8-12h-.5a.5.5 0 01-.5-.5V3h.5c.28 0 .5.22.5.5V4z",
    fill: primaryFill
  }));
};

export const MoneyHandRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyHandRegularIcon({}), 'MoneyHandRegular');

const MoneyOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.3 4.01C2.57 4.11 2 4.74 2 5.5v7c0 .83.67 1.5 1.5 1.5h9.8l1 1H4.08c.2.58.76 1 1.41 1h9c.25 0 .49-.03.72-.07l1.93 1.92a.5.5 0 00.7-.7l-15-15zm6.98 8.39a1.75 1.75 0 01-2.37-2.37l2.37 2.37zM5.9 6.61A2 2 0 014 8H3V7h1a1 1 0 001-1v-.3l.9.91zM3 11v-1h1a2 2 0 012 2v1H5v-1a1 1 0 00-1-1H3zm6.42-3.7l1.28 1.28 1.95 1.95A2 2 0 0114 10h1v1h-1a1 1 0 00-.65.24l2.27 2.26c.24-.27.38-.62.38-1v-7c0-.83-.67-1.5-1.5-1.5H6.12l3.3 3.3zM15 7v1h-1a2 2 0 01-2-2V5h1v1a1 1 0 001 1h1zm1.33 7.2l.7.72c.6-.63.97-1.48.97-2.42v-5c0-.65-.42-1.2-1-1.41v6.41a2.5 2.5 0 01-.67 1.7z",
    fill: primaryFill
  }));
};

export const MoneyOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyOffFilledIcon({}), 'MoneyOffFilled');

const MoneyOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.3 4.01C2.57 4.11 2 4.74 2 5.5v7c0 .83.67 1.5 1.5 1.5h9.8l1 1H4.08c.2.58.76 1 1.41 1h9c.25 0 .49-.03.72-.07l1.93 1.92a.5.5 0 00.7-.7l-15-15zM12 12.7V13H6v-1a2 2 0 00-2-2H3V8h1a2 2 0 001.9-1.39l1.38 1.37a2 2 0 002.74 2.74L12 12.71zM4.3 5l.7.7V6a1 1 0 01-1 1H3V5.5c0-.28.22-.5.5-.5h.8zm3.73 3.74l1.23 1.23a1 1 0 01-1.23-1.23zM3.5 13a.5.5 0 01-.5-.5V11h1a1 1 0 011 1v1H3.5zM14 10a2 2 0 00-1.35.53l.7.7A1 1 0 0114 11h1v1.5c0 .1-.03.2-.1.29l.72.71c.24-.27.38-.62.38-1v-7c0-.83-.67-1.5-1.5-1.5H6.12l1 1H12v1c0 1.1.9 2 2 2h1v2h-1zm.5-5c.28 0 .5.22.5.5V7h-1a1 1 0 01-1-1V5h1.5zm1.83 9.2l.7.72c.6-.63.97-1.48.97-2.42v-5c0-.65-.42-1.2-1-1.41v6.41a2.5 2.5 0 01-.67 1.7z",
    fill: primaryFill
  }));
};

export const MoneyOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyOffRegularIcon({}), 'MoneyOffRegular');

const MoneySettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52A5.5 5.5 0 0116 9.2V5.5c0-.83-.67-1.5-1.5-1.5h-11zM6 6a2 2 0 01-2 2H3V7h1a1 1 0 001-1V5h1v1zm3 4.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM3 11v-1h1a2 2 0 012 2v1H5v-1a1 1 0 00-1-1H3zm10-5a1 1 0 001 1h1v1h-1a2 2 0 01-2-2V5h1v1zm-8.91 9h4.93c.03.34.1.68.19 1H5.5a1.5 1.5 0 01-1.41-1zM18 7.5v2.76a5.5 5.5 0 00-1-.66V6.09c.58.2 1 .76 1 1.41zm-5.94 3.94a2 2 0 01-1.43 2.48l-.46.12a4.73 4.73 0 00.01 1.02l.35.08A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const MoneySettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneySettingsFilledIcon({}), 'MoneySettingsFilled');

const MoneySettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 9a2 2 0 114 0 2 2 0 01-4 0zm2-1a1 1 0 100 2 1 1 0 000-2zM3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52c.03-.34.1-.68.19-1H6v-1a2 2 0 00-2-2H3V8h1a2 2 0 002-2V5h6v1c0 1.1.9 2 2 2h1v1.02c.34.03.68.1 1 .19V5.5c0-.83-.67-1.5-1.5-1.5h-11zM3 5.5c0-.28.22-.5.5-.5H5v1a1 1 0 01-1 1H3V5.5zM13 5h1.5c.28 0 .5.22.5.5V7h-1a1 1 0 01-1-1V5zm-8 8H3.5a.5.5 0 01-.5-.5V11h1a1 1 0 011 1v1zm-.91 2h4.93c.03.34.1.68.19 1H5.5a1.5 1.5 0 01-1.41-1zM18 7.5v2.76a5.5 5.5 0 00-1-.66V6.09c.58.2 1 .76 1 1.41zm-5.94 3.94a2 2 0 01-1.43 2.48l-.46.12a4.73 4.73 0 00.01 1.02l.35.08A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const MoneySettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneySettingsRegularIcon({}), 'MoneySettingsRegular');

const MoreCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zm-3 8a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const MoreCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreCircleFilledIcon({}), 'MoreCircleFilled');

const MoreCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 10a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm-5-8a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const MoreCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreCircleRegularIcon({}), 'MoreCircleRegular');

const MoreHorizontalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.75 10a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm5 0a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM15 11.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z",
    fill: primaryFill
  }));
};

export const MoreHorizontalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontalFilledIcon({}), 'MoreHorizontalFilled');

const MoreHorizontalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.25 10a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm5 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const MoreHorizontalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontalRegularIcon({}), 'MoreHorizontalRegular');

const MoreVerticalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5A1.75 1.75 0 1110 3a1.75 1.75 0 010 3.5zM10 17a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zm-1.75-7a1.75 1.75 0 103.5 0 1.75 1.75 0 00-3.5 0z",
    fill: primaryFill
  }));
};

export const MoreVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVerticalFilledIcon({}), 'MoreVerticalFilled');

const MoreVerticalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6a1.25 1.25 0 110-2.5A1.25 1.25 0 0110 6zm0 5.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm-1.25 4a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0z",
    fill: primaryFill
  }));
};

export const MoreVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVerticalRegularIcon({}), 'MoreVerticalRegular');

const MoviesAndTvFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.13 5.38L7.03 8h9.47c.28 0 .5.22.5.5v7a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 15.5V8.57l-.26-.9a2.5 2.5 0 011.71-3.09L13.1 2.1a2.5 2.5 0 013.1 1.7l.27.97a.5.5 0 01-.34.62zM3.84 7.88l.6-.17L5.9 5.2l-1.16.33A1.5 1.5 0 003.7 7.4l.14.48zm2-.57l2.11-.61L9.4 4.2l-2.13.61-.02.04-1.42 2.46zm5.62-1.63l1.44-2.5-2.12.62-.03.05L9.34 6.3l2.12-.62zm2.68-2.65c0 .02 0 .03-.02.04l-1.27 2.22 2.52-.73-.14-.48a1.5 1.5 0 00-1.09-1.05z",
    fill: primaryFill
  }));
};

export const MoviesAndTvFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoviesAndTvFilledIcon({}), 'MoviesAndTvFilled');

const MoviesAndTvRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.13 5.38L7.03 8h9.47c.28 0 .5.22.5.5v7a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 15.5V8.57l-.26-.9a2.5 2.5 0 011.71-3.09L13.1 2.1a2.5 2.5 0 013.1 1.7l.27.97a.5.5 0 01-.34.62zM3.84 7.88l.6-.17L5.9 5.2l-1.16.33A1.5 1.5 0 003.7 7.4l.14.48zm2-.57l2.11-.61L9.4 4.2l-2.13.61-.02.04-1.42 2.46zm5.62-1.63l1.44-2.5-2.12.62-.03.05L9.34 6.3l2.12-.62zm2.68-2.65c0 .02 0 .03-.02.04l-1.27 2.22 2.52-.73-.14-.48a1.5 1.5 0 00-1.09-1.05zM4 9v6.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V9H4z",
    fill: primaryFill
  }));
};

export const MoviesAndTvRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoviesAndTvRegularIcon({}), 'MoviesAndTvRegular');

const Multiplier12XFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.7 8.75a.75.75 0 00.8-.7l.02-.1c.02-.08.06-.19.13-.3.1-.16.34-.4.95-.4.58 0 .86.19 1 .38.16.22.27.61.16 1.24a.78.78 0 01-.4.6c-.2.13-.42.2-.72.31l-.43.17c-.47.18-1.06.45-1.5 1-.47.55-.71 1.3-.71 2.3a.75.75 0 00.75.75h3.75a.75.75 0 000-1.5H9.58c.07-.28.17-.47.28-.6.2-.24.48-.4.9-.56l.27-.1c.34-.12.77-.28 1.12-.5.52-.32.95-.82 1.09-1.61.15-.87.06-1.73-.43-2.38-.5-.69-1.29-1-2.21-1-1.14 0-1.83.5-2.21 1.1A2.53 2.53 0 008 7.92v.01c0 .01-.02.36 0 .01-.03.41.29.77.7.8zm6.58 1.47a.75.75 0 10-1.06 1.06l.72.72-.72.72a.75.75 0 101.06 1.06l.72-.72.72.72a.75.75 0 101.06-1.06l-.72-.72.72-.72a.75.75 0 10-1.06-1.06l-.72.72-.72-.72zM7 13.5a.5.5 0 11-1 0 .5.5 0 011 0zM4.46 6.03c.32.1.54.39.54.72v6.5a.75.75 0 01-1.5 0V8.8c-.24.2-.52.39-.86.6a.75.75 0 01-.78-1.3c.58-.34.9-.61 1.13-.86.22-.24.36-.47.58-.81l.04-.08a.75.75 0 01.85-.32z",
    fill: primaryFill
  }));
};

export const Multiplier12XFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12XFilledIcon({}), 'Multiplier12XFilled');

const Multiplier12XRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.66 6.03c.2.06.34.26.34.47v7a.5.5 0 01-1 0V7.96a6 6 0 01-1.24.97.5.5 0 01-.52-.86c.94-.56 1.31-1.1 1.64-1.57l.22-.3a.5.5 0 01.56-.17zm4.33 2.06v-.03l.05-.12c.04-.11.1-.25.2-.39.2-.26.55-.55 1.26-.55.64 0 1.04.2 1.27.5.23.3.35.76.24 1.42-.07.38-.26.61-.57.8-.24.16-.52.28-.85.41a22 22 0 00-.43.18c-.5.21-1.05.5-1.47 1A3.27 3.27 0 008 13.5a.5.5 0 00.5.5h4a.5.5 0 100-1H9.03c.07-.49.23-.81.43-1.05.26-.32.64-.52 1.1-.72.1-.05.2-.1.32-.14.36-.14.77-.3 1.1-.52.49-.31.89-.76 1.01-1.49.15-.84.02-1.62-.44-2.2C12.1 6.29 11.36 6 10.5 6a2.44 2.44 0 00-2.47 1.81L8 7.88v.03L8 7.99v-.06a.5.5 0 001 .17zm5.86 2.06a.5.5 0 00-.7.7L15.29 12l-1.14 1.15a.5.5 0 00.7.7L16 12.71l1.15 1.14a.5.5 0 00.7-.7L16.71 12l1.14-1.15a.5.5 0 00-.7-.7L16 11.29l-1.15-1.14zM7 13.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const Multiplier12XRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12XRegularIcon({}), 'Multiplier12XRegular');

const Multiplier15XFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.46 6.03c.32.1.54.39.54.72v6.5a.75.75 0 01-1.5 0V8.81c-.24.19-.52.38-.86.58a.75.75 0 01-.78-1.28c.58-.35.9-.62 1.13-.87.22-.24.36-.47.58-.81l.04-.08a.75.75 0 01.85-.32zM9 6c-.39 0-.71.3-.75.68L8 9.43a.75.75 0 00.85.81l1.37-.18a1.35 1.35 0 11.16 2.69c-.36 0-.72-.15-.97-.4l-.38-.38a.75.75 0 00-1.06 1.06l.38.38a2.86 2.86 0 004.9-2.01 2.85 2.85 0 00-3.23-2.83l-.44.06.1-1.13h2.57a.75.75 0 000-1.5H9zm-2.5 8a.5.5 0 100-1 .5.5 0 000 1zm7.72-3.78c.3-.3.77-.3 1.06 0l.72.72.72-.72a.75.75 0 111.06 1.06l-.72.72.72.72a.75.75 0 11-1.06 1.06l-.72-.72-.72.72a.75.75 0 11-1.06-1.06l.72-.72-.72-.72a.75.75 0 010-1.06z",
    fill: primaryFill
  }));
};

export const Multiplier15XFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15XFilledIcon({}), 'Multiplier15XFilled');

const Multiplier15XRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.66 6.03c.2.06.34.26.34.47v7a.5.5 0 01-1 0V7.96a6 6 0 01-1.24.97.5.5 0 01-.52-.86c.94-.56 1.31-1.1 1.64-1.57l.22-.3a.5.5 0 01.56-.17zm3.84.43A.5.5 0 019 6h3.5a.5.5 0 010 1H9.46L9.3 8.93l1.28-.15a2.62 2.62 0 11.3 5.22h-.35c-.8 0-1.55-.31-2.1-.87l-.28-.28a.5.5 0 11.7-.7l.28.27c.37.37.87.58 1.4.58h.35a1.62 1.62 0 10-.19-3.23L8.81 10a.5.5 0 01-.56-.54l.25-3zm6.35 3.69a.5.5 0 00-.7.7L15.29 12l-1.14 1.15a.5.5 0 00.7.7L16 12.71l1.15 1.14a.5.5 0 00.7-.7L16.71 12l1.14-1.15a.5.5 0 00-.7-.7L16 11.29l-1.15-1.14zM6.5 14a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const Multiplier15XRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15XRegularIcon({}), 'Multiplier15XRegular');

const Multiplier18XFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.46 6.03c.32.1.54.39.54.72v6.5a.75.75 0 01-1.5 0V8.81c-.24.19-.52.38-.86.58a.75.75 0 01-.78-1.28c.58-.35.9-.62 1.13-.87.22-.24.36-.47.58-.81l.04-.08a.75.75 0 01.85-.32zm8.79 2.22c0 .58-.23 1.07-.59 1.45.51.44.84 1.07.84 1.8 0 1.47-1.33 2.5-2.75 2.5S8 12.97 8 11.5c0-.73.33-1.36.84-1.8a2.08 2.08 0 01-.59-1.45C8.25 6.9 9.48 6 10.75 6s2.5.9 2.5 2.25zm-2.5-.75c-.66 0-1 .44-1 .75s.34.75 1 .75c.66 0 1-.44 1-.75s-.34-.75-1-.75zm-1.25 4c0 .46.46 1 1.25 1s1.25-.54 1.25-1c0-.46-.46-1-1.25-1s-1.25.54-1.25 1zm4.72-1.28c.3-.3.77-.3 1.06 0l.72.72.72-.72a.75.75 0 111.06 1.06l-.72.72.72.72a.75.75 0 11-1.06 1.06l-.72-.72-.72.72a.75.75 0 11-1.06-1.06l.72-.72-.72-.72a.75.75 0 010-1.06zM7 13.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const Multiplier18XFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18XFilledIcon({}), 'Multiplier18XFilled');

const Multiplier18XRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.66 6.03c.2.06.34.26.34.47v7a.5.5 0 01-1 0V7.96a6 6 0 01-1.24.97.5.5 0 01-.52-.86c.94-.56 1.31-1.1 1.64-1.57l.22-.3a.5.5 0 01.56-.17zM13 8c0 .59-.27 1.09-.69 1.44.7.44 1.19 1.18 1.19 2.06 0 1.43-1.29 2.5-2.75 2.5S8 12.93 8 11.5c0-.88.48-1.62 1.19-2.06A1.87 1.87 0 018.5 8c0-1.17 1.08-2 2.25-2S13 6.83 13 8zm-2.25-1c-.77 0-1.25.52-1.25 1s.48 1 1.25 1S12 8.48 12 8s-.48-1-1.25-1zM9 11.5c0 .77.73 1.5 1.75 1.5s1.75-.73 1.75-1.5-.73-1.5-1.75-1.5S9 10.73 9 11.5zm5.15-1.35c.2-.2.5-.2.7 0L16 11.29l1.15-1.14a.5.5 0 01.7.7L16.71 12l1.14 1.15a.5.5 0 01-.7.7L16 12.71l-1.15 1.14a.5.5 0 01-.7-.7L15.29 12l-1.14-1.15a.5.5 0 010-.7zM7 13.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const Multiplier18XRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18XRegularIcon({}), 'Multiplier18XRegular');

const Multiplier1XFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 6.75a.75.75 0 00-1.39-.4l-.04.08a5.3 5.3 0 01-.58.8 4.8 4.8 0 01-1.13.88.75.75 0 10.78 1.28c.34-.2.62-.4.86-.58v4.44a.75.75 0 001.5 0v-6.5zm2.78 3.47a.75.75 0 10-1.06 1.06l.72.72-.72.72a.75.75 0 101.06 1.06l.72-.72.72.72a.75.75 0 101.06-1.06l-.72-.72.72-.72a.75.75 0 00-1.06-1.06l-.72.72-.72-.72z",
    fill: primaryFill
  }));
};

export const Multiplier1XFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1XFilledIcon({}), 'Multiplier1XFilled');

const Multiplier1XRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 6.5a.5.5 0 00-.9-.3l-.22.3c-.33.48-.7 1-1.64 1.57a.5.5 0 10.52.86A6 6 0 007 7.96v5.54a.5.5 0 101 0v-7zm2.85 3.65a.5.5 0 00-.7.7L11.29 12l-1.14 1.15a.5.5 0 00.7.7L12 12.71l1.15 1.14a.5.5 0 00.7-.7L12.71 12l1.14-1.15a.5.5 0 00-.7-.7L12 11.29l-1.15-1.14z",
    fill: primaryFill
  }));
};

export const Multiplier1XRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1XRegularIcon({}), 'Multiplier1XRegular');

const Multiplier2XFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.7 8.75a.75.75 0 00.8-.7l.02-.1c.02-.08.06-.19.13-.3.1-.16.34-.4.95-.4.58 0 .86.19 1 .38.16.22.27.61.16 1.24a.78.78 0 01-.4.6c-.2.13-.42.2-.72.31l-.43.17c-.47.18-1.06.45-1.5 1-.46.55-.7 1.3-.7 2.3a.75.75 0 00.74.75H9.5a.75.75 0 000-1.5H6.58c.07-.28.17-.47.28-.6.2-.24.48-.4.9-.56l.27-.1c.34-.12.77-.28 1.12-.5.52-.32.95-.82 1.09-1.61a3.1 3.1 0 00-.42-2.38c-.5-.69-1.3-1-2.22-1-1.13 0-1.83.5-2.2 1.1A2.53 2.53 0 005 7.92v.02c-.02.41.29.77.7.8zm6.58 1.47a.75.75 0 10-1.06 1.06l.72.72-.72.72a.75.75 0 001.06 1.06l.72-.72.72.72a.75.75 0 101.06-1.06l-.72-.72.72-.72a.75.75 0 00-1.06-1.06l-.72.72-.72-.72z",
    fill: primaryFill
  }));
};

export const Multiplier2XFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2XFilledIcon({}), 'Multiplier2XFilled');

const Multiplier2XRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 8.09l.01-.03.04-.12c.04-.11.1-.25.2-.39.2-.26.56-.55 1.26-.55.64 0 1.04.2 1.26.5.24.3.36.76.25 1.42-.07.38-.26.61-.57.8-.24.16-.52.28-.85.41l-.43.18c-.5.21-1.05.5-1.47 1a3.27 3.27 0 00-.69 2.19.5.5 0 00.5.5h4a.5.5 0 000-1H6.04c.07-.49.23-.81.43-1.05.26-.32.64-.52 1.1-.72.1-.05.2-.1.32-.14.36-.14.77-.3 1.1-.52.48-.31.89-.76 1.01-1.49.14-.84.02-1.62-.44-2.2C9.1 6.29 8.37 6 7.5 6a2.44 2.44 0 00-2.48 1.88v.03h-.01c0 .03-.04.27 0 0A.5.5 0 006 8.1zm5.86 2.06a.5.5 0 10-.7.7L12.3 12l-1.15 1.15a.5.5 0 00.7.7L13 12.71l1.15 1.14a.5.5 0 10.7-.7L13.71 12l1.14-1.15a.5.5 0 00-.7-.7L13 11.29l-1.14-1.14z",
    fill: primaryFill
  }));
};

export const Multiplier2XRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2XRegularIcon({}), 'Multiplier2XRegular');

const Multiplier5XFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.25 6.68A.75.75 0 017 6h3.25a.75.75 0 010 1.5H7.68l-.1 1.13.44-.06a2.85 2.85 0 11.36 5.68c-.75 0-1.5-.3-2.03-.84l-.38-.38a.75.75 0 111.06-1.06l.38.38a1.36 1.36 0 002.34-.95c0-.82-.72-1.45-1.53-1.34l-1.37.18a.75.75 0 01-.85-.8l.25-2.76zM5 13.5a.5.5 0 11-1 0 .5.5 0 011 0zm8.28-3.28a.75.75 0 10-1.06 1.06l.72.72-.72.72a.75.75 0 101.06 1.06l.72-.72.72.72a.75.75 0 101.06-1.06l-.72-.72.72-.72a.75.75 0 10-1.06-1.06l-.72.72-.72-.72z",
    fill: primaryFill
  }));
};

export const Multiplier5XFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5XFilledIcon({}), 'Multiplier5XFilled');

const Multiplier5XRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 6a.5.5 0 00-.5.46l-.25 3a.5.5 0 00.56.54l1.88-.23A1.62 1.62 0 118.9 13h-.36c-.53 0-1.03-.2-1.4-.58l-.28-.27a.5.5 0 00-.7.7l.27.28c.56.56 1.32.87 2.1.87h.36a2.62 2.62 0 10-.3-5.22l-1.28.15L7.46 7h3.04a.5.5 0 000-1H7zm5.15 4.15c.2-.2.5-.2.7 0L14 11.29l1.15-1.14a.5.5 0 01.7.7L14.71 12l1.14 1.15a.5.5 0 01-.7.7L14 12.71l-1.15 1.14a.5.5 0 01-.7-.7L13.29 12l-1.14-1.15a.5.5 0 010-.7zM5 13.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const Multiplier5XRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5XRegularIcon({}), 'Multiplier5XRegular');

const MultiselectLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.25 3.2c.31.27.33.74.06 1.05l-2.25 2.5a.75.75 0 01-1.09.03L1.72 5.53a.75.75 0 011.06-1.06l.7.7 1.71-1.92a.75.75 0 011.06-.06zM8 5.24c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 018 5.25zm0 5c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5a.75.75 0 01-.75-.75zm.75 4.25a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm-2.44-.25a.75.75 0 10-1.12-1l-1.72 1.91-.69-.69a.75.75 0 00-1.06 1.06l1.25 1.25a.75.75 0 001.09-.03l2.25-2.5z",
    fill: primaryFill
  }));
};

export const MultiselectLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectLtrFilledIcon({}), 'MultiselectLtrFilled');

const MultiselectLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.85 4.35a.5.5 0 10-.7-.7L3.5 5.29l-.65-.64a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0l2-2zM8 5.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm-2.65-.85c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const MultiselectLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectLtrRegularIcon({}), 'MultiselectLtrRegular');

const MultiselectRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.25c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 012 5.25zm0 5c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5a.75.75 0 01-.75-.75zm.75 4.25a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zM18.31 4.25a.75.75 0 10-1.12-1l-1.72 1.91-.69-.69a.75.75 0 10-1.06 1.06l1.25 1.25a.75.75 0 001.09-.03l2.25-2.5zm-.06 8.94c.31.28.33.75.06 1.06l-2.25 2.5a.75.75 0 01-1.09.03l-1.25-1.25a.75.75 0 111.06-1.06l.7.7 1.71-1.92a.75.75 0 011.06-.06z",
    fill: primaryFill
  }));
};

export const MultiselectRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectRtlFilledIcon({}), 'MultiselectRtlFilled');

const MultiselectRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.85 4.35a.5.5 0 00-.7-.7L15.5 5.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2zm0 9.8c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0zM2.5 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm0 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zM2 15.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const MultiselectRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectRtlRegularIcon({}), 'MultiselectRtlRegular');

const MusicNote1FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.15 2.02a.5.5 0 00-.65.48v9.9A3.24 3.24 0 004 14.75a3.25 3.25 0 106.5-.25V7.18l5.85 1.8A.5.5 0 0017 8.5V5.98a2.5 2.5 0 00-1.76-2.4l-5.1-1.56z",
    fill: primaryFill
  }));
};

export const MusicNote1Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote1FilledIcon({}), 'MusicNote1Filled');

const MusicNote1RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.15 2.02a.5.5 0 00-.65.48v9.9A3.24 3.24 0 004 14.75a3.25 3.25 0 106.5-.25V7.18l5.85 1.8A.5.5 0 0017 8.5V5.98a2.5 2.5 0 00-1.76-2.4l-5.1-1.56zM16 7.82l-5.5-1.69V3.18l4.44 1.36c.63.2 1.06.78 1.06 1.44v1.84zM5 14.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z",
    fill: primaryFill
  }));
};

export const MusicNote1Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote1RegularIcon({}), 'MusicNote1Regular');

const MusicNote2FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.99 3.02a1 1 0 00-1.29-.8l-7 2.2a1 1 0 00-.7.95v8.13a2.5 2.5 0 101 2V8.37l7-2.19v5.32a2.5 2.5 0 101 2V3.18l-.01-.16z",
    fill: primaryFill
  }));
};

export const MusicNote2Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote2FilledIcon({}), 'MusicNote2Filled');

const MusicNote2RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.7 2.23a1 1 0 011.3.95V13.5a2.5 2.5 0 11-1-2V6.18L8 8.37v7.13a2.5 2.5 0 11-1-2V5.37a1 1 0 01.7-.96l7-2.18zM8 7.32l7-2.19V3.18L8 5.37v1.95zM5.5 14a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.5-.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
    fill: primaryFill
  }));
};

export const MusicNote2Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote2RegularIcon({}), 'MusicNote2Regular');

const MusicNote2PlayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.99 3.02a1 1 0 00-1.29-.8l-7 2.2a1 1 0 00-.7.95v8.13a2.5 2.5 0 101 2V8.37l7-2.19v2.84c.34.03.68.1 1 .19V3.18l-.01-.16zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.26-.44l-3-1.65a.5.5 0 00-.74.44v3.3c0 .38.4.62.74.44l3-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const MusicNote2PlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote2PlayFilledIcon({}), 'MusicNote2PlayFilled');

const MusicNote2PlayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.7 2.23a1 1 0 011.3.95v6.03c-.32-.1-.66-.16-1-.19V6.18L8 8.37v7.13a2.5 2.5 0 11-1-2V5.37a1 1 0 01.7-.96l7-2.18zM8 7.32l7-2.19V3.18L8 5.37v1.95zM5.5 14a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm13.5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.26-.44l-3-1.65a.5.5 0 00-.74.44v3.3c0 .38.4.62.74.44l3-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const MusicNote2PlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote2PlayRegularIcon({}), 'MusicNote2PlayRegular');

const MusicNoteOff1FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l7.35 7.36v2.2A3.24 3.24 0 004 14.74a3.25 3.25 0 106.5-.25v-3.3l6.65 6.65a.5.5 0 00.7-.7l-15-15zm7.65 5.03v1.2l-1-1V2.5a.5.5 0 01.65-.48l5.09 1.57A2.5 2.5 0 0117 5.98V8.5a.5.5 0 01-.65.48l-5.85-1.8z",
    fill: primaryFill
  }));
};

export const MusicNoteOff1Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff1FilledIcon({}), 'MusicNoteOff1Filled');

const MusicNoteOff1RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l7.35 7.36v2.2A3.24 3.24 0 004 14.74a3.25 3.25 0 106.5-.25v-3.3l6.65 6.65a.5.5 0 00.7-.7l-15-15zM5 14.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm5.5-7.57v1.2l-1-1V2.5a.5.5 0 01.65-.48l5.09 1.57A2.5 2.5 0 0117 5.98V8.5a.5.5 0 01-.65.48l-5.85-1.8zm5.5.64V5.98a1.5 1.5 0 00-1.06-1.44L10.5 3.18v2.95l5.5 1.7z",
    fill: primaryFill
  }));
};

export const MusicNoteOff1Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff1RegularIcon({}), 'MusicNoteOff1Regular');

const MusicNoteOff2FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L7 7.71v5.79a2.5 2.5 0 101 2V8.7l3.41 3.42a2.5 2.5 0 003.46 3.46l2.28 2.27a.5.5 0 00.7-.7l-15-15zM13.5 11c-.12 0-.24 0-.35.02l2.83 2.83.02-.35V3.18l-.01-.16a1 1 0 00-1.29-.8l-7 2.2a1 1 0 00-.61.54l2.8 2.82L15 6.18v5.32c-.42-.31-.94-.5-1.5-.5z",
    fill: primaryFill
  }));
};

export const MusicNoteOff2Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff2FilledIcon({}), 'MusicNoteOff2Filled');

const MusicNoteOff2RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L7 7.71v5.79a2.5 2.5 0 101 2V8.7l3.41 3.42a2.5 2.5 0 003.46 3.46l2.28 2.27a.5.5 0 00.7-.7l-15-15zm11.3 12.7a1.5 1.5 0 01-2-2l2 2zM5.5 14a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8-3c-.12 0-.24 0-.35.02l2.83 2.83.02-.35V3.18a1 1 0 00-1.3-.95l-7 2.18a1 1 0 00-.61.55l.91.92v-.51l7-2.19v1.95L9.1 6.98l.8.8 5.1-1.6v5.32c-.42-.31-.94-.5-1.5-.5z",
    fill: primaryFill
  }));
};

export const MusicNoteOff2Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff2RegularIcon({}), 'MusicNoteOff2Regular');

const MyLocationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 13a3 3 0 100-6 3 3 0 000 6zm.75-10.25a.75.75 0 00-1.5 0v1.3a6 6 0 00-5.2 5.2h-1.3a.75.75 0 000 1.5h1.3a6 6 0 005.2 5.2v1.3a.75.75 0 001.5 0v-1.3a6 6 0 005.2-5.2h1.3a.75.75 0 000-1.5h-1.3a6 6 0 00-5.2-5.2v-1.3zM10 14.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9z",
    fill: primaryFill
  }));
};

export const MyLocationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MyLocationFilledIcon({}), 'MyLocationFilled');

const MyLocationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 13a3 3 0 100-6 3 3 0 000 6zm.5-10.5a.5.5 0 00-1 0v1.52A6 6 0 004.02 9.5H2.5a.5.5 0 000 1h1.52a6 6 0 005.48 5.48v1.52a.5.5 0 001 0v-1.52a6 6 0 005.48-5.48h1.52a.5.5 0 000-1h-1.52a6 6 0 00-5.48-5.48V2.5zM10 15a5 5 0 110-10 5 5 0 010 10z",
    fill: primaryFill
  }));
};

export const MyLocationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MyLocationRegularIcon({}), 'MyLocationRegular');

const NavigationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.75zM2.75 14a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75z",
    fill: primaryFill
  }));
};

export const NavigationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationFilledIcon({}), 'NavigationFilled');

const NavigationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const NavigationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationRegularIcon({}), 'NavigationRegular');

const NavigationLocationTargetFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 5a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zM2 10.75c0-.41.34-.75.75-.75h11.34a1.5 1.5 0 00-.07.27 4.47 4.47 0 00-1.85 1.23H2.75a.75.75 0 01-.75-.75zM2.75 15h7.34a1.5 1.5 0 001.18.98c.06.18.13.35.22.52H2.75a.75.75 0 010-1.5zm13.3.33a1 1 0 11-1.1-1.66 1 1 0 011.1 1.66zm2.9-1.33h.55a.5.5 0 010 1h-.55A3.49 3.49 0 0116 17.95v.55a.5.5 0 01-1 0v-.55A3.49 3.49 0 0112.05 15h-.55a.5.5 0 010-1h.55A3.49 3.49 0 0115 11.05v-.55a.5.5 0 011 0v.55A3.49 3.49 0 0118.95 14zm-3.2 2.99a2.5 2.5 0 10-.5-4.98 2.5 2.5 0 00.5 4.98z",
    fill: primaryFill
  }));
};

export const NavigationLocationTargetFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationLocationTargetFilledIcon({}), 'NavigationLocationTargetFilled');

const NavigationLocationTargetRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 5a.5.5 0 000 1h15a.5.5 0 000-1h-15zm0 5a.5.5 0 000 1h10.2c.4-.32.84-.56 1.32-.73.01-.1.04-.18.07-.27H2.5zm7.86 5.48a1.5 1.5 0 01-.27-.48H2.5a.5.5 0 000 1h8.77v-.02a1.5 1.5 0 01-.91-.5zm5.14.02a1 1 0 100-2 1 1 0 000 2zm4-1.5h-.55A3.49 3.49 0 0016 11.05v-.55a.5.5 0 00-1 0v.55A3.49 3.49 0 0012.05 14h-.55a.5.5 0 000 1h.55A3.49 3.49 0 0015 17.95v.55a.5.5 0 001 0v-.55A3.49 3.49 0 0018.95 15h.55a.5.5 0 000-1zm-2.23 2.27a2.5 2.5 0 11-3.54-3.54 2.5 2.5 0 013.54 3.54z",
    fill: primaryFill
  }));
};

export const NavigationLocationTargetRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationLocationTargetRegularIcon({}), 'NavigationLocationTargetRegular');

const NavigationPlayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 5a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zM2 10.75c0-.41.34-.75.75-.75h9.59c-.58.4-1.07.91-1.45 1.5H2.75a.75.75 0 01-.75-.75zM2.75 15h7.27c.05.52.17 1.03.35 1.5H2.75a.75.75 0 010-1.5zM20 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const NavigationPlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationPlayFilledIcon({}), 'NavigationPlayFilled');

const NavigationPlayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 5a.5.5 0 000 1h15a.5.5 0 000-1h-15zm0 5a.5.5 0 000 1h8.76c.31-.38.67-.72 1.08-1H2.5zm7.7 6c-.08-.32-.15-.66-.18-1H2.5a.5.5 0 000 1h7.7zm9.8-1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const NavigationPlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationPlayRegularIcon({}), 'NavigationPlayRegular');

const NavigationUnreadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.98 4.57l.02-.32a2.25 2.25 0 10-.28 1.08c.13-.24.22-.5.26-.76zM2.75 4h9.76a3.28 3.28 0 00.24 1.5h-10a.75.75 0 010-1.5zM2 9.75c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.75zM2.75 14a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75z",
    fill: primaryFill
  }));
};

export const NavigationUnreadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationUnreadFilledIcon({}), 'NavigationUnreadFilled');

const NavigationUnreadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.42v-.17a2.25 2.25 0 10-.05.46c.02-.1.04-.2.04-.29zM2.5 4h10a3.28 3.28 0 00.09 1H2.5a.5.5 0 010-1zM2 9.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const NavigationUnreadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationUnreadRegularIcon({}), 'NavigationUnreadRegular');

const NetworkCheckFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.51 10.18a8 8 0 0110.37-4.65l.57-.72.08-.1a9 9 0 00-11.95 5.1.5.5 0 10.93.37zm13.5-3.87a9.02 9.02 0 012.41 3.51.5.5 0 01-.93.36 8 8 0 00-1.87-2.88l.26-.66.14-.33zM10 6.5c.66 0 1.3.1 1.9.28l-.67.86a5.52 5.52 0 00-6.56 3.98.5.5 0 11-.96-.24A6.5 6.5 0 0110 6.5zm5 2.35l-.44 1.08c.35.51.6 1.08.77 1.7a.5.5 0 10.97-.25c-.25-.95-.7-1.8-1.3-2.53zM10 9h.16l-.83 1.08A3 3 0 007 13a.5.5 0 01-1 0 4 4 0 014-4zm3.17 4.35v.02c.08.08.2.13.33.13a.5.5 0 00.5-.5 4 4 0 00-.19-1.21l-.64 1.56zm.22-6.85l.61-.78.23-.29.04-.04a.5.5 0 01.86.37l-.04.16-.14.35a1207.08 1207.08 0 01-2.7 6.7 77.26 77.26 0 01-.73 1.66 1.75 1.75 0 01-3.04-1.75l.38-.54.7-.92a341.32 341.32 0 013.83-4.92zm1.74-.74a.5.5 0 01-.04.16z",
    fill: primaryFill
  }));
};

export const NetworkCheckFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NetworkCheckFilledIcon({}), 'NetworkCheckFilled');

const NetworkCheckRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.51 10.18a8 8 0 0110.37-4.65l.57-.72.08-.1a9 9 0 00-11.95 5.1.5.5 0 10.93.37zm13.5-3.87a9.02 9.02 0 012.41 3.51.5.5 0 01-.93.36 8 8 0 00-1.87-2.88l.26-.66.14-.33zM10 6.5c.66 0 1.3.1 1.9.28l-.67.86a5.52 5.52 0 00-6.56 3.98.5.5 0 11-.96-.24A6.5 6.5 0 0110 6.5zm5 2.35l-.44 1.08c.35.51.6 1.08.77 1.7a.5.5 0 10.97-.25c-.25-.95-.7-1.8-1.3-2.53zM10 9h.16l-.83 1.08A3 3 0 007 13a.5.5 0 01-1 0 4 4 0 014-4zm3.17 4.35v.02c.08.08.2.13.33.13a.5.5 0 00.5-.5 4 4 0 00-.19-1.21l-.64 1.56zm.22-6.85l.61-.78.23-.29.04-.04a.5.5 0 01.86.37l-.04.16-.14.35a1207.08 1207.08 0 01-2.7 6.7 77.26 77.26 0 01-.73 1.66 1.75 1.75 0 01-3.04-1.75l.38-.54.7-.92a341.32 341.32 0 013.83-4.92zm-1.1 3.02a338.93 338.93 0 00-2.94 3.86.75.75 0 101.3.75l.23-.5.44-1.05a342.47 342.47 0 001.55-3.8l-.57.74zm2.84-3.76a.5.5 0 01-.04.16z",
    fill: primaryFill
  }));
};

export const NetworkCheckRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NetworkCheckRegularIcon({}), 'NetworkCheckRegular');

const NewFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 2.75c.41 0 .75.34.75.75v8a.75.75 0 01-1.5 0v-8c0-.41.34-.75.75-.75zM5.97 5.97c.3-.3.77-.3 1.06 0l6 6a.75.75 0 11-1.06 1.06l-6-6a.75.75 0 010-1.06zM3.5 14.75a.75.75 0 000 1.5h8a.75.75 0 000-1.5h-8z",
    fill: primaryFill
  }));
};

export const NewFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NewFilledIcon({}), 'NewFilled');

const NewRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 3c.28 0 .5.22.5.5v8a.5.5 0 01-1 0v-8c0-.28.22-.5.5-.5zM6.15 6.15c.2-.2.5-.2.7 0l6 6a.5.5 0 01-.7.7l-6-6a.5.5 0 010-.7zM3.5 15a.5.5 0 000 1h8a.5.5 0 000-1h-8z",
    fill: primaryFill
  }));
};

export const NewRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NewRegularIcon({}), 'NewRegular');

const NewsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 12v-2h2v2H5zm10-7.5c0-.83-.67-1.5-1.5-1.5H3.42c-.83 0-1.5.67-1.5 1.5v9a2.5 2.5 0 002.5 2.5h11.16a2.5 2.5 0 002.5-2.5v-6c0-.83-.67-1.5-1.5-1.5H16v7.23a.5.5 0 01-1 0V4.5zm-11 2c0-.28.22-.5.5-.5h8a.5.5 0 010 1h-8a.5.5 0 01-.5-.5zM9.5 9h3a.5.5 0 010 1h-3a.5.5 0 010-1zM9 12.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM4.5 9h3c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const NewsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NewsFilledIcon({}), 'NewsFilled');

const NewsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zM10.5 9a.5.5 0 000 1h2a.5.5 0 000-1h-2zm-.5 3.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zM5.5 9a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm.5 3v-2h2v2H6zM2 5c0-1.1.9-2 2-2h10a2 2 0 012 2v1a2 2 0 012 2v5.5a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 13.5V5zm13 0a1 1 0 00-1-1H4a1 1 0 00-1 1v8.5c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V8a1 1 0 00-1-1v6.5a.5.5 0 01-1 0V5z",
    fill: primaryFill
  }));
};

export const NewsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NewsRegularIcon({}), 'NewsRegular');

const NextFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.25c0-1 1.12-1.6 1.95-1.04l8.5 5.71c.73.5.73 1.57 0 2.07l-8.5 5.8A1.25 1.25 0 013 15.75V4.25zm14-.75a.5.5 0 00-1 0v13a.5.5 0 101 0v-13z",
    fill: primaryFill
  }));
};

export const NextFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NextFilledIcon({}), 'NextFilled');

const NextRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 3.5a.5.5 0 10-1 0v13a.5.5 0 001 0v-13zM3 4.25c0-1 1.12-1.6 1.95-1.04l8.5 5.71c.73.5.73 1.57 0 2.07l-8.5 5.8A1.25 1.25 0 013 15.75V4.25zm1.39-.2a.25.25 0 00-.39.2v11.5c0 .2.23.32.4.2l8.49-5.78a.25.25 0 000-.42l-8.5-5.7z",
    fill: primaryFill
  }));
};

export const NextRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NextRegularIcon({}), 'NextRegular');

const NoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 3a3 3 0 013 2.82V10h-4.18a3 3 0 00-2.81 2.82L10 13v4H6a3 3 0 01-3-2.82V6a3 3 0 012.82-3H14zm2.9 8a2 2 0 01-.36.65l-.13.14-4.62 4.62a2 2 0 01-.79.5V12.84a2 2 0 011.84-1.84L13 11h3.9z",
    fill: primaryFill
  }));
};

export const NoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteFilledIcon({}), 'NoteFilled');

const NoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 3a3 3 0 013 2.82v4.56a2 2 0 01-.47 1.28l-.12.13-4.62 4.62a2 2 0 01-1.24.58l-.17.01H6a3 3 0 01-3-2.82V6a3 3 0 012.82-3H14zm0 1H6a2 2 0 00-2 1.85V14a2 2 0 001.85 2H10v-3a3 3 0 012.82-3H16V6a2 2 0 00-1.85-2H14zm1.78 7H13a2 2 0 00-2 1.85V15.78l.09-.07 4.62-4.62a1 1 0 00.07-.09z",
    fill: primaryFill
  }));
};

export const NoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteRegularIcon({}), 'NoteRegular');

const NoteAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H6V3.5zM5.5 11a5.5 5.5 0 004.9-8H14a3 3 0 013 2.82V10h-4.18a3 3 0 00-2.81 2.82L10 13v4H6a3 3 0 01-3-2.82V10.4c.75.38 1.6.6 2.5.6zm11.4 0a2 2 0 01-.36.65l-.13.14-4.62 4.62a2 2 0 01-.79.5V12.84a2 2 0 011.84-1.84L13 11h3.9z",
    fill: primaryFill
  }));
};

export const NoteAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAddFilledIcon({}), 'NoteAddFilled');

const NoteAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H6V3.5zm8 .5h-3.2c-.1-.35-.24-.68-.4-1H14a3 3 0 013 2.82v4.56a2 2 0 01-.47 1.28l-.12.13-4.62 4.62a2 2 0 01-1.24.58l-.17.01H6a3 3 0 01-3-2.82V10.4c.32.16.65.3 1 .4V14a2 2 0 001.85 2H10v-3a3 3 0 012.82-3H16V6a2 2 0 00-1.85-2H14zm1.78 7H13a2 2 0 00-2 1.85V15.78l.09-.07 4.62-4.62a1 1 0 00.07-.09z",
    fill: primaryFill
  }));
};

export const NoteAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAddRegularIcon({}), 'NoteAddRegular');

const NoteEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 14.18A3 3 0 006 17h2l.06-.35.37-1.5a3.2 3.2 0 01.84-1.48l4.83-4.83a2.87 2.87 0 012.9-.7V5.81A3 3 0 0014 3h-4v4.18a3 3 0 01-2.82 2.81L7 10H3v4.18zm.46-5.83A2 2 0 003.1 9h4.06a2 2 0 001.83-1.85L9 7V3.1a2 2 0 00-.8.49L3.6 8.2l-.13.14zm6.52 6.03l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const NoteEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteEditFilledIcon({}), 'NoteEditFilled');

const NoteEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 14.18A3 3 0 006 17h2l.06-.35.16-.65H5.85A2 2 0 014 14v-4h3.18A3 3 0 0010 7V4h4.15A2 2 0 0116 6v2c.34-.01.68.03 1 .13V5.82A3 3 0 0014 3H9.45a2 2 0 00-1.24.59L3.59 8.2l-.12.13A2 2 0 003 9.62v4.56zM7 9H4.22a1 1 0 01.07-.09L8.91 4.3 9 4.22V7.15A2 2 0 017 9zm2.98 5.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const NoteEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteEditRegularIcon({}), 'NoteEditRegular');

const NotePinFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 9.02v5.16A3 3 0 006 17h4v-4.18a3 3 0 012.82-2.81L13 10h4V5.82A3 3 0 0014 3H9.46c.95 1.12.6 2.85-.74 3.51l-1.89.92-.44 1.28a1.82 1.82 0 01-3 .7L3 9zm13.54 2.63a2 2 0 00.36-.65h-4.06a2 2 0 00-1.83 1.85L11 13v3.9a2 2 0 00.8-.49l4.61-4.62.13-.14zm-8-8.26L6.6 1.46a1.5 1.5 0 00-2.4.4L3.4 3.51a1 1 0 01-.57.5l-1.1.39a1 1 0 00-.39 1.65L2.3 7 1 8.3V9h.7L3 7.7l.95.95a1 1 0 001.65-.38l.38-1.1a1 1 0 01.5-.57l1.65-.8a1.5 1.5 0 00.4-2.41z",
    fill: primaryFill
  }));
};

export const NotePinFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotePinFilledIcon({}), 'NotePinFilled');

const NotePinRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 9.02v5.16A3 3 0 006 17h4.55a2 2 0 001.24-.59l4.62-4.62.12-.13a2 2 0 00.47-1.28V5.82A3 3 0 0014 3H9.46c.26.3.42.64.5 1h4.19A2 2 0 0116 6v4h-3.18A3 3 0 0010 13v3H5.85A2 2 0 014 14V9.81a1.82 1.82 0 01-.61-.4L3 9zM13 11h2.78a1 1 0 01-.07.09l-4.62 4.62-.09.07V12.85A2 2 0 0113 11zM8.54 3.39L6.6 1.46a1.5 1.5 0 00-2.4.4L3.4 3.51a1 1 0 01-.57.5l-1.1.39a1 1 0 00-.39 1.65L2.3 7 1 8.3V9h.7L3 7.7l.95.95a1 1 0 001.65-.38l.38-1.1a1 1 0 01.5-.57l1.65-.8a1.5 1.5 0 00.4-2.41z",
    fill: primaryFill
  }));
};

export const NotePinRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotePinRegularIcon({}), 'NotePinRegular');

const NotebookFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-7A.5.5 0 015 7V5zm11 1h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13z",
    fill: primaryFill
  }));
};

export const NotebookFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookFilledIcon({}), 'NotebookFilled');

const NotebookRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 4.5A.5.5 0 005 5v2c0 .28.22.5.5.5h7A.5.5 0 0013 7V5a.5.5 0 00-.5-.5h-7zm.5 2v-1h6v1H6zM3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V4a1 1 0 00-1-1H5zm11 3h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm.5 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zM16 13h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13z",
    fill: primaryFill
  }));
};

export const NotebookRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookRegularIcon({}), 'NotebookRegular');

const NotebookAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6A5.5 5.5 0 019.74 18H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-7A.5.5 0 015 7V5zm11 1h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm.5 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zM16 13h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zm-6 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H6v-1.5z",
    fill: primaryFill
  }));
};

export const NotebookAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookAddFilledIcon({}), 'NotebookAddFilled');

const NotebookAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H9.74c.26-.3.48-.64.66-1H13a1 1 0 001-1V4a1 1 0 00-1-1H5a1 1 0 00-1 1v5.2c-.35.1-.68.24-1 .4V4zm2.5.5A.5.5 0 005 5v2c0 .28.22.5.5.5h7A.5.5 0 0013 7V5a.5.5 0 00-.5-.5h-7zm.5 2v-1h6v1H6zM16.5 6H16v2.5h.5A.5.5 0 0017 8V6.5a.5.5 0 00-.5-.5zm0 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zm0 3.5H16v2.5h.5a.5.5 0 00.5-.5v-1.5a.5.5 0 00-.5-.5zm-11 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 010 1H6v1.5a.5.5 0 01-1 0V15H3.5a.5.5 0 010-1H5v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const NotebookAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookAddRegularIcon({}), 'NotebookAddRegular');

const NotebookErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H9.74A5.5 5.5 0 003 9.6V4zm2.5.5A.5.5 0 005 5v2c0 .28.22.5.5.5h7A.5.5 0 0013 7V5a.5.5 0 00-.5-.5h-7zm11 1.5H16v2.5h.5A.5.5 0 0017 8V6.5a.5.5 0 00-.5-.5zM16 9.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm.5 3.5H16v2.5h.5a.5.5 0 00.5-.5v-1.5a.5.5 0 00-.5-.5zm-11 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM5 12.5a.5.5 0 011 0v2a.5.5 0 01-1 0v-2zm1.13 4a.62.62 0 11-1.25 0 .62.62 0 011.25 0z",
    fill: primaryFill
  }));
};

export const NotebookErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookErrorFilledIcon({}), 'NotebookErrorFilled');

const NotebookErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6c.32-.16.65-.3 1-.4V4a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1h-2.6c-.18.36-.4.7-.66 1H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3v2c0 .28.22.5.5.5h7A.5.5 0 0013 7V5a.5.5 0 00-.5-.5h-7A.5.5 0 005 5zm1 .5h6v1H6v-1zM16 6h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zm-6 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM5.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const NotebookErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookErrorRegularIcon({}), 'NotebookErrorRegular');

const NotebookLightningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H9.74A5.5 5.5 0 003 9.6V4zm2.5.5A.5.5 0 005 5v2c0 .28.22.5.5.5h7A.5.5 0 0013 7V5a.5.5 0 00-.5-.5h-7zm11 1.5H16v2.5h.5A.5.5 0 0017 8V6.5a.5.5 0 00-.5-.5zM16 9.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm.5 3.5H16v2.5h.5a.5.5 0 00.5-.5v-1.5a.5.5 0 00-.5-.5zm-11 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1.13-3.66h-.6c-.2 0-.32-.2-.25-.39l1.1-2.78c.04-.1.13-.17.24-.17h1.83c.18 0 .3.19.25.37l-.31.97c-.05.17.07.33.24.33h.23c.36 0 .54.46.27.72l-2.56 2.53c-.2.2-.5 0-.44-.27l.24-1a.25.25 0 00-.24-.31z",
    fill: primaryFill
  }));
};

export const NotebookLightningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookLightningFilledIcon({}), 'NotebookLightningFilled');

const NotebookLightningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6c.32-.16.65-.3 1-.4V4a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1h-2.6c-.18.36-.4.7-.66 1H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-7A.5.5 0 015 7V5zm1 .5v1h6v-1H6zM16 6h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zm-6 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.63.84c.16 0 .28.15.24.3l-.24 1.01c-.06.27.25.46.44.27l2.56-2.53c.27-.26.1-.72-.27-.72h-.23a.25.25 0 01-.24-.33l.3-.97C7 12.19 6.88 12 6.7 12H4.86c-.1 0-.2.07-.24.17l-1.1 2.78c-.07.19.06.39.24.39h.6z",
    fill: primaryFill
  }));
};

export const NotebookLightningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookLightningRegularIcon({}), 'NotebookLightningRegular');

const NotebookQuestionMarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6A5.5 5.5 0 019.74 18H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-7A.5.5 0 015 7V5zm11 1h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm.5 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zM16 13h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zm-6 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5 1.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 101-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95z",
    fill: primaryFill
  }));
};

export const NotebookQuestionMarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookQuestionMarkFilledIcon({}), 'NotebookQuestionMarkFilled');

const NotebookQuestionMarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6c.32-.16.65-.3 1-.4V4a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1h-2.6c-.18.36-.4.7-.66 1H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3v2c0 .28.22.5.5.5h7A.5.5 0 0013 7V5a.5.5 0 00-.5-.5h-7A.5.5 0 005 5zm1 .5h6v1H6v-1zM16 6h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zm-6 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5 1.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 101-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95z",
    fill: primaryFill
  }));
};

export const NotebookQuestionMarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookQuestionMarkRegularIcon({}), 'NotebookQuestionMarkRegular');

const NotebookSectionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 2.5a.5.5 0 00-1 0V3H8a2 2 0 00-2 2v10c0 1.1.9 2 2 2h1.6A5.5 5.5 0 0114 9.02V2.5zm.5 7.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const NotebookSectionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSectionFilledIcon({}), 'NotebookSectionFilled');

const NotebookSectionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 2.5a.5.5 0 00-1 0V3H8a2 2 0 00-2 2v10c0 1.1.9 2 2 2h1.6c-.16-.32-.3-.65-.4-1H8a1 1 0 01-1-1V5a1 1 0 011-1h5v5.2c.32-.08.66-.15 1-.18V2.5zm.5 7.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const NotebookSectionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSectionRegularIcon({}), 'NotebookSectionRegular');

const NotebookSubsectionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5.5A3.5 3.5 0 017.5 2H10c.82 0 1.54.4 2 1H7.5A2.5 2.5 0 005 5.5V15a2.5 2.5 0 01-1-2V5.5zM13.5 2h-.07c-.24.05-.43.3-.43.6V4H7.5C6.67 4 6 4.67 6 5.5v10c0 .83.67 1.5 1.5 1.5H13V17.48c.04.3.25.52.5.52.28 0 .5-.27.5-.6V2.52c-.04-.3-.25-.52-.5-.52z",
    fill: primaryFill
  }));
};

export const NotebookSubsectionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSubsectionFilledIcon({}), 'NotebookSubsectionFilled');

const NotebookSubsectionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5.5A3.5 3.5 0 017.5 2H10c.82 0 1.54.4 2 1H7.5A2.5 2.5 0 005 5.5V15a2.5 2.5 0 01-1-2V5.5zM13.43 2h.07c.25 0 .46.23.5.52V17.4c0 .33-.22.6-.5.6-.25 0-.46-.23-.5-.52V17H8a2 2 0 01-2-2V6c0-1.1.9-2 2-2h5V2.6c0-.3.19-.55.43-.6zM8 5a1 1 0 00-1 1v9a1 1 0 001 1h5V5H8z",
    fill: primaryFill
  }));
};

export const NotebookSubsectionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSubsectionRegularIcon({}), 'NotebookSubsectionRegular');

const NotebookSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6A5.5 5.5 0 019.74 18H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-7A.5.5 0 015 7V5zm11 1h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zM1 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H6a.5.5 0 010-1h.47a1.99 1.99 0 00-2.38.34.5.5 0 01-.71-.71A3 3 0 017 12.15V12c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 014 16.85V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H5a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const NotebookSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSyncFilledIcon({}), 'NotebookSyncFilled');

const NotebookSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 4.5A.5.5 0 005 5v2c0 .28.22.5.5.5h7A.5.5 0 0013 7V5a.5.5 0 00-.5-.5h-7zm.5 2v-1h6v1H6zM3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H9.74c.26-.3.48-.64.66-1H13a1 1 0 001-1V4a1 1 0 00-1-1H5a1 1 0 00-1 1v5.2c-.35.1-.68.24-1 .4V4zm13 2h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm.5 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zM16 13h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zM1 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H6a.5.5 0 010-1h.47a1.99 1.99 0 00-2.38.34.5.5 0 01-.71-.71A3 3 0 017 12.15V12c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 014 16.85V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H5a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const NotebookSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSyncRegularIcon({}), 'NotebookSyncRegular');

const NotepadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2.5a.5.5 0 00-1 0V3h-.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H11v-3.5c0-.83.67-1.5 1.5-1.5H16V4.5c0-.83-.67-1.5-1.5-1.5H14v-.5a.5.5 0 00-1 0V3h-2.5v-.5a.5.5 0 00-1 0V3H7v-.5zm0 5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 2.5h5a.5.5 0 010 1h-5a.5.5 0 010-1zM7 13.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm8.69.5H12.5a.5.5 0 00-.5.5v3.19l.15-.13 3.41-3.41.13-.15z",
    fill: primaryFill
  }));
};

export const NotepadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadFilledIcon({}), 'NotepadFilled');

const NotepadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 7a.5.5 0 000 1h5a.5.5 0 000-1h-5zM7 10.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h2a.5.5 0 000-1h-2zm-1-11a.5.5 0 00-.5.5V3h-.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h6a.5.5 0 00.35-.15l4-4a.5.5 0 00.15-.35v-9c0-.83-.67-1.5-1.5-1.5H14v-.5a.5.5 0 00-1 0V3h-2.5v-.5a.5.5 0 00-1 0V3H7v-.5a.5.5 0 00-.5-.5zm8 2c.28 0 .5.22.5.5V13h-2.5c-.83 0-1.5.67-1.5 1.5V17H5.5a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5h9zm-.2 10L12 16.3v-1.8c0-.28.22-.5.5-.5h1.8z",
    fill: primaryFill
  }));
};

export const NotepadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadRegularIcon({}), 'NotepadRegular');

const NotepadEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.8 10.55l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64zM7 2.5a.5.5 0 00-1 0V3h-.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H9l.06-.35.37-1.5a3.2 3.2 0 01.84-1.48l4.83-4.83c.27-.27.57-.47.9-.6V4.5c0-.83-.67-1.5-1.5-1.5H14v-.5a.5.5 0 00-1 0V3h-2.5v-.5a.5.5 0 00-1 0V3H7v-.5zM7.5 7h5a.5.5 0 010 1h-5a.5.5 0 010-1zm5.5 3.5a.5.5 0 01-.5.5h-5a.5.5 0 010-1h5c.28 0 .5.22.5.5zM7.5 13h2a.5.5 0 010 1h-2a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const NotepadEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadEditFilledIcon({}), 'NotepadEditFilled');

const NotepadEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 7.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM7 13.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm-1-11a.5.5 0 011 0V3h2.5v-.5a.5.5 0 011 0V3H13v-.5a.5.5 0 011 0V3h.5c.83 0 1.5.67 1.5 1.5v4.73c-.33.14-.63.34-.9.61l-.1.1V4.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h3.72l-.16.65L9 18H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3H6v-.5zm9.8 8.05l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const NotepadEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadEditRegularIcon({}), 'NotepadEditRegular');

const NotepadPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2.5a.5.5 0 00-1 0V3h-.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h5.87a3.21 3.21 0 01-.37-1.5c0-1.3 1-2.38 2.27-2.49A2.99 2.99 0 0115.5 9c.17 0 .34.01.5.04V4.5c0-.83-.67-1.5-1.5-1.5H14v-.5a.5.5 0 00-1 0V3h-2.5v-.5a.5.5 0 00-1 0V3H7v-.5zm0 5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 6c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm0-3c0-.28.22-.5.5-.5H11a.5.5 0 010 1H7.5a.5.5 0 01-.5-.5zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const NotepadPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadPersonFilledIcon({}), 'NotepadPersonFilled');

const NotepadPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 7a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 6a.5.5 0 000 1h2a.5.5 0 000-1h-2zm-1-11a.5.5 0 00-.5.5V3h-.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h5.87a3.18 3.18 0 01-.33-1H5.5a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v4.54a3.02 3.02 0 011 0V4.5c0-.83-.67-1.5-1.5-1.5H14v-.5a.5.5 0 00-1 0V3h-2.5v-.5a.5.5 0 00-1 0V3H7v-.5a.5.5 0 00-.5-.5zm9 12a2 2 0 100-4 2 2 0 000 4zm0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5zm-8-9a.5.5 0 000 1H11a.5.5 0 000-1H7.5z",
    fill: primaryFill
  }));
};

export const NotepadPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadPersonRegularIcon({}), 'NotepadPersonRegular');

const NumberCircle1FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11.5v7a.5.5 0 01-1 0V8.48c-.38.48-.82.92-1.22 1.19a.5.5 0 11-.56-.84c.32-.2.71-.6 1.07-1.07.35-.47.62-.97.73-1.38a.5.5 0 01.98.12z",
    fill: primaryFill
  }));
};

export const NumberCircle1Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle1FilledIcon({}), 'NumberCircle1Filled');

const NumberCircle1RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 6.5a.5.5 0 00-.98-.12c-.1.4-.38.91-.73 1.38-.36.47-.75.86-1.07 1.07a.5.5 0 00.56.84c.4-.27.84-.7 1.22-1.2v5.03a.5.5 0 101 0v-7zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const NumberCircle1Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle1RegularIcon({}), 'NumberCircle1Regular');

const NumberRowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h3a2 2 0 002-2V5a2 2 0 00-2-2H4zm1 3.5a.5.5 0 011 0v7a.5.5 0 01-1 0v-7zM13 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h3a2 2 0 002-2V5a2 2 0 00-2-2h-3zm.5 3h2c.28 0 .5.22.5.5V10a.5.5 0 01-.5.5H14V13h1.5a.5.5 0 010 1h-2a.5.5 0 01-.5-.5V10c0-.28.22-.5.5-.5H15V7h-1.5a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const NumberRowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberRowFilledIcon({}), 'NumberRowFilled');

const NumberRowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6.5a.5.5 0 011 0v7a.5.5 0 01-1 0v-7zM4 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h3a2 2 0 002-2V5a2 2 0 00-2-2H4zM3 5a1 1 0 011-1h3a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V5zm10.5 1a.5.5 0 000 1H15v2.5h-1.5a.5.5 0 00-.5.5v3.5c0 .28.22.5.5.5h2a.5.5 0 000-1H14v-2.5h1.5a.5.5 0 00.5-.5V6.5a.5.5 0 00-.5-.5h-2zM13 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h3a2 2 0 002-2V5a2 2 0 00-2-2h-3zm-1 2a1 1 0 011-1h3a1 1 0 011 1v10a1 1 0 01-1 1h-3a1 1 0 01-1-1V5z",
    fill: primaryFill
  }));
};

export const NumberRowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberRowRegularIcon({}), 'NumberRowRegular');

const NumberSymbolFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.99 2.88a.75.75 0 00-1.48-.26L6.84 6.5H3.75a.75.75 0 000 1.5h2.83l-.68 4H2.75a.75.75 0 000 1.5h2.89L5 17.12a.75.75 0 101.48.26l.67-3.88h4.48L11 17.12a.75.75 0 101.48.26l.67-3.88h3.1a.75.75 0 000-1.5h-2.84l.69-4h3.14a.75.75 0 100-1.5h-2.88l.62-3.62a.75.75 0 00-1.48-.26l-.67 3.88H8.37l.62-3.62zM8.1 8h4.47l-.68 4H7.42l.69-4z",
    fill: primaryFill
  }));
};

export const NumberSymbolFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolFilledIcon({}), 'NumberSymbolFilled');

const NumberSymbolRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.99 2.6a.5.5 0 00-.98-.2L7.09 7H3.5a.5.5 0 100 1h3.39l-.8 4H2.5a.5.5 0 000 1h3.4L5 17.4a.5.5 0 10.98.2l.92-4.6h5l-.9 4.4a.5.5 0 00.98.2l.95-4.6h3.56a.5.5 0 000-1h-3.36l.82-4h3.54a.5.5 0 100-1h-3.33l.9-4.39a.5.5 0 10-.98-.2l-.95 4.6H8.11l.88-4.41zM7.91 8h5.03l-.82 4h-5l.79-4z",
    fill: primaryFill
  }));
};

export const NumberSymbolRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolRegularIcon({}), 'NumberSymbolRegular');

const NumberSymbolDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.99 2.88a.75.75 0 00-1.48-.26L6.84 6.5H3.75a.75.75 0 000 1.5h2.83l-.68 4H2.75a.75.75 0 000 1.5h2.89L5 17.12a.75.75 0 101.48.26l.67-3.88H9.1c.1-.53.27-1.04.51-1.5H7.42l.69-4h4.47l-.24 1.44c.5-.21 1.03-.35 1.59-.41L14.11 8h3.14a.75.75 0 100-1.5h-2.88l.62-3.62a.75.75 0 00-1.48-.26l-.67 3.88H8.37l.62-3.62zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const NumberSymbolDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolDismissFilledIcon({}), 'NumberSymbolDismissFilled');

const NumberSymbolDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.99 2.6a.5.5 0 00-.98-.2L7.09 7H3.5a.5.5 0 100 1h3.39l-.8 4H2.5a.5.5 0 000 1h3.4L5 17.4a.5.5 0 10.98.2l.92-4.6h2.3c.1-.35.23-.69.4-1H7.1l.8-4h5.03l-.27 1.31c.34-.12.7-.2 1.08-.26L13.96 8h3.54a.5.5 0 100-1h-3.33l.9-4.39a.5.5 0 10-.98-.2l-.95 4.6H8.11l.88-4.41zM19 14.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-2.65-1.15l-1.14 1.15 1.14 1.15a.5.5 0 01-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const NumberSymbolDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolDismissRegularIcon({}), 'NumberSymbolDismissRegular');

const NumberSymbolSquareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.45 9l-.43 2H8.55l.43-2h2.47zM5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0014.5 3h-9zm3.6 3.01a.5.5 0 01.39.6L9.19 8h2.48L12 6.4a.5.5 0 01.98.2l-.3 1.4h.81a.5.5 0 010 1h-1.02l-.43 2H13a.5.5 0 010 1h-1.17l-.34 1.6a.5.5 0 11-.98-.2l.3-1.4H8.33L8 13.6a.5.5 0 11-.98-.2l.3-1.4H6.5a.5.5 0 010-1h1.02l.43-2H7a.5.5 0 010-1h1.17l.34-1.6a.5.5 0 01.6-.39z",
    fill: primaryFill
  }));
};

export const NumberSymbolSquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolSquareFilledIcon({}), 'NumberSymbolSquareFilled');

const NumberSymbolSquareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 6.01a.5.5 0 01.39.6L9.19 8h2.48L12 6.4a.5.5 0 01.98.2l-.3 1.4h.81a.5.5 0 010 1h-1.02l-.43 2H13a.5.5 0 010 1h-1.17l-.34 1.6a.5.5 0 11-.98-.2l.3-1.4H8.33L8 13.6a.5.5 0 11-.98-.2l.3-1.4H6.5a.5.5 0 010-1h1.02l.43-2H7a.5.5 0 010-1h1.17l.34-1.6a.5.5 0 01.6-.39zM8.55 11h2.47l.43-2H8.98l-.43 2zM3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9zM5.5 4C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9z",
    fill: primaryFill
  }));
};

export const NumberSymbolSquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolSquareRegularIcon({}), 'NumberSymbolSquareRegular');

const OpenFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75v-2a.75.75 0 011.5 0v2c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 013 13.75v-7.5C3 4.45 4.46 3 6.25 3h2a.75.75 0 010 1.5h-2zm4.25-.75c0-.41.34-.75.75-.75h5c.41 0 .75.34.75.75v5a.75.75 0 01-1.5 0V5.56l-3.72 3.72a.75.75 0 11-1.06-1.06l3.72-3.72h-3.19a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const OpenFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFilledIcon({}), 'OpenFilled');

const OpenRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h8a2 2 0 002-2v-2.5a.5.5 0 011 0V14a3 3 0 01-3 3H6a3 3 0 01-3-3V6a3 3 0 013-3h2.5a.5.5 0 010 1H6zm5-.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 01-1 0V4.7l-4.15 4.15a.5.5 0 01-.7-.7L15.29 4H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const OpenRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenRegularIcon({}), 'OpenRegular');

const OpenFolderFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.25C3 4.45 4.46 3 6.25 3H14c1.8 0 3.25 1.46 3.25 3.25v2a.75.75 0 01-1.5 0v-2c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h4a.75.75 0 010 1.5h-4A3.25 3.25 0 013 13.75v-7.5zm5 2.5c0-.41.34-.75.75-.75h4.5a.75.75 0 010 1.5h-2.69l5.22 5.22a.75.75 0 11-1.06 1.06L9.5 10.56v2.69a.75.75 0 01-1.5 0v-4.5z",
    fill: primaryFill
  }));
};

export const OpenFolderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolderFilledIcon({}), 'OpenFolderFilled');

const OpenFolderRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h4.5a.5.5 0 000-1H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8a2 2 0 012 2v2.5a.5.5 0 001 0V6a3 3 0 00-3-3H6zm2.15 5.15A.5.5 0 018.5 8h4.99a.5.5 0 010 1H9.7l6.15 6.15a.5.5 0 01-.7.7L9 9.71v3.79a.5.5 0 11-1 0v-5a.5.5 0 01.15-.35z",
    fill: primaryFill
  }));
};

export const OpenFolderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolderRegularIcon({}), 'OpenFolderRegular');

const OpenOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15l15 15a.5.5 0 01-.7.7l-1.48-1.48c-.54.4-1.2.63-1.92.63h-7.5A3.25 3.25 0 013 13.75v-7.5c0-.72.23-1.38.63-1.92L2.15 2.85a.5.5 0 11.7-.7zm11.73 13.14L4.71 5.42c-.13.25-.21.53-.21.83v7.5c0 .97.78 1.75 1.75 1.75h7.5c.3 0 .59-.08.83-.21zm-4.01-6.85l.99 1a.75.75 0 00.22-.16l3.72-3.72v3.19a.75.75 0 001.5 0v-5a.75.75 0 00-.75-.75h-5a.75.75 0 000 1.5h3.19l-3.72 3.72a.75.75 0 00-.15.22zm6.28 6.29l-1.35-1.35v-1.63a.75.75 0 011.5 0v2c0 .34-.05.67-.15.98zM5.27 3.15L6.62 4.5h1.63a.75.75 0 000-1.5h-2c-.34 0-.67.05-.98.15z",
    fill: primaryFill
  }));
};

export const OpenOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOffFilledIcon({}), 'OpenOffFilled');

const OpenOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15l15 15a.5.5 0 01-.7.7l-1.41-1.4c-.5.34-1.1.55-1.74.55H6a3 3 0 01-3-3V6c0-.65.2-1.25.55-1.74l-1.4-1.4a.5.5 0 11.7-.71zm12.17 13.57L4.28 4.98A2 2 0 004 6v8c0 1.1.9 2 2 2h8a2 2 0 001.02-.28zm1.88-.94l-.9-.9V11.5a.5.5 0 011 0V14a3 3 0 01-.1.78zM5.22 3.1l.9.9H8.5a.5.5 0 000-1H6a3 3 0 00-.78.1zm5.78.4c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 01-1 0V4.7l-4.15 4.15a.5.5 0 01-.7-.7L15.29 4H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const OpenOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOffRegularIcon({}), 'OpenOffRegular');

const OptionsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.25 5h-2.36a2.5 2.5 0 00-4.78 0H2.75a.75.75 0 000 1.5h7.36a2.5 2.5 0 004.78 0h2.36a.75.75 0 000-1.5zm-14.5 8.5a.75.75 0 000 1.5h2.36a2.5 2.5 0 004.78 0h7.36a.75.75 0 000-1.5H9.89a2.5 2.5 0 00-4.78 0H2.75z",
    fill: primaryFill
  }));
};

export const OptionsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OptionsFilledIcon({}), 'OptionsFilled');

const OptionsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.95 5a2.5 2.5 0 00-4.9 0H2.5a.5.5 0 000 1h7.55a2.5 2.5 0 004.9 0h2.55a.5.5 0 000-1h-2.55zM12.5 7a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-2.55 7a2.5 2.5 0 00-4.9 0H2.5a.5.5 0 000 1h2.55a2.5 2.5 0 004.9 0h7.55a.5.5 0 000-1H9.95zM7.5 16a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const OptionsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OptionsRegularIcon({}), 'OptionsRegular');

const OrganizationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 5a3 3 0 113.5 2.96V9.5h3c.83 0 1.5.67 1.5 1.5v1.04a3 3 0 11-1 0V11a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v1.04a3 3 0 11-1 0V11c0-.83.67-1.5 1.5-1.5h3V7.96A3 3 0 017 5z",
    fill: primaryFill
  }));
};

export const OrganizationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OrganizationFilledIcon({}), 'OrganizationFilled');

const OrganizationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a3 3 0 00-.5 5.96V9.5h-3c-.83 0-1.5.67-1.5 1.5v1.04a3 3 0 101 0V11c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1.04a3 3 0 101 0V11c0-.83-.67-1.5-1.5-1.5h-3V7.96A3 3 0 0010 2zM8 5a2 2 0 114 0 2 2 0 01-4 0zM3.5 15a2 2 0 114 0 2 2 0 01-4 0zm11-2a2 2 0 110 4 2 2 0 010-4z",
    fill: primaryFill
  }));
};

export const OrganizationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OrganizationRegularIcon({}), 'OrganizationRegular');

const OrganizationHorizontalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 13a3 3 0 112.96-3.5H9.5v-3c0-.83.67-1.5 1.5-1.5h1.04a3 3 0 110 1H11a.5.5 0 00-.5.5v7c0 .28.22.5.5.5h1.04a3 3 0 110 1H11a1.5 1.5 0 01-1.5-1.5v-3H7.96A3 3 0 015 13z",
    fill: primaryFill
  }));
};

export const OrganizationHorizontalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OrganizationHorizontalFilledIcon({}), 'OrganizationHorizontalFilled');

const OrganizationHorizontalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a3 3 0 005.96.5H9.5v3c0 .83.67 1.5 1.5 1.5h1.04a3 3 0 100-1H11a.5.5 0 01-.5-.5v-7c0-.28.22-.5.5-.5h1.04a3 3 0 100-1H11c-.83 0-1.5.67-1.5 1.5v3H7.96A3 3 0 002 10zm3 2a2 2 0 110-4 2 2 0 010 4zm10 4.5a2 2 0 110-4 2 2 0 010 4zm-2-11a2 2 0 114 0 2 2 0 01-4 0z",
    fill: primaryFill
  }));
};

export const OrganizationHorizontalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OrganizationHorizontalRegularIcon({}), 'OrganizationHorizontalRegular');

const OrientationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.25 5a.25.25 0 00-.25.25v.25a.5.5 0 01-1 0v-.25C2 4.56 2.56 4 3.25 4h.25a.5.5 0 010 1h-.25z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5 4.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 4.5c0-.28.22-.5.5-.5h.25C9.44 4 10 4.56 10 5.25v.25a.5.5 0 01-1 0v-.25A.25.25 0 008.75 5H8.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14.85 5.85l-.15.16a3.5 3.5 0 01-.2 6.99.5.5 0 010-1 2.5 2.5 0 00.22-5l.13.15a.5.5 0 01-.7.7l-1-1a.5.5 0 010-.7l1-1a.5.5 0 01.7.7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3.5 9C2.67 9 2 9.67 2 10.5v4c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 00.5-.5v-1a.5.5 0 00-1 0v1c0 .28.22.5.5.5h-6z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3 7.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1z",
    fill: primaryFill
  }));
};

export const OrientationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OrientationFilledIcon({}), 'OrientationFilled');

const OrientationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.25 5a.25.25 0 00-.25.25v.25a.5.5 0 01-1 0v-.25C2 4.56 2.56 4 3.25 4h.25a.5.5 0 010 1h-.25z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5 4.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 4.5c0-.28.22-.5.5-.5h.25C9.44 4 10 4.56 10 5.25v.25a.5.5 0 01-1 0v-.25A.25.25 0 008.75 5H8.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14.85 5.85l-.15.16a3.5 3.5 0 01-.2 6.99.5.5 0 010-1 2.5 2.5 0 00.22-5l.13.15a.5.5 0 01-.7.7l-1-1a.5.5 0 010-.7l1-1a.5.5 0 01.7.7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2 10.5C2 9.67 2.67 9 3.5 9h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 012 14.5v-4zm1.5-.5a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h8a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-8z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9.5 9a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3 7.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1z",
    fill: primaryFill
  }));
};

export const OrientationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OrientationRegularIcon({}), 'OrientationRegular');

const OvalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a6 6 0 016-6h4a6 6 0 010 12H8a6 6 0 01-6-6z",
    fill: primaryFill
  }));
};

export const OvalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OvalFilledIcon({}), 'OvalFilled');

const OvalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a6 6 0 016-6h4a6 6 0 010 12H8a6 6 0 01-6-6zm6-5a5 5 0 000 10h4a5 5 0 000-10H8z",
    fill: primaryFill
  }));
};

export const OvalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OvalRegularIcon({}), 'OvalRegular');

const PaddingDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.75 2.75c0 .41.34.75.75.75H15A.75.75 0 0015 2H4.5a.75.75 0 00-.75.75zm0 14.5c0 .41.34.75.75.75h1.31a.75.75 0 000-1.5H4.5a.75.75 0 00-.75.75zm3.94 0c0 .41.33.75.75.75h2.62a.75.75 0 000-1.5H8.44a.75.75 0 00-.75.75zm5.25 0c0 .41.33.75.75.75H15a.75.75 0 000-1.5h-1.31a.75.75 0 00-.75.75zm-2.66-1.97c-.3.3-.77.3-1.06 0l-4.25-4.25a.75.75 0 111.06-1.06L9 12.94V5.75a.75.75 0 011.5 0v7.19l2.97-2.97a.75.75 0 111.06 1.06l-4.25 4.25z",
    fill: primaryFill
  }));
};

export const PaddingDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingDownFilledIcon({}), 'PaddingDownFilled');

const PaddingDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.35 11.35l-4.5 4.5a.5.5 0 01-.7 0l-4.5-4.5a.5.5 0 01.7-.7L9 14.29V4.5a.5.5 0 011 0v9.8l3.65-3.65a.5.5 0 01.7.7zM3.5 3a.5.5 0 010-1h12a.5.5 0 010 1h-12zm0 15a.5.5 0 010-1h1a.5.5 0 010 1h-1zm3 0a.5.5 0 010-1h2a.5.5 0 010 1h-2zm4 0a.5.5 0 010-1h2a.5.5 0 010 1h-2zm4 0a.5.5 0 010-1h1a.5.5 0 010 1h-1z",
    fill: primaryFill
  }));
};

export const PaddingDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingDownRegularIcon({}), 'PaddingDownRegular');

const PaddingLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 3.75A.75.75 0 002 4.5v1.31a.75.75 0 001.5 0V4.5a.75.75 0 00-.75-.75zm0 3.94a.75.75 0 00-.75.75v2.62a.75.75 0 001.5 0V8.44a.75.75 0 00-.75-.75zm0 5.25a.75.75 0 00-.75.75V15a.75.75 0 001.5 0v-1.31a.75.75 0 00-.75-.75zm14.5-9.19a.75.75 0 00-.75.75V15a.75.75 0 001.5 0V4.5a.75.75 0 00-.75-.75zM4.72 10.28a.75.75 0 010-1.06l4.25-4.25a.75.75 0 111.06 1.06L7.06 9h7.19a.75.75 0 010 1.5H7.06l2.97 2.97a.75.75 0 11-1.06 1.06l-4.25-4.25z",
    fill: primaryFill
  }));
};

export const PaddingLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingLeftFilledIcon({}), 'PaddingLeftFilled');

const PaddingLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.5a.5.5 0 011 0v1a.5.5 0 01-1 0v-1zm0 3a.5.5 0 011 0v2a.5.5 0 01-1 0v-2zm0 4a.5.5 0 011 0v2a.5.5 0 01-1 0v-2zm0 4a.5.5 0 011 0v1a.5.5 0 01-1 0v-1zm2.15-4.65a.5.5 0 010-.7l4.5-4.5a.5.5 0 11.7.7L5.71 9h9.79a.5.5 0 010 1H5.7l3.65 3.65a.5.5 0 01-.7.7l-4.5-4.5zM17 3.5a.5.5 0 011 0v12a.5.5 0 01-1 0v-12z",
    fill: primaryFill
  }));
};

export const PaddingLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingLeftRegularIcon({}), 'PaddingLeftRegular');

const PaddingRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 3.75c.41 0 .75.34.75.75V15A.75.75 0 012 15V4.5c0-.41.34-.75.75-.75zm14.5 0c.41 0 .75.34.75.75v1.31a.75.75 0 01-1.5 0V4.5c0-.41.34-.75.75-.75zm0 3.94c.41 0 .75.33.75.75v2.62a.75.75 0 01-1.5 0V8.44c0-.42.34-.75.75-.75zm0 5.25c.41 0 .75.33.75.75V15a.75.75 0 01-1.5 0v-1.31c0-.42.34-.75.75-.75zm-1.97-2.66c.3-.3.3-.77 0-1.06l-4.25-4.25a.75.75 0 10-1.06 1.06L12.94 9H5.75a.75.75 0 000 1.5h7.19l-2.97 2.97a.75.75 0 101.06 1.06l4.25-4.25z",
    fill: primaryFill
  }));
};

export const PaddingRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingRightFilledIcon({}), 'PaddingRightFilled');

const PaddingRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.85 9.85a.5.5 0 000-.7l-4.5-4.5a.5.5 0 00-.7.7L14.29 9H4.5a.5.5 0 000 1h9.8l-3.65 3.65a.5.5 0 00.7.7l4.5-4.5zM3 3.5a.5.5 0 00-1 0v12a.5.5 0 001 0v-12zm15 0a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zm0 3a.5.5 0 00-1 0v2a.5.5 0 001 0v-2zm0 4a.5.5 0 00-1 0v2a.5.5 0 001 0v-2zm0 4a.5.5 0 00-1 0v1a.5.5 0 001 0v-1z",
    fill: primaryFill
  }));
};

export const PaddingRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingRightRegularIcon({}), 'PaddingRightRegular');

const PaddingTopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.75 2.75c0-.41.34-.75.75-.75h1.31a.75.75 0 010 1.5H4.5a.75.75 0 01-.75-.75zm3.94 0c0-.41.33-.75.75-.75h2.62a.75.75 0 010 1.5H8.44a.75.75 0 01-.75-.75zm5.25 0c0-.41.33-.75.75-.75H15a.75.75 0 010 1.5h-1.31a.75.75 0 01-.75-.75zm-9.19 14.5c0-.41.34-.75.75-.75H15a.75.75 0 010 1.5H4.5a.75.75 0 01-.75-.75zm6.53-12.53a.75.75 0 00-1.06 0L4.97 8.97a.75.75 0 101.06 1.06L9 7.06v7.19a.75.75 0 001.5 0V7.06l2.97 2.97a.75.75 0 101.06-1.06l-4.25-4.25z",
    fill: primaryFill
  }));
};

export const PaddingTopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingTopFilledIcon({}), 'PaddingTopFilled');

const PaddingTopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2a.5.5 0 000 1h1a.5.5 0 000-1h-1zm3 0a.5.5 0 000 1h2a.5.5 0 000-1h-2zm4 0a.5.5 0 000 1h2a.5.5 0 000-1h-2zm4 0a.5.5 0 000 1h1a.5.5 0 000-1h-1zM9.85 4.15a.5.5 0 00-.7 0l-4.5 4.5a.5.5 0 10.7.7L9 5.71v9.79a.5.5 0 001 0V5.7l3.65 3.65a.5.5 0 00.7-.7l-4.5-4.5zM3.5 17a.5.5 0 000 1h12a.5.5 0 000-1h-12z",
    fill: primaryFill
  }));
};

export const PaddingTopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingTopRegularIcon({}), 'PaddingTopRegular');

const PageFitFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm1.5 2h1a.5.5 0 010 1h-1a.5.5 0 00-.5.5v1a.5.5 0 01-1 0v-1C4 6.67 4.67 6 5.5 6zm8 0h1c.83 0 1.5.67 1.5 1.5v1a.5.5 0 01-1 0v-1a.5.5 0 00-.5-.5h-1a.5.5 0 010-1zM5 11.5v1c0 .28.22.5.5.5h1a.5.5 0 010 1h-1A1.5 1.5 0 014 12.5v-1a.5.5 0 011 0zm11 0v1c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 010-1h1a.5.5 0 00.5-.5v-1a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const PageFitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PageFitFilledIcon({}), 'PageFitFilled');

const PageFitRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 6C4.67 6 4 6.67 4 7.5v1a.5.5 0 001 0v-1c0-.28.22-.5.5-.5h1a.5.5 0 000-1h-1zm8 0a.5.5 0 000 1h1c.28 0 .5.22.5.5v1a.5.5 0 001 0v-1c0-.83-.67-1.5-1.5-1.5h-1zM5 11.5a.5.5 0 00-1 0v1c0 .83.67 1.5 1.5 1.5h1a.5.5 0 000-1h-1a.5.5 0 01-.5-.5v-1zm11 0a.5.5 0 00-1 0v1a.5.5 0 01-.5.5h-1a.5.5 0 000 1h1c.83 0 1.5-.67 1.5-1.5v-1zM2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm1 0v8a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1H4a1 1 0 00-1 1zm2.5 0C4.67 6 4 6.67 4 7.5v1a.5.5 0 001 0v-1c0-.28.22-.5.5-.5h1a.5.5 0 000-1h-1zM5 11.5a.5.5 0 00-1 0v1c0 .83.67 1.5 1.5 1.5h1a.5.5 0 000-1h-1a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const PageFitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PageFitRegularIcon({}), 'PageFitRegular');

const PaintBrushFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 4.5V2H5.5a.5.5 0 00-.5.5V9h10V2.5a.5.5 0 00-.5-.5H13v3.5a.5.5 0 01-1 0V2h-1v2.5a.5.5 0 01-1 0zm5 5.5H5v1c0 1.1.9 2 2 2h1.5v3.5a1.5 1.5 0 103 0V13H13a2 2 0 002-2v-1z",
    fill: primaryFill
  }));
};

export const PaintBrushFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrushFilledIcon({}), 'PaintBrushFilled');

const PaintBrushRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2a.5.5 0 00-.5.5V11c0 1.1.9 2 2 2h1v3a2 2 0 104 0v-3h1a2 2 0 002-2V2.5a.5.5 0 00-.5-.5h-9zm.5 8h8v1a1 1 0 01-1 1h-1.5a.5.5 0 00-.5.5V16a1 1 0 11-2 0v-3.5a.5.5 0 00-.5-.5H7a1 1 0 01-1-1v-1zm8-1H6V3h4v1.5a.5.5 0 001 0V3h1v2.5a.5.5 0 001 0V3h1v6z",
    fill: primaryFill
  }));
};

export const PaintBrushRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrushRegularIcon({}), 'PaintBrushRegular');

const PaintBrushArrowDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.57 17.24A.5.5 0 004 18h1.7l.02-.03c.26-.54.55-1.14.79-1.71.3-.73.49-1.35.49-1.76a.5.5 0 011 0c0 .63-.27 1.41-.57 2.14-.19.46-.4.92-.61 1.36H8c.2-.39.43-.8.61-1.21.24-.54.39-.99.39-1.29a.5.5 0 011 0c0 .53-.23 1.15-.48 1.7-.12.27-.25.54-.39.8h2.75l-.44-.44A1.5 1.5 0 0113 15.1V13.5a1.5 1.5 0 012-1.41V11H5v.5a12.57 12.57 0 01-1.42 5.72v.02zM5 10h10V9a2 2 0 00-2-2h-1V4a2 2 0 10-4 0v3H7a2 2 0 00-2 2v1zm10 3.5a.5.5 0 00-1 0v3.8l-1.15-1.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 00-.7-.7L15 17.29V13.5z",
    fill: primaryFill
  }));
};

export const PaintBrushArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrushArrowDownFilledIcon({}), 'PaintBrushArrowDownFilled');

const PaintBrushArrowDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 4v3.5a.5.5 0 01-.5.5H7a1 1 0 00-1 1v1h8V9a1 1 0 00-1-1h-1.5a.5.5 0 01-.5-.5V4a1 1 0 10-2 0zm6 5v1.47a.57.57 0 010 .06v1.56a1.5 1.5 0 00-1 0V11H6v.5A13.57 13.57 0 014.8 17h1.37l.02-.04a16.46 16.46 0 00.66-1.7A3 3 0 007 14.5a.5.5 0 011 0c0 .32-.08.69-.18 1.03A10.96 10.96 0 017.28 17h1.24l.18-.42c.17-.4.3-.83.3-1.08a.5.5 0 011 0c0 .47-.2 1.05-.37 1.46L9.6 17h1.48c.07.2.19.4.35.56l.44.44H8.84 6.51 4a.5.5 0 01-.43-.76l.01-.02a3.9 3.9 0 00.2-.38A12.57 12.57 0 005 11.5V9c0-1.1.9-2 2-2h1V4a2 2 0 014 0v3h1a2 2 0 012 2zm0 4.5a.5.5 0 00-1 0v3.8l-1.15-1.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 00-.7-.7L15 17.29V13.5z",
    fill: primaryFill
  }));
};

export const PaintBrushArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrushArrowDownRegularIcon({}), 'PaintBrushArrowDownRegular');

const PaintBrushArrowUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.57 17.24A.5.5 0 004 18h1.7l.02-.03c.26-.54.55-1.14.79-1.71.3-.73.49-1.35.49-1.76a.5.5 0 011 0c0 .63-.27 1.41-.57 2.14-.19.46-.4.92-.61 1.36H8c.2-.39.43-.8.61-1.21.24-.54.39-.99.39-1.29a.5.5 0 011 0c0 .53-.23 1.15-.48 1.7-.12.27-.25.54-.39.8H13v-1.09a1.5 1.5 0 01-1.56-2.47l2-2a1.5 1.5 0 011.56-.35V11H5v.5a12.57 12.57 0 01-1.42 5.72v.02zM5 10h10V9a2 2 0 00-2-2h-1V4a2 2 0 10-4 0v3H7a2 2 0 00-2 2v1zm10 4.7v3.8a.5.5 0 01-1 0v-3.8l-1.15 1.15a.5.5 0 01-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 01-.7.7L15 14.71z",
    fill: primaryFill
  }));
};

export const PaintBrushArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrushArrowUpFilledIcon({}), 'PaintBrushArrowUpFilled');

const PaintBrushArrowUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 4v3.5a.5.5 0 01-.5.5H7a1 1 0 00-1 1v1h8V9a1 1 0 00-1-1h-1.5a.5.5 0 01-.5-.5V4a1 1 0 10-2 0zm6 5v1.47a.57.57 0 010 .06v1.56a1.5 1.5 0 00-1 0V11H6v.5A13.57 13.57 0 014.8 17h1.37l.02-.04a16.46 16.46 0 00.66-1.7A3 3 0 007 14.5a.5.5 0 011 0c0 .32-.08.69-.18 1.03A10.96 10.96 0 017.28 17h1.24l.18-.42c.17-.4.3-.83.3-1.08a.5.5 0 011 0c0 .47-.2 1.05-.37 1.46L9.6 17H13v1H8.84 6.51 4a.5.5 0 01-.43-.76l.01-.02a3.9 3.9 0 00.2-.38A12.57 12.57 0 005 11.5V9c0-1.1.9-2 2-2h1V4a2 2 0 014 0v3h1a2 2 0 012 2zm0 5.7v3.8a.5.5 0 01-1 0v-3.8l-1.15 1.15a.5.5 0 01-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 01-.7.7L15 14.71z",
    fill: primaryFill
  }));
};

export const PaintBrushArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrushArrowUpRegularIcon({}), 'PaintBrushArrowUpRegular');

const PaintBucketFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.5a.5.5 0 00-1 0V4c-.2.07-.4.19-.56.35L2.35 9.44a1.5 1.5 0 000 2.12L6.7 15.9a1.5 1.5 0 002.12 0l5.09-5.09a1.5 1.5 0 000-2.12L9.56 4.35A1.5 1.5 0 009 4V2.5zm4.27 7.5H3.2L8 5.2v1.3a.5.5 0 001 0V5.2l4.19 4.2a.5.5 0 01.08.6zm2.75 1.4a.6.6 0 00-1.04 0l-1.65 2.82a2.51 2.51 0 104.34 0l-1.65-2.83z",
    fill: primaryFill
  }));
};

export const PaintBucketFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBucketFilledIcon({}), 'PaintBucketFilled');

const PaintBucketRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.5a.5.5 0 00-1 0V4c-.2.07-.4.19-.56.35L2.35 9.44a1.5 1.5 0 000 2.12L6.7 15.9a1.5 1.5 0 002.12 0l5.09-5.09a1.5 1.5 0 000-2.12L9.56 4.35A1.5 1.5 0 009 4V2.5zM8 5.2v1.3a.5.5 0 001 0V5.2l4.19 4.2a.5.5 0 01.08.6H3.2L8 5.2zm-.6 9.99L3.2 11h9.1l-4.2 4.19a.5.5 0 01-.7 0zm8.62-3.8a.6.6 0 00-1.04 0l-1.65 2.83a2.51 2.51 0 104.34 0l-1.65-2.83zm-1.82 3.34l1.3-2.24 1.3 2.24a1.51 1.51 0 11-2.6 0z",
    fill: primaryFill
  }));
};

export const PaintBucketRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBucketRegularIcon({}), 'PaintBucketRegular');

const PairFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.5c0 .56.3 1.04.75 1.3v6.4a1.5 1.5 0 102.05 2.05h1.95v1.95a1.5 1.5 0 102.05 2.05h6.4a1.5 1.5 0 102.05-2.05V8.8a1.5 1.5 0 10-2.05-2.05h-1.95V4.8a1.5 1.5 0 10-2.05-2.05H4.8A1.5 1.5 0 002 3.5zm6.8 12.25a1.5 1.5 0 00-.55-.55v-1.95h2.95a1.5 1.5 0 102.05-2.05V8.25h1.95c.13.23.32.42.55.55v6.4a1.5 1.5 0 00-.55.55H8.8zM4.25 11.2V4.8c.23-.13.42-.32.55-.55h6.4c.13.23.32.42.55.55v1.95H8.8A1.5 1.5 0 106.75 8.8v2.95H4.8a1.5 1.5 0 00-.55-.55zm7.5 0a1.5 1.5 0 00-.55.55H8.25V8.8c.23-.13.42-.32.55-.55h2.95v2.95z",
    fill: primaryFill
  }));
};

export const PairFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PairFilledIcon({}), 'PairFilled');

const PairRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.5c0 .65.42 1.2 1 1.41v6.18A1.5 1.5 0 104.91 13H7v2.09A1.5 1.5 0 108.91 17h6.18A1.5 1.5 0 1017 15.09V8.9A1.5 1.5 0 1015.09 7H13V4.91A1.5 1.5 0 1011.09 3H4.9A1.5 1.5 0 002 3.5zM8.91 16a1.5 1.5 0 00-.91-.91V13h3.09A1.5 1.5 0 1013 11.09V8h2.09c.15.43.48.76.91.91v6.18a1.5 1.5 0 00-.91.91H8.9zM4 11.09V4.9c.43-.15.76-.48.91-.91h6.18c.15.43.48.76.91.91V7H8.91A1.5 1.5 0 107 8.91V12H4.91a1.5 1.5 0 00-.91-.91zm8 0a1.5 1.5 0 00-.91.91H8V8.91c.43-.15.76-.48.91-.91H12v3.09z",
    fill: primaryFill
  }));
};

export const PairRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PairRegularIcon({}), 'PairRegular');

const PanelBottomFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h12a1 1 0 011 1v5H3V6z",
    fill: primaryFill
  }));
};

export const PanelBottomFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelBottomFilledIcon({}), 'PanelBottomFilled');

const PanelBottomRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h12a1 1 0 011 1v5H3V6zm0 6h14v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2z",
    fill: primaryFill
  }));
};

export const PanelBottomRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelBottomRegularIcon({}), 'PanelBottomRegular');

const PanelBottomContractFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 11.17l.87-1a.5.5 0 01.76.66l-1.75 2a.5.5 0 01-.76 0l-1.75-2a.5.5 0 11.76-.65l.87 1V7.5a.5.5 0 111 0v3.67zM4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h12a1 1 0 011 1v5h-3.83a1.5 1.5 0 01-.3.5l-1.74 2a1.5 1.5 0 01-2.26 0l-1.75-2a1.5 1.5 0 01-.29-.5H3V6z",
    fill: primaryFill
  }));
};

export const PanelBottomContractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelBottomContractFilledIcon({}), 'PanelBottomContractFilled');

const PanelBottomContractRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 11.17l.87-1a.5.5 0 01.76.66l-1.75 2a.5.5 0 01-.76 0l-1.75-2a.5.5 0 11.76-.65l.87 1V7.5a.5.5 0 111 0v3.67zM4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h12a1 1 0 011 1v5h-3.83a1.5 1.5 0 01-.3.5l-.44.5H17v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2h4.57l-.45-.5a1.5 1.5 0 01-.29-.5H3V6z",
    fill: primaryFill
  }));
};

export const PanelBottomContractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelBottomContractRegularIcon({}), 'PanelBottomContractRegular');

const PanelBottomExpandFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 8.83l.87 1a.5.5 0 00.76-.66l-1.75-2a.5.5 0 00-.76 0l-1.75 2a.5.5 0 00.76.65l.87-1v3.68a.5.5 0 001 0V8.83zM4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h12a1 1 0 011 1v5h-5.5v1.5a1.5 1.5 0 11-3 0V11H3V6z",
    fill: primaryFill
  }));
};

export const PanelBottomExpandFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelBottomExpandFilledIcon({}), 'PanelBottomExpandFilled');

const PanelBottomExpandRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 8.83l.87 1a.5.5 0 00.76-.66l-1.75-2a.5.5 0 00-.76 0l-1.75 2a.5.5 0 00.76.65l.87-1v3.68a.5.5 0 001 0V8.83zM4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h12a1 1 0 011 1v5h-5.5v1H17v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2h5.5v-1H3V6z",
    fill: primaryFill
  }));
};

export const PanelBottomExpandRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelBottomExpandRegularIcon({}), 'PanelBottomExpandRegular');

const PanelLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm4 11V5h8a1 1 0 011 1v8a1 1 0 01-1 1H8z",
    fill: primaryFill
  }));
};

export const PanelLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftFilledIcon({}), 'PanelLeftFilled');

const PanelLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c-1.1-.02-2 .9-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h3v10H4a1 1 0 01-1-1V6zm5 9V5h8a1 1 0 011 1v8a1 1 0 01-1 1H8z",
    fill: primaryFill
  }));
};

export const PanelLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftRegularIcon({}), 'PanelLeftRegular');

const PanelLeftContractFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.82 10.5h3.68a.5.5 0 000-1h-3.68l1-.87a.5.5 0 10-.66-.76l-2 1.75a.5.5 0 000 .76l2 1.75a.5.5 0 10.66-.76l-1-.87zM4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm4 11V5h8a1 1 0 011 1v8a1 1 0 01-1 1H8z",
    fill: primaryFill
  }));
};

export const PanelLeftContractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftContractFilledIcon({}), 'PanelLeftContractFilled');

const PanelLeftContractRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.82 10.5h3.68a.5.5 0 000-1h-3.68l1-.87a.5.5 0 10-.66-.76l-2 1.75a.5.5 0 000 .76l2 1.75a.5.5 0 10.66-.76l-1-.87zM4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h3v10H4a1 1 0 01-1-1V6zm5 9V5h8a1 1 0 011 1v8a1 1 0 01-1 1H8z",
    fill: primaryFill
  }));
};

export const PanelLeftContractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftContractRegularIcon({}), 'PanelLeftContractRegular');

const PanelLeftExpandFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.18 10.5l-1 .87a.5.5 0 00.66.76l2-1.75a.5.5 0 000-.76l-2-1.75a.5.5 0 10-.66.76l1 .87H9.5a.5.5 0 000 1h3.68zM2 14c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v8zm6 1V5h8a1 1 0 011 1v8a1 1 0 01-1 1H8z",
    fill: primaryFill
  }));
};

export const PanelLeftExpandFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftExpandFilledIcon({}), 'PanelLeftExpandFilled');

const PanelLeftExpandRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.18 10.5l-1 .87a.5.5 0 00.66.76l2-1.75a.5.5 0 000-.76l-2-1.75a.5.5 0 10-.66.76l1 .87H9.5a.5.5 0 000 1h3.68zM2 14c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v8zm2 1a1 1 0 01-1-1V6a1 1 0 011-1h3v10H4zm4 0V5h8a1 1 0 011 1v8a1 1 0 01-1 1H8z",
    fill: primaryFill
  }));
};

export const PanelLeftExpandRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftExpandRegularIcon({}), 'PanelLeftExpandRegular');

const PanelLeftFocusRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 16a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12zM7 5v10H4a1 1 0 01-1-1V6a1 1 0 011-1h3z",
    fill: primaryFill
  }));
};

export const PanelLeftFocusRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftFocusRightFilledIcon({}), 'PanelLeftFocusRightFilled');

const PanelRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 4a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12zm-4 11V5H4a1 1 0 00-1 1v8a1 1 0 001 1h8z",
    fill: primaryFill
  }));
};

export const PanelRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelRightFilledIcon({}), 'PanelRightFilled');

const PanelRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 4c1.1-.02 2 .9 2 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12zm1 2a1 1 0 00-1-1h-3v10h3a1 1 0 001-1V6zm-5 9V5H4a1 1 0 00-1 1v8a1 1 0 001 1h8z",
    fill: primaryFill
  }));
};

export const PanelRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelRightRegularIcon({}), 'PanelRightRegular');

const PanelRightContractFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.18 10.5l-1 .87a.5.5 0 10.66.76l2-1.75a.5.5 0 000-.76l-2-1.75a.5.5 0 10-.66.76l1 .87H5.5a.5.5 0 000 1h3.68zM16 16a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12zM12 5v10H4a1 1 0 01-1-1V6a1 1 0 011-1h8z",
    fill: primaryFill
  }));
};

export const PanelRightContractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelRightContractFilledIcon({}), 'PanelRightContractFilled');

const PanelRightContractRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.18 10.5l-1 .87a.5.5 0 10.66.76l2-1.75a.5.5 0 000-.76l-2-1.75a.5.5 0 10-.66.76l1 .87H5.5a.5.5 0 000 1h3.68zM16 16a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12zm1-2a1 1 0 01-1 1h-3V5h3a1 1 0 011 1v8zm-5-9v10H4a1 1 0 01-1-1V6a1 1 0 011-1h8z",
    fill: primaryFill
  }));
};

export const PanelRightContractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelRightContractRegularIcon({}), 'PanelRightContractRegular');

const PanelRightExpandFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.82 10.5l1 .87a.5.5 0 01-.66.76l-2-1.75a.5.5 0 010-.76l2-1.75a.5.5 0 01.66.76l-1 .87h3.68a.5.5 0 010 1H6.82zM18 14a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12a2 2 0 012 2v8zm-6 1V5H4a1 1 0 00-1 1v8a1 1 0 001 1h8z",
    fill: primaryFill
  }));
};

export const PanelRightExpandFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelRightExpandFilledIcon({}), 'PanelRightExpandFilled');

const PanelRightExpandRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.82 10.5l1 .87a.5.5 0 01-.66.76l-2-1.75a.5.5 0 010-.76l2-1.75a.5.5 0 01.66.76l-1 .87h3.68a.5.5 0 010 1H6.82zM18 14a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12a2 2 0 012 2v8zm-2 1a1 1 0 001-1V6a1 1 0 00-1-1h-3v10h3zm-4 0V5H4a1 1 0 00-1 1v8a1 1 0 001 1h8z",
    fill: primaryFill
  }));
};

export const PanelRightExpandRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelRightExpandRegularIcon({}), 'PanelRightExpandRegular');

const PanelSeparateWindowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 2a2 2 0 00-2 2v4c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H3zm0 12v-3h1v3a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1h-3V4h3a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z",
    fill: primaryFill
  }));
};

export const PanelSeparateWindowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelSeparateWindowFilledIcon({}), 'PanelSeparateWindowFilled');

const PanelSeparateWindowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 2a2 2 0 00-2 2v4c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H3zM2 4a1 1 0 011-1h8a1 1 0 011 1v4a1 1 0 01-1 1H3a1 1 0 01-1-1V4zm1 10v-3h1v3a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1h-3V4h3a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z",
    fill: primaryFill
  }));
};

export const PanelSeparateWindowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelSeparateWindowRegularIcon({}), 'PanelSeparateWindowRegular');

const PanelTopContractFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 8.83l.87 1a.5.5 0 00.76-.66l-1.75-2a.5.5 0 00-.76 0l-1.75 2a.5.5 0 00.76.65l.87-1v3.68a.5.5 0 001 0V8.83zM4 16a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4zm-1-2a1 1 0 001 1h12a1 1 0 001-1V9h-3.83a1.5 1.5 0 00-.3-.5l-1.74-2a1.5 1.5 0 00-2.26 0l-1.75 2a1.5 1.5 0 00-.29.5H3v5z",
    fill: primaryFill
  }));
};

export const PanelTopContractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelTopContractFilledIcon({}), 'PanelTopContractFilled');

const PanelTopContractRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 8.83l.87 1a.5.5 0 00.76-.66l-1.75-2a.5.5 0 00-.76 0l-1.75 2a.5.5 0 00.76.65l.87-1v3.68a.5.5 0 001 0V8.83zM4 16a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4zm-1-2a1 1 0 001 1h12a1 1 0 001-1V9h-3.83a1.5 1.5 0 00-.3-.5l-.44-.5H17V6a1 1 0 00-1-1H4a1 1 0 00-1 1v2h4.57l-.45.5a1.5 1.5 0 00-.29.5H3v5z",
    fill: primaryFill
  }));
};

export const PanelTopContractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelTopContractRegularIcon({}), 'PanelTopContractRegular');

const PanelTopExpandFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 11.17l.87-1a.5.5 0 01.76.66l-1.75 2a.5.5 0 01-.76 0l-1.75-2a.5.5 0 11.76-.65l.87 1V7.5a.5.5 0 011 0v3.67zM4 16a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4zm-1-2a1 1 0 001 1h12a1 1 0 001-1V9h-5.5V7.5a1.5 1.5 0 10-3 0V9H3v5z",
    fill: primaryFill
  }));
};

export const PanelTopExpandFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelTopExpandFilledIcon({}), 'PanelTopExpandFilled');

const PanelTopExpandRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 11.17l.87-1a.5.5 0 01.76.66l-1.75 2a.5.5 0 01-.76 0l-1.75-2a.5.5 0 11.76-.65l.87 1V7.5a.5.5 0 011 0v3.67zM4 16a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4zm-1-2a1 1 0 001 1h12a1 1 0 001-1V9h-5.5V8H17V6a1 1 0 00-1-1H4a1 1 0 00-1 1v2h5.5v1H3v5z",
    fill: primaryFill
  }));
};

export const PanelTopExpandRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelTopExpandRegularIcon({}), 'PanelTopExpandRegular');

const PasswordFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v5.5A2.75 2.75 0 0115.25 15H4.75A2.75 2.75 0 012 12.25v-5.5zm5.15 1.4l-.65.64-.65-.64a.5.5 0 10-.7.7l.64.65-.64.65a.5.5 0 00.7.7l.65-.64.65.64a.5.5 0 00.7-.7l-.64-.65.64-.65a.5.5 0 10-.7-.7zm4 0l-.65.64-.65-.64a.5.5 0 10-.7.7l.64.65-.64.65a.5.5 0 00.7.7l.65-.64.65.64a.5.5 0 00.7-.7l-.64-.65.64-.65a.5.5 0 00-.7-.7zM13 10.5c0 .28.22.5.5.5h2a.5.5 0 000-1h-2a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PasswordFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PasswordFilledIcon({}), 'PasswordFilled');

const PasswordRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.85 8.15a.5.5 0 00-.7 0l-.65.64-.65-.64a.5.5 0 10-.7.7l.64.65-.64.65a.5.5 0 00.7.7l.65-.64.65.64a.5.5 0 00.7-.7l-.64-.65.64-.65a.5.5 0 000-.7zm3.3 0a.5.5 0 01.7.7l-.64.65.64.65a.5.5 0 01-.7.7l-.65-.64-.65.64a.5.5 0 01-.7-.7l.64-.65-.64-.65a.5.5 0 11.7-.7l.65.64.65-.64zM13.5 10a.5.5 0 000 1h2a.5.5 0 000-1h-2zM4.75 4A2.75 2.75 0 002 6.75v5.5A2.75 2.75 0 004.75 15h10.5A2.75 2.75 0 0018 12.25v-5.5A2.75 2.75 0 0015.25 4H4.75zM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v5.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 14 3 13.22 3 12.25v-5.5z",
    fill: primaryFill
  }));
};

export const PasswordRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PasswordRegularIcon({}), 'PasswordRegular');

const PatchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.27 3.06l1.02 1.03-5.2 5.2-1.03-1.02a2.5 2.5 0 010-3.54l1.67-1.67a2.5 2.5 0 013.54 0zm3.46 13.88l-1.02-1.03 5.2-5.2 1.03 1.02a2.5 2.5 0 010 3.54l-1.67 1.67a2.5 2.5 0 01-3.54 0zm-8.67-5.2a2.5 2.5 0 000 3.53l1.67 1.67a2.5 2.5 0 003.54 0l8.67-8.67a2.5 2.5 0 000-3.54l-1.67-1.67a2.5 2.5 0 00-3.54 0l-8.67 8.67zM10 8.5a.5.5 0 110-1 .5.5 0 010 1zm0 2a.5.5 0 110-1 .5.5 0 010 1zM8.5 10a.5.5 0 11-1 0 .5.5 0 011 0zm3.5.5a.5.5 0 110-1 .5.5 0 010 1zM10.5 12a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const PatchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PatchFilledIcon({}), 'PatchFilled');

const PatchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 8a.5.5 0 11-1 0 .5.5 0 011 0zm0 2a.5.5 0 11-1 0 .5.5 0 011 0zm-2.5.5a.5.5 0 100-1 .5.5 0 000 1zm4.5-.5a.5.5 0 11-1 0 .5.5 0 011 0zM10 12.5a.5.5 0 100-1 .5.5 0 000 1zm-6.94 2.77a2.5 2.5 0 010-3.54l8.67-8.67a2.5 2.5 0 013.54 0l1.67 1.67a2.5 2.5 0 010 3.54l-8.67 8.67a2.5 2.5 0 01-3.54 0l-1.67-1.67zm.7-2.83a1.5 1.5 0 000 2.12l1.68 1.67a1.5 1.5 0 002.12 0L9.3 14.5 5.5 10.7l-1.73 1.74zM13.8 10L10 6.2 6.2 10l3.8 3.8 3.8-3.8zm.71-.7l1.73-1.74a1.5 1.5 0 000-2.12l-1.67-1.67a1.5 1.5 0 00-2.12 0L10.7 5.5l3.79 3.8zm-3.8 6.61l1.03 1.03a2.5 2.5 0 003.54 0l1.67-1.67a2.5 2.5 0 000-3.54l-1.03-1.02-.7.7 1.02 1.03a1.5 1.5 0 010 2.12l-1.67 1.67a1.5 1.5 0 01-2.12 0l-1.03-1.02-.7.7zM8.6 4.8L7.56 3.77a1.5 1.5 0 00-2.12 0L3.77 5.44a1.5 1.5 0 000 2.12L4.79 8.6l-.7.7-1.03-1.02a2.5 2.5 0 010-3.54l1.67-1.67a2.5 2.5 0 013.54 0L9.29 4.1l-.7.7z",
    fill: primaryFill
  }));
};

export const PatchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PatchRegularIcon({}), 'PatchRegular');

const PatientFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 4a2 2 0 100 4 2 2 0 000-4zM6.5 14.5a.5.5 0 000 1h7a.5.5 0 000-1h-7zM4 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm10-1H6a1 1 0 00-1 1v8h2v-2a1 1 0 011-1h4a1 1 0 011 1v2h2V4a1 1 0 00-1-1zM5 13v3a1 1 0 001 1h8a1 1 0 001-1v-3H5z",
    fill: primaryFill
  }));
};

export const PatientFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PatientFilledIcon({}), 'PatientFilled');

const PatientRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 4a2 2 0 100 4 2 2 0 000-4zM9 6a1 1 0 112 0 1 1 0 01-2 0zm-2.5 8.5a.5.5 0 000 1h7a.5.5 0 000-1h-7zM4 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm10-1H6a1 1 0 00-1 1v8h2v-2a1 1 0 011-1h4a1 1 0 011 1v2h2V4a1 1 0 00-1-1zm-2 7H8v2h4v-2zm-7 3v3a1 1 0 001 1h8a1 1 0 001-1v-3H5z",
    fill: primaryFill
  }));
};

export const PatientRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PatientRegularIcon({}), 'PatientRegular');

const PauseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5v-13zm-9 0C3 2.67 3.67 2 4.5 2h2C7.33 2 8 2.67 8 3.5v13c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 013 16.5v-13z",
    fill: primaryFill
  }));
};

export const PauseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PauseFilledIcon({}), 'PauseFilled');

const PauseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-13C8 2.67 7.33 2 6.5 2h-2zm0 1h2c.28 0 .5.22.5.5v13a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5zm9-1c-.83 0-1.5.67-1.5 1.5v13c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-2zm0 1h2c.28 0 .5.22.5.5v13a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const PauseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PauseRegularIcon({}), 'PauseRegular');

const PauseCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm7-2.5a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zm3 0a.5.5 0 00-1 0v5a.5.5 0 001 0v-5z",
    fill: primaryFill
  }));
};

export const PauseCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PauseCircleFilledIcon({}), 'PauseCircleFilled');

const PauseCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 7.5a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zm3 0a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const PauseCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PauseCircleRegularIcon({}), 'PauseCircleRegular');

const PauseOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.7v12.8c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V8.7l4 4v3.8c0 .83.67 1.5 1.5 1.5h2c.49 0 .92-.23 1.2-.6l.45.45a.5.5 0 00.7-.7l-15-15a.5.5 0 10-.7.7l.85.86zm9 6.18l5 5V3.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v6.38zM4.16 2.04L8 5.88V3.5C8 2.67 7.33 2 6.5 2h-2c-.12 0-.23.01-.34.04z",
    fill: primaryFill
  }));
};

export const PauseOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PauseOffFilledIcon({}), 'PauseOffFilled');

const PauseOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.7l-.85-.85a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-.45-.45c-.28.37-.71.6-1.2.6h-2a1.5 1.5 0 01-1.5-1.5v-3.8l-4-4v7.8c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 013 16.5V3.7zm4 4l-3-3v11.8c0 .28.22.5.5.5h2a.5.5 0 00.5-.5V7.7zm6 6v2.8c0 .28.22.5.5.5h2a.5.5 0 00.47-.32L13 13.7zM7 3.5v1.38l1 1V3.5C8 2.67 7.33 2 6.5 2h-2c-.12 0-.23.01-.34.04l.96.96H6.5c.28 0 .5.22.5.5zm5 6.38l1 1V3.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v10.38l1 1V3.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v6.38z",
    fill: primaryFill
  }));
};

export const PauseOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PauseOffRegularIcon({}), 'PauseOffRegular');

const PauseSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v6.1a5.48 5.48 0 00-5 0V3.5zm-9 0C3 2.67 3.67 2 4.5 2h2C7.33 2 8 2.67 8 3.5v13c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 013 16.5v-13zm9.07 7.94a2 2 0 01-1.44 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PauseSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PauseSettingsFilledIcon({}), 'PauseSettingsFilled');

const PauseSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-13C8 2.67 7.33 2 6.5 2h-2zm0 1h2c.28 0 .5.22.5.5v13a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5zm9-1c-.83 0-1.5.67-1.5 1.5v6.1c.32-.16.65-.3 1-.4V3.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v5.7c.35.1.68.24 1 .4V3.5c0-.83-.67-1.5-1.5-1.5h-2zm-1.43 9.44a2 2 0 01-1.44 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PauseSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PauseSettingsRegularIcon({}), 'PauseSettingsRegular');

const PaymentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 6.5c0-1.1.9-2 2-2h11a2 2 0 012 2V8h-15V6.5zm0 2.5h15v4.5a2 2 0 01-2 2h-11a2 2 0 01-2-2V9zm11 4a.5.5 0 000 1h2a.5.5 0 000-1h-2z",
    fill: primaryFill
  }));
};

export const PaymentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaymentFilledIcon({}), 'PaymentFilled');

const PaymentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 13a.5.5 0 000 1h2a.5.5 0 000-1h-2zM2 6.5A2.5 2.5 0 014.5 4h11A2.5 2.5 0 0118 6.5v7a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 13.5v-7zm1 7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V9H3v4.5zm14-7c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5V8h14V6.5z",
    fill: primaryFill
  }));
};

export const PaymentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaymentRegularIcon({}), 'PaymentRegular');

const PenFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.92 2.87a2.97 2.97 0 014.2 4.21l-.66.67.33.34a2 2 0 010 2.82l-.94.94a.5.5 0 01-.7-.7l.94-.94a1 1 0 000-1.42l-.34-.33-7.98 7.98c-.34.34-.77.57-1.24.68l-3.92.87a.5.5 0 01-.6-.6l.88-3.95c.1-.45.33-.86.66-1.2l9.37-9.37z",
    fill: primaryFill
  }));
};

export const PenFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PenFilledIcon({}), 'PenFilled');

const PenRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.18 2.93a2.97 2.97 0 00-4.26-.06l-9.37 9.38c-.33.32-.56.74-.66 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.88c.47-.1.9-.33 1.24-.67l7.98-7.98.34.33a1 1 0 010 1.42l-.94.94a.5.5 0 00.7.7l.94-.94a2 2 0 000-2.82l-.33-.34.67-.67a2.97 2.97 0 00.05-4.15zm-3.55.65a1.97 1.97 0 012.79 2.8l-9.36 9.35c-.2.2-.46.35-.74.4l-3.16.71.7-3.18c.07-.27.2-.51.4-.7l9.37-9.38z",
    fill: primaryFill
  }));
};

export const PenRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PenRegularIcon({}), 'PenRegular');

const PenOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l5.4 5.4-4 4c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68l3.98-3.98 5.4 5.4a.5.5 0 00.7-.71l-15-15zm12.9 6.3l-2.59 2.6-4.2-4.21 3.96-3.97a2.97 2.97 0 014.2 4.21l-.66.67.33.34a2 2 0 010 2.82l-.94.94a.5.5 0 01-.7-.7l.94-.94a1 1 0 000-1.42l-.34-.33z",
    fill: primaryFill
  }));
};

export const PenOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PenOffFilledIcon({}), 'PenOffFilled');

const PenOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l5.4 5.4-4 4c-.33.32-.56.74-.66 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.88c.47-.1.9-.33 1.24-.67l3.98-3.98 5.4 5.4a.5.5 0 00.7-.71l-15-15zm8.2 9.6l-3.99 3.98c-.2.2-.46.35-.74.4l-3.16.71.7-3.18c.07-.27.2-.51.4-.7l3.99-4 2.8 2.79zm5.37-5.38l-3.96 3.97.7.7 2.59-2.58.34.33a1 1 0 010 1.42l-.94.94a.5.5 0 10.7.7l.94-.94a2 2 0 000-2.82l-.33-.34.67-.67a2.97 2.97 0 00-4.21-4.2L8.96 6.83l.7.7 3.97-3.96a1.97 1.97 0 012.79 2.8z",
    fill: primaryFill
  }));
};

export const PenOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PenOffRegularIcon({}), 'PenOffRegular');

const PenProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.18 2.93a2.97 2.97 0 00-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16A5.5 5.5 0 0115 9.2l2.13-2.12a2.97 2.97 0 00.05-4.15zM9 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 01-2.8 5.6z",
    fill: primaryFill
  }));
};

export const PenProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PenProhibitedFilledIcon({}), 'PenProhibitedFilled');

const PenProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.92 2.87a2.97 2.97 0 014.2 4.2L15 9.22c-.39-.11-.8-.18-1.21-.2l2.63-2.64a1.97 1.97 0 00-2.8-2.79l-9.37 9.37c-.2.2-.32.44-.38.7l-.71 3.2 3.16-.71c.28-.06.54-.2.74-.41l.95-.95c.02.42.09.83.2 1.22l-.44.44c-.34.34-.77.57-1.24.67L2.61 18a.5.5 0 01-.6-.6l.88-3.95c.1-.45.33-.87.66-1.2l9.37-9.37zM9 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 01-2.8 5.6z",
    fill: primaryFill
  }));
};

export const PenProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PenProhibitedRegularIcon({}), 'PenProhibitedRegular');

const PentagonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.76 1.66a2.5 2.5 0 00-3.37-.01L2.82 6.7a2.5 2.5 0 00-.67 2.7l2.15 5.95A2.5 2.5 0 006.65 17h6.83a2.5 2.5 0 002.36-1.7l2.03-6.02a2.5 2.5 0 00-.68-2.64l-5.43-4.98z",
    fill: primaryFill
  }));
};

export const PentagonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PentagonFilledIcon({}), 'PentagonFilled');

const PentagonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.4 1.65a2.5 2.5 0 013.36 0l5.43 4.99c.73.67 1 1.7.68 2.64l-2.03 6.02a2.5 2.5 0 01-2.36 1.7H6.65c-1.05 0-2-.66-2.35-1.65L2.15 9.4a2.5 2.5 0 01.67-2.7L8.4 1.65zm2.69.74a1.5 1.5 0 00-2.03 0L3.5 7.44a1.5 1.5 0 00-.4 1.62l2.15 5.95c.21.6.78.99 1.4.99h6.84a1.5 1.5 0 001.42-1.02l2.02-6.02a1.5 1.5 0 00-.4-1.58l-5.43-4.99z",
    fill: primaryFill
  }));
};

export const PentagonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PentagonRegularIcon({}), 'PentagonRegular');

const PeopleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 012 2v1.5c0 2.05-2.09 3.5-5.5 3.5S2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm5 0a2 2 0 012 2v.5c0 2.09-1.57 3.5-4.5 3.5l-.41-.01c.54-.63.85-1.39.9-2.25l.01-.24V12c0-.7-.23-1.33-.63-1.84l-.13-.16H16zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm7 2a2.5 2.5 0 110 5 2.5 2.5 0 010-5z",
    fill: primaryFill
  }));
};

export const PeopleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleFilledIcon({}), 'PeopleFilled');

const PeopleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 012 2v1.5c0 2.05-2.09 3.5-5.5 3.5S2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm0 1H4a1 1 0 00-1 1v1.5C3 14.9 4.58 16 7.5 16s4.5-1.1 4.5-2.5V12a1 1 0 00-1-1zm5-1a2 2 0 012 2v.5c0 2.09-1.57 3.5-4.5 3.5l-.41-.01c.2-.24.38-.5.52-.78l.1-.21h.03c2.24-.07 3.26-1.04 3.26-2.5V12a1 1 0 00-1-1h-2.17a3 3 0 00-.6-1H16zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm7 2a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm-7-1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm7 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const PeopleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleRegularIcon({}), 'PeopleRegular');

const PeopleAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10c.1 0 .2 0 .3.02a5.5 5.5 0 00-1.8 6.79c-.6.12-1.27.19-2 .19C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm6-3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PeopleAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleAddFilledIcon({}), 'PeopleAddFilled');

const PeopleAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10c.1 0 .2 0 .3.02-.39.28-.74.61-1.04.98H4a1 1 0 00-1 1v1.5C3 14.9 4.58 16 7.5 16c.62 0 1.17-.05 1.67-.14.08.33.2.65.34.95-.6.12-1.28.19-2.01.19C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm6-3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM14.5 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-7-3a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PeopleAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleAddRegularIcon({}), 'PeopleAddRegular');

const PeopleAudienceFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.21 5.22a2.23 2.23 0 10-4.45 0 2.23 2.23 0 004.45 0zM2.51 12h3V8.83c.03-.3.12-.57.26-.82H3.02l-.12.01a1 1 0 00-.88 1v2.48c0 .28.22.5.5.5zM18 11.5a.5.5 0 01-.5.5h-3.02V8.87c-.02-.31-.12-.6-.26-.86h2.78a1 1 0 011 .89v2.6zm-4.52-2.6a1 1 0 00-1-.89H7.5l-.11.01a1 1 0 00-.89 1V12h6.97V8.9zm1.5-5.28a1.91 1.91 0 110 3.82 1.91 1.91 0 010-3.82zM6.93 5.53a1.91 1.91 0 10-3.83 0 1.91 1.91 0 003.83 0zM2.5 13a.5.5 0 00-.5.5v1A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5v-1a.5.5 0 00-.5-.5h-15z",
    fill: primaryFill
  }));
};

export const PeopleAudienceFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleAudienceFilledIcon({}), 'PeopleAudienceFilled');

const PeopleAudienceRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.99 2.99a2.23 2.23 0 110 4.45 2.23 2.23 0 010-4.45zm0 1a1.23 1.23 0 100 2.45 1.23 1.23 0 000-2.45zM3.02 11.5a.5.5 0 11-1 0V9.01a1 1 0 01.88-.99h2.87c-.14.24-.23.52-.26.81v.18H3v2.49zm14.47.5a.5.5 0 00.5-.5V8.9a1 1 0 00-1-.89h-2.78c.14.26.24.55.26.86V9H17v2.49c0 .28.22.5.5.5zm-5.02-3.99a1 1 0 011 .89v2.6a.5.5 0 11-1 0V9.01H7.5v2.49a.5.5 0 11-1 0V9.01a1 1 0 01.89-.99h5.08zm4.42-2.48a1.91 1.91 0 10-3.83 0 1.91 1.91 0 003.83 0zm-2.83 0a.91.91 0 111.83 0 .91.91 0 01-1.83 0zM5.02 3.62a1.91 1.91 0 110 3.82 1.91 1.91 0 010-3.82zm0 1a.91.91 0 100 1.82.91.91 0 000-1.82zM2.5 13a.5.5 0 00-.5.5v1A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5v-1a.5.5 0 00-.5-.5h-15zm.5 1.5V14h14v.5c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 14.5z",
    fill: primaryFill
  }));
};

export const PeopleAudienceRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleAudienceRegularIcon({}), 'PeopleAudienceRegular');

const PeopleCallFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 012 2v1.5c0 2.05-2.09 3.5-5.5 3.5S2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm3.45 4.61c-.2-.04-.4-.05-.6-.03.08-.27.13-.55.14-.84l.01-.24V12c0-.7-.23-1.33-.63-1.84l-.13-.16h2.04l-.38.9-.05.15v.02c-.23.74-.04 1.57.53 2.11l.48.46a3.02 3.02 0 01-.7 1.2l-.53-.18-.16-.04h-.02zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm7 2a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm1.33 7.26l.4-.94a.96.96 0 011.08-.59l.1.03.5.16c.49.16.87.58 1 1.11.28 1.27-.07 2.81-1.06 4.63-.99 1.82-2.07 2.9-3.25 3.28a1.4 1.4 0 01-1.32-.27l-.1-.1-.38-.38c-.32-.33-.4-.85-.17-1.26l.05-.09.58-.84a.95.95 0 01.98-.4l.1.02 1.05.35a4.03 4.03 0 001.53-2.46l.03-.22-.88-.83c-.29-.28-.4-.7-.27-1.1l.03-.1z",
    fill: primaryFill
  }));
};

export const PeopleCallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleCallFilledIcon({}), 'PeopleCallFilled');

const PeopleCallRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 012 2v1.5c0 2.05-2.09 3.5-5.5 3.5S2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm-7 1a1 1 0 00-1 1v1.5C3 14.9 4.58 16 7.5 16s4.5-1.1 4.5-2.5V12a1 1 0 00-1-1H4zm11.16 3.84l-.07-.03.13-.03-.06.06zm-.26-3.94l-.03.1h-1.04a3 3 0 00-.6-1h2.05l-.38.9zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm7 1a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm1.33 6.26l.4-.94a.96.96 0 011.08-.59l.1.03.5.16c.49.16.87.58 1 1.11.28 1.27-.07 2.81-1.06 4.63-.99 1.82-2.07 2.9-3.25 3.28a1.4 1.4 0 01-1.32-.27l-.1-.1-.38-.38c-.32-.33-.4-.85-.17-1.26l.05-.09.58-.84a.95.95 0 01.98-.4l.1.02 1.05.35a4.03 4.03 0 001.53-2.46l.03-.22-.88-.83c-.29-.28-.4-.7-.27-1.1l.03-.1z",
    fill: primaryFill
  }));
};

export const PeopleCallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleCallRegularIcon({}), 'PeopleCallRegular');

const PeopleCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.3 10.02L11 10H4a2 2 0 00-2 2v1.5C2 15.55 4.09 17 7.5 17c.73 0 1.4-.07 2-.2a5.48 5.48 0 011.8-6.78zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM11 5.5a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zm8 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PeopleCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleCheckmarkFilledIcon({}), 'PeopleCheckmarkFilled');

const PeopleCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.3 10.02L11 10H4a2 2 0 00-2 2v1.5C2 15.55 4.09 17 7.5 17c.73 0 1.4-.07 2-.2-.13-.3-.25-.61-.33-.94-.5.1-1.05.14-1.67.14C4.58 16 3 14.9 3 13.5V12a1 1 0 011-1h6.26c.3-.37.65-.7 1.04-.98zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM13 6.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-2-1a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zm-6 0a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm14 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PeopleCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleCheckmarkRegularIcon({}), 'PeopleCheckmarkRegular');

const PeopleCommunityFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.88 7.5a2.74 2.74 0 114.24 3.49A2.74 2.74 0 017.88 7.5zm5.87 1.75c0-.63-.16-1.23-.43-1.75h4.18c.83 0 1.5.67 1.5 1.5v.5c0 1.59-1.2 3.21-3.31 3.78A2.5 2.5 0 0013.5 12h-.95a3.74 3.74 0 001.2-2.75zM13.5 13a1.5 1.5 0 011.5 1.5v.5c0 1.97-1.86 4-5 4-3.14 0-5-2.03-5-4v-.5A1.5 1.5 0 016.5 13h7zM1 9.5c0 1.59 1.2 3.21 3.31 3.78A2.5 2.5 0 016.5 12h.95a3.74 3.74 0 01-.77-4.5H2.5C1.67 7.5 1 8.17 1 9v.5zm7.75-5.75a2.75 2.75 0 10-5.5 0 2.75 2.75 0 005.5 0zm8 0a2.75 2.75 0 10-5.5 0 2.75 2.75 0 005.5 0z",
    fill: primaryFill
  }));
};

export const PeopleCommunityFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleCommunityFilledIcon({}), 'PeopleCommunityFilled');

const PeopleCommunityRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.75 3.75a2.75 2.75 0 10-5.5 0 2.75 2.75 0 005.5 0zm-4.5 0a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zM2.5 7.5h4.18c-.16.31-.28.65-.35 1H2.5A.5.5 0 002 9v.5c0 1.26 1.1 2.61 3.1 2.93-.33.22-.6.51-.79.85C2.21 12.71 1 11.08 1 9.5V9c0-.83.67-1.5 1.5-1.5zm5.38 0a2.74 2.74 0 114.24 3.49A2.74 2.74 0 017.88 7.5zm.54 1a1.74 1.74 0 00.87 2.35 1.74 1.74 0 002.46-1.6 1.74 1.74 0 00-2.01-1.73c-.59.09-1.08.46-1.32.98zm7.27 4.78c-.2-.34-.46-.63-.79-.85 2-.32 3.1-1.67 3.1-2.93V9a.5.5 0 00-.5-.5h-3.82c-.08-.35-.2-.69-.36-1h4.18c.83 0 1.5.67 1.5 1.5v.5c0 1.59-1.2 3.21-3.31 3.78zm-1.2.1a1.5 1.5 0 00-.99-.38h-7A1.5 1.5 0 005 14.5v.5c0 1.97 1.86 4 5 4 3.14 0 5-2.03 5-4v-.5c0-.45-.2-.85-.51-1.13zM6 14.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v.5c0 1.44-1.43 3-4 3-2.57 0-4-1.56-4-3v-.5zM14 1a2.75 2.75 0 110 5.5A2.75 2.75 0 0114 1zm0 1a1.75 1.75 0 100 3.5A1.75 1.75 0 0014 2z",
    fill: primaryFill
  }));
};

export const PeopleCommunityRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleCommunityRegularIcon({}), 'PeopleCommunityRegular');

const PeopleCommunityAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5a2.74 2.74 0 00-.39 5.47 5.52 5.52 0 013.14-2.69v-.03A2.74 2.74 0 0010 6.5zm8.68 4.42a5.49 5.49 0 00-4.94-1.87 3.73 3.73 0 00-.42-1.55h4.18c.83 0 1.5.67 1.5 1.5v.5c0 .48-.11.96-.32 1.42zM9.2 13a5.5 5.5 0 001.98 5.9c-.37.06-.77.1-1.19.1-3.14 0-5-2.03-5-4v-.5A1.5 1.5 0 016.5 13h2.7zm-4.9.28C2.21 12.71 1 11.08 1 9.5V9c0-.83.67-1.5 1.5-1.5h4.18a3.73 3.73 0 00.77 4.5H6.5a2.5 2.5 0 00-2.19 1.28zM6 1a2.75 2.75 0 110 5.5A2.75 2.75 0 016 1zm8 0a2.75 2.75 0 110 5.5A2.75 2.75 0 0114 1zm.5 18a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 010 1H15v1.5a.5.5 0 01-1 0V15h-1.5a.5.5 0 010-1H14v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const PeopleCommunityAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleCommunityAddFilledIcon({}), 'PeopleCommunityAddFilled');

const PeopleCommunityAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 1a2.75 2.75 0 110 5.5A2.75 2.75 0 016 1zm0 1a1.75 1.75 0 100 3.5A1.75 1.75 0 006 2zm.68 5.5H2.5C1.67 7.5 1 8.17 1 9v.5c0 1.59 1.2 3.21 3.31 3.78.2-.34.46-.63.79-.85-2-.32-3.1-1.67-3.1-2.93V9c0-.28.22-.5.5-.5h3.83c.07-.35.19-.69.35-1zm3.32-1a2.74 2.74 0 00-.39 5.47c.19-.35.41-.69.67-1A1.76 1.76 0 018.42 8.5a1.75 1.75 0 013.25 1.28c.34-.2.7-.37 1.08-.5v-.03A2.75 2.75 0 0010 6.5zm8.68 4.42c-.24-.27-.5-.52-.78-.75.07-.22.1-.45.1-.67V9a.5.5 0 00-.5-.5h-3.82c-.08-.35-.2-.69-.36-1h4.18c.83 0 1.5.67 1.5 1.5v.5c0 .48-.11.96-.32 1.42zM9.2 13H6.5A1.5 1.5 0 005 14.5v.5c0 1.97 1.86 4 5 4 .42 0 .82-.04 1.2-.1a5.54 5.54 0 01-.95-.9H10c-2.57 0-4-1.56-4-3v-.5c0-.28.22-.5.5-.5h2.52c.03-.34.1-.68.19-1zm7.54-9.25a2.75 2.75 0 10-5.5 0 2.75 2.75 0 005.5 0zm-4.5 0a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 010 1H15v1.5a.5.5 0 01-1 0V15h-1.5a.5.5 0 010-1H14v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const PeopleCommunityAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleCommunityAddRegularIcon({}), 'PeopleCommunityAddRegular');

const PeopleEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 5.5a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zM14.5 9a2.51 2.51 0 001.93-.91A2.5 2.5 0 1014.5 9zm-3.52 5.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02zM11 10a2 2 0 011.8 1.14l-2.53 2.53c-.4.41-.7.92-.84 1.49l-.37 1.5-.05.24c-.47.06-.97.1-1.51.1C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7z",
    fill: primaryFill
  }));
};

export const PeopleEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleEditFilledIcon({}), 'PeopleEditFilled');

const PeopleEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 011.8 1.14l-.8.8a1 1 0 00-1-.94H4a1 1 0 00-1 1v1.5C3 14.9 4.58 16 7.5 16c.65 0 1.24-.05 1.76-.16l-.2.81-.05.25c-.47.06-.97.1-1.51.1C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm4.8-.45a1.87 1.87 0 112.65 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02l4.83-4.83zM14.5 9a2.51 2.51 0 001.93-.91A2.5 2.5 0 1014.5 9zm0-4a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7-3a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",
    fill: primaryFill
  }));
};

export const PeopleEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleEditRegularIcon({}), 'PeopleEditRegular');

const PeopleErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm7 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-3.2 1.02L11 10H4a2 2 0 00-2 2v1.5C2 15.55 4.09 17 7.5 17c.73 0 1.4-.07 2-.2a5.48 5.48 0 011.8-6.78zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const PeopleErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleErrorFilledIcon({}), 'PeopleErrorFilled');

const PeopleErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm7 6a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM13 6.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-1.7 3.52L11 10H4a2 2 0 00-2 2v1.5C2 15.55 4.09 17 7.5 17c.73 0 1.4-.07 2-.2-.13-.3-.25-.61-.33-.94-.5.1-1.05.14-1.67.14C4.58 16 3 14.9 3 13.5V12a1 1 0 011-1h6.26c.3-.37.65-.7 1.04-.98zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const PeopleErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleErrorRegularIcon({}), 'PeopleErrorRegular');

const PeopleListFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 012 2h-.5c-.83 0-1.5.67-1.5 1.5v2.82c-.9.43-2.09.68-3.5.68C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm6.5 2c.18 0 .34.03.5.09V12a2 2 0 00-2-2h-2.76l.13.16c.4.51.63 1.15.63 1.84h3.5zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm7 2a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm-2 9a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 2a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 2a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const PeopleListFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleListFilledIcon({}), 'PeopleListFilled');

const PeopleListRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 012 2h-.5c-.18 0-.34.03-.5.09V12a1 1 0 00-1-1H4a1 1 0 00-1 1v1.5C3 14.9 4.58 16 7.5 16c1.56 0 2.74-.31 3.5-.82v1.14c-.9.43-2.09.68-3.5.68C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm6.5 2c.18 0 .34.03.5.09V12a2 2 0 00-2-2h-2.76a3 3 0 01.59 1H16a1 1 0 011 1h.5zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm7 1a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-2 8a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 2a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 2a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const PeopleListRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleListRegularIcon({}), 'PeopleListRegular');

const PeopleLockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 011.7.94 3 3 0 00-.2 1.06v.06A2 2 0 0011 14v2.32c-.9.43-2.09.68-3.5.68C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm1 4a1 1 0 011-1h.5v-1a1.99 1.99 0 012-2 2 2 0 012 2v1h.5a1 1 0 011 1v4a1 1 0 01-1 1h-5a1 1 0 01-1-1v-4zm4.07 1.51a.75.75 0 00-.57-.26.75.75 0 10.57.26zM15.5 11a1 1 0 00-1 1v1h2v-1a1 1 0 00-1-1zm-2.25-.98l.01-.02h-.02v.02zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm7 2a2.5 2.5 0 110 5 2.5 2.5 0 010-5z",
    fill: primaryFill
  }));
};

export const PeopleLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleLockFilledIcon({}), 'PeopleLockFilled');

const PeopleLockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 011.7.94 3 3 0 00-.2 1.06v.06c-.18.05-.35.12-.5.2V12a1 1 0 00-1-1H4a1 1 0 00-1 1v1.5C3 14.9 4.58 16 7.5 16c1.56 0 2.74-.31 3.5-.82v1.14c-.9.43-2.09.68-3.5.68C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm1 4a1 1 0 011-1h.5v-1a1.99 1.99 0 012-2 2 2 0 012 2v1h.5a1 1 0 011 1v4a1 1 0 01-1 1h-5a1 1 0 01-1-1v-4zm4.07 1.51a.75.75 0 00-.57-.26.75.75 0 10.57.26zM15.5 11a1 1 0 00-1 1v1h2v-1a1 1 0 00-1-1zm-2.25-.98l.01-.02h-.02l.01.02zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm7 1a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const PeopleLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleLockRegularIcon({}), 'PeopleLockRegular');

const PeopleMoneyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 012 2h-2a2 2 0 00-2 2v2.9c-.47.06-.97.1-1.5.1C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm2.37.16c.4.51.63 1.15.63 1.84h4a2 2 0 00-2-2h-2.76l.13.16zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm7 2a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM19 14.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5zM17.5 18c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5h1zm.5-3.5a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zm-6.5-.5a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const PeopleMoneyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleMoneyFilledIcon({}), 'PeopleMoneyFilled');

const PeopleMoneyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10a2 2 0 012 2h-1a1 1 0 00-1-1H4a1 1 0 00-1 1v1.5C3 14.9 4.58 16 7.5 16a9.6 9.6 0 001.5-.11v1c-.47.07-.97.11-1.5.11C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm6 2h1a2 2 0 00-2-2h-2.76a3 3 0 01.59 1H16a1 1 0 011 1zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm7 1a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm4.5 9.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5zM17.5 18c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5h1zm.5-3.5a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zm-6.5-.5a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const PeopleMoneyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleMoneyRegularIcon({}), 'PeopleMoneyRegular');

const PeopleProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm7 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-3.2 1.02L11 10H4a2 2 0 00-2 2v1.5C2 15.55 4.09 17 7.5 17c.73 0 1.4-.07 2-.2a5.48 5.48 0 011.8-6.78zM10 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm2.4 2.8l4.9-4.9a3.5 3.5 0 01-4.9 4.9zm-.7-.7a3.5 3.5 0 014.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const PeopleProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleProhibitedFilledIcon({}), 'PeopleProhibitedFilled');

const PeopleProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm7 6a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM13 6.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-1.7 3.52L11 10H4a2 2 0 00-2 2v1.5C2 15.55 4.09 17 7.5 17c.73 0 1.4-.07 2-.2-.13-.3-.25-.61-.33-.94-.5.1-1.05.14-1.67.14C4.58 16 3 14.9 3 13.5V12a1 1 0 011-1h6.26c.3-.37.65-.7 1.04-.98zM10 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm2.4 2.8l4.9-4.9a3.5 3.5 0 01-4.9 4.9zm-.7-.7a3.5 3.5 0 014.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const PeopleProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleProhibitedRegularIcon({}), 'PeopleProhibitedRegular');

const PeopleQueueFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.17 5.25a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM4.42 8a1 1 0 00-1 1v4.5a3.5 3.5 0 107 0V9a1 1 0 00-1-1h-5zm5.75-2.75c0 .65-.2 1.26-.52 1.76a2 2 0 011.08.48l.19.01A2.25 2.25 0 109.6 3.42c.36.52.57 1.15.57 1.83zm-.25 11.6a4.49 4.49 0 001.5-3.35V9a2 2 0 00-.27-1h2.27a1 1 0 011 1v4.5a3.5 3.5 0 01-4.5 3.35zm4.25-11.6c0 .65-.2 1.26-.52 1.76a2 2 0 011.08.48l.19.01a2.25 2.25 0 10-1.32-4.08c.36.52.57 1.15.57 1.83zm-.25 11.6a4.49 4.49 0 001.5-3.35V9a2 2 0 00-.27-1h2.27a1 1 0 011 1v4.5a3.5 3.5 0 01-4.5 3.35z",
    fill: primaryFill
  }));
};

export const PeopleQueueFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleQueueFilledIcon({}), 'PeopleQueueFilled');

const PeopleQueueRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 7.5a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm0-1a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM3 9a1 1 0 011-1h5a1 1 0 011 1v4.5a3.5 3.5 0 11-7 0V9zm1 0v4.5a2.5 2.5 0 005 0V9H4zm5.63-2.86c-.1.31-.23.6-.4.87a2 2 0 011.08.48l.19.01a2.25 2.25 0 10-1.31-4.08c.19.28.34.6.44.94a1.25 1.25 0 012.12.89 1.25 1.25 0 01-2.12.9zM9.5 16.85A3.5 3.5 0 0014 13.5V9a1 1 0 00-1-1h-2.27A2 2 0 0111 9h2v4.5a2.5 2.5 0 01-2.75 2.49c-.21.32-.47.6-.75.86zm4.13-10.7c-.1.3-.23.6-.4.86a2 2 0 011.08.48l.19.01a2.25 2.25 0 10-1.31-4.08c.19.28.34.6.44.94a1.25 1.25 0 012.12.89 1.25 1.25 0 01-2.12.9zm-.13 10.7A3.5 3.5 0 0018 13.5V9a1 1 0 00-1-1h-2.27A2 2 0 0115 9h2v4.5a2.5 2.5 0 01-2.75 2.49c-.21.32-.47.6-.75.86z",
    fill: primaryFill
  }));
};

export const PeopleQueueRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleQueueRegularIcon({}), 'PeopleQueueRegular');

const PeopleSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm4.87 14.8a8.53 8.53 0 01-3.97 1.17 1.5 1.5 0 00-.34-.53l-2-2A4.48 4.48 0 008.24 11H15a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8zM4.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 10.7-.7L7.3 15.6A3.5 3.5 0 104.5 17zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const PeopleSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleSearchFilledIcon({}), 'PeopleSearchFilled');

const PeopleSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm7.87 10.8a8.53 8.53 0 01-3.97 1.17 1.5 1.5 0 00-.34-.53l-.44-.44a8.07 8.07 0 004.2-1.05A3.36 3.36 0 0016 13a1 1 0 00-1-1H8.74c-.12-.36-.3-.7-.5-1H15a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8zM4.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 10.7-.7L7.3 15.6A3.5 3.5 0 104.5 17zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const PeopleSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleSearchRegularIcon({}), 'PeopleSearchRegular');

const PeopleSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10c.1 0 .2 0 .3.02a5.5 5.5 0 00-1.8 6.79c-.6.12-1.27.19-2 .19C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm6-3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm4.57 9.44a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PeopleSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleSettingsFilledIcon({}), 'PeopleSettingsFilled');

const PeopleSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10c.1 0 .2 0 .3.02-.39.28-.74.61-1.04.98H4a1 1 0 00-1 1v1.5C3 14.9 4.58 16 7.5 16c.62 0 1.17-.05 1.67-.14.08.33.2.65.34.95-.6.12-1.28.19-2.01.19C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm6-3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM14.5 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-7-3a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm4.57 8.44a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PeopleSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleSettingsRegularIcon({}), 'PeopleSettingsRegular');

const PeopleSwapFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 12a2 2 0 00-2-2H4a2 2 0 00-2 2v1.5C2 15.55 4.09 17 7.5 17c.46 0 .9-.03 1.3-.08l-.36-.36a1.5 1.5 0 010-2.12l2-2A1.5 1.5 0 0113 13.5V12zm4.8 1.69c.13-.37.2-.76.2-1.19V12a2 2 0 00-2-2h-2.76l.13.16c.4.51.63 1.15.63 1.84v1.5a1.5 1.5 0 012.56-1.06l1.25 1.25zM11 5.5a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zm6 1a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0zm-5.85 11.35a.5.5 0 00.7-.7L10.71 16h5.58l-1.14 1.15a.5.5 0 00.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7L16.29 15h-5.58l1.14-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2zM10.7 15h1.86-1.86z",
    fill: primaryFill
  }));
};

export const PeopleSwapFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleSwapFilledIcon({}), 'PeopleSwapFilled');

const PeopleSwapRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 12a2 2 0 00-2-2H4a2 2 0 00-2 2v1.5C2 15.55 4.09 17 7.5 17c.46 0 .9-.03 1.3-.08l-.36-.36a1.5 1.5 0 01-.36-.58L7.5 16C4.58 16 3 14.9 3 13.5V12a1 1 0 011-1h7a1 1 0 011 1v.09a1.5 1.5 0 011 1.41V12zm5 .5c0 .43-.07.82-.2 1.19l-.82-.83.02-.36V12a1 1 0 00-1-1h-2.17a3 3 0 00-.6-1H16a2 2 0 012 2v.5zm-7-7a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zm-6 0a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm12 1a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0zm-4 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-1.85 11.35a.5.5 0 00.7-.7L10.71 16h5.58l-1.14 1.15a.5.5 0 00.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7L16.29 15h-5.58l1.14-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2zm.1-2.85h1.32-1.33z",
    fill: primaryFill
  }));
};

export const PeopleSwapRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleSwapRegularIcon({}), 'PeopleSwapRegular');

const PeopleSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10c.1 0 .2 0 .3.02a5.5 5.5 0 00-1.8 6.79c-.6.12-1.27.19-2 .19C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm6-3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM7.5 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm7 17a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.5-7v.15a3.01 3.01 0 00-3.62.48.5.5 0 00.7.7 2 2 0 012.39-.33H15a.5.5 0 000 1h1.5a.5.5 0 00.5-.5V12a.5.5 0 00-1 0zm-1.55 5.25a3 3 0 002.17-.88.5.5 0 00-.7-.7 2 2 0 01-2.39.33H14a.5.5 0 000-1h-1.5a.5.5 0 00-.5.5V17a.5.5 0 001 0v-.15a3.01 3.01 0 001.45.4z",
    fill: primaryFill
  }));
};

export const PeopleSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleSyncFilledIcon({}), 'PeopleSyncFilled');

const PeopleSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10c.1 0 .2 0 .3.02-.39.28-.74.61-1.04.98H4a1 1 0 00-1 1v1.5C3 14.9 4.58 16 7.5 16c.62 0 1.17-.05 1.67-.14.08.33.2.65.34.95-.6.12-1.28.19-2.01.19C4.09 17 2 15.55 2 13.5V12c0-1.1.9-2 2-2h7zm6-3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM14.5 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-7-3a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm7 16a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.5-7v.15a3.01 3.01 0 00-3.62.48.5.5 0 00.7.7 2 2 0 012.39-.33H15a.5.5 0 000 1h1.5a.5.5 0 00.5-.5V12a.5.5 0 00-1 0zm-1.55 5.25a3 3 0 002.17-.88.5.5 0 00-.7-.7 2 2 0 01-2.39.33H14a.5.5 0 000-1h-1.5a.5.5 0 00-.5.5V17a.5.5 0 001 0v-.15a3.01 3.01 0 001.45.4z",
    fill: primaryFill
  }));
};

export const PeopleSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleSyncRegularIcon({}), 'PeopleSyncRegular');

const PeopleTeamFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 4.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm5 .5a2 2 0 11-4 0 2 2 0 014 0zm-13 2a2 2 0 100-4 2 2 0 000 4zM6 9.25C6 8.56 6.56 8 7.25 8h5.5c.69 0 1.25.56 1.25 1.25V14a4 4 0 01-8 0V9.25zm-1 0c0-.46.14-.9.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 003.4 2.97C5.14 15.37 5 14.7 5 14V9.25zM15 14c0 .7-.14 1.37-.4 1.97A3 3 0 0018 13V9.25C18 8.56 17.44 8 16.75 8h-2.13c.24.36.38.79.38 1.25V14z",
    fill: primaryFill
  }));
};

export const PeopleTeamFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTeamFilledIcon({}), 'PeopleTeamFilled');

const PeopleTeamRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM7.5 4.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm8-.5a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0zm-10 0a1 1 0 112 0 1 1 0 01-2 0zm1-2a2 2 0 100 4 2 2 0 000-4zm.6 12H5a2 2 0 01-2-2V9.25c0-.14.11-.25.25-.25h1.76c.04-.37.17-.7.37-1H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 003.4 2.97 4.96 4.96 0 01-.3-.97zm9.5.97A3 3 0 0018 13V9.25C18 8.56 17.44 8 16.75 8h-2.13c.2.3.33.63.37 1h1.76c.14 0 .25.11.25.25V13a2 2 0 01-2.1 2c-.07.34-.17.66-.3.97zM7.25 8C6.56 8 6 8.56 6 9.25V14a4 4 0 008 0V9.25C14 8.56 13.44 8 12.75 8h-5.5zM7 9.25c0-.14.11-.25.25-.25h5.5c.14 0 .25.11.25.25V14a3 3 0 11-6 0V9.25z",
    fill: primaryFill
  }));
};

export const PeopleTeamRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTeamRegularIcon({}), 'PeopleTeamRegular');

const PeopleTeamAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 4.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm5 .5a2 2 0 11-4 0 2 2 0 014 0zm-13 2a2 2 0 100-4 2 2 0 000 4zM6 9.25C6 8.56 6.56 8 7.25 8h5.5c.61 0 1.12.44 1.23 1.02A5.5 5.5 0 0010.25 18L10 18a4 4 0 01-4-4V9.25zm8.99-.23c1.14.1 2.18.55 3.01 1.24V9.25C18 8.56 17.44 8 16.75 8h-2.13c.2.3.33.65.37 1.02zM5 9.25c0-.46.14-.9.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 003.4 2.97C5.14 15.37 5 14.7 5 14V9.25zm14 5.25a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PeopleTeamAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTeamAddFilledIcon({}), 'PeopleTeamAddFilled');

const PeopleTeamAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 4.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM10 2a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm4.5 3a1 1 0 112 0 1 1 0 01-2 0zm1-2a2 2 0 100 4 2 2 0 000-4zm-11 1a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0zM5 15h.1c.07.34.17.66.3.97A3 3 0 012 13V9.25C2 8.56 2.56 8 3.25 8h2.13c-.2.3-.33.63-.37 1H3.25a.25.25 0 00-.25.25V13c0 1.1.9 2 2 2zm8.97-6c-.11-.57-.62-1-1.22-1h-5.5C6.56 8 6 8.56 6 9.25V14a4 4 0 004.25 4 5.51 5.51 0 01-.66-1.03A3 3 0 017 14V9.25c0-.14.11-.25.25-.25h6.72zM15 9h1.76c.14 0 .25.11.25.25v.35c.36.18.7.4 1 .66V9.25C18 8.56 17.44 8 16.75 8h-2.13c.2.3.33.63.37 1zm-.49 1a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 2c.28 0 .5.22.5.5V14h1.5a.5.5 0 010 1H15v1.5a.5.5 0 01-1 0V15h-1.5a.5.5 0 010-1H14v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const PeopleTeamAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTeamAddRegularIcon({}), 'PeopleTeamAddRegular');

const PeopleTeamDeleteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 4.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm5 .5a2 2 0 11-4 0 2 2 0 014 0zm-13 2a2 2 0 100-4 2 2 0 000 4zM6 9.25C6 8.56 6.56 8 7.25 8h5.5c.61 0 1.12.44 1.23 1.02A5.5 5.5 0 0010.25 18L10 18a4 4 0 01-4-4V9.25zm8.99-.23c1.14.1 2.18.55 3.01 1.24V9.25C18 8.56 17.44 8 16.75 8h-2.13c.2.3.33.65.37 1.02zM5 9.25c0-.46.14-.9.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 003.4 2.97C5.14 15.37 5 14.7 5 14V9.25zm14 5.25a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-3.8 0l1.15-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15z",
    fill: primaryFill
  }));
};

export const PeopleTeamDeleteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTeamDeleteFilledIcon({}), 'PeopleTeamDeleteFilled');

const PeopleTeamDeleteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 4.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM10 2a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm4.5 3a1 1 0 112 0 1 1 0 01-2 0zm1-2a2 2 0 100 4 2 2 0 000-4zm-11 1a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0zM5 15h.1c.07.34.17.66.3.97A3 3 0 012 13V9.25C2 8.56 2.56 8 3.25 8h2.13c-.2.3-.33.63-.37 1H3.25a.25.25 0 00-.25.25V13c0 1.1.9 2 2 2zm8.97-6c-.11-.57-.62-1-1.22-1h-5.5C6.56 8 6 8.56 6 9.25V14a4 4 0 004.25 4 5.51 5.51 0 01-.66-1.03A3 3 0 017 14V9.25c0-.14.11-.25.25-.25h6.72zM18 10.26V9.25C18 8.56 17.44 8 16.75 8h-2.13c.2.3.33.63.37 1h1.76c.14 0 .25.11.25.25v.35c.36.18.7.4 1 .66zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-5.65l-1.14 1.15 1.14 1.15a.5.5 0 01-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const PeopleTeamDeleteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTeamDeleteRegularIcon({}), 'PeopleTeamDeleteRegular');

const PeopleTeamToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 4.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm5 .5a2 2 0 11-4 0 2 2 0 014 0zm-13 2a2 2 0 100-4 2 2 0 000 4zM6 9.25C6 8.56 6.56 8 7.25 8h5.5c.6 0 1.1.43 1.22 1h-.47a2.5 2.5 0 00-2.46 2.04A2.5 2.5 0 009 13.5v4c0 .13.01.26.03.38A4 4 0 016 14V9.25zm11.96 1.8H18v-1.8C18 8.56 17.44 8 16.75 8h-2.13c.2.3.33.63.37 1h.51a2.5 2.5 0 012.46 2.04zM5 9.24c0-.46.14-.9.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 003.4 2.97C5.14 15.37 5 14.7 5 14V9.25zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const PeopleTeamToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTeamToolboxFilledIcon({}), 'PeopleTeamToolboxFilled');

const PeopleTeamToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 4.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM10 2a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm4.5 3a1 1 0 112 0 1 1 0 01-2 0zm1-2a2 2 0 100 4 2 2 0 000-4zm-11 1a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0zM5 15h.1c.07.34.17.66.3.97A3 3 0 012 13V9.25C2 8.56 2.56 8 3.25 8h2.13c-.2.3-.33.63-.37 1H3.25a.25.25 0 00-.25.25V13c0 1.1.9 2 2 2zm12-5.5c.5.37.84.91.96 1.54l.04.01v-1.8C18 8.56 17.44 8 16.75 8h-2.13c.2.3.33.63.37 1h1.76c.14 0 .25.11.25.25v.25zm-1.5.5h-2c-.83 0-1.5.67-1.5 1.5v.5h-.5c-.83 0-1.5.67-1.5 1.5V15h2v-.5a.5.5 0 011 0v.5h3v-.5a.5.5 0 011 0v.5h2v-1.5c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5zM7.25 9a.25.25 0 00-.25.25V14a3 3 0 002 2.83v.67c0 .13.01.26.03.38A4 4 0 016 14V9.25C6 8.56 6.56 8 7.25 8h5.5c.6 0 1.1.43 1.22 1H7.25zM13 12v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v.5h-3zm4 4v.5a.5.5 0 01-1 0V16h-3v.5a.5.5 0 01-1 0V16h-2v1.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V16h-2z",
    fill: primaryFill
  }));
};

export const PeopleTeamToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTeamToolboxRegularIcon({}), 'PeopleTeamToolboxRegular');

const PeopleToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.46 10.05A2 2 0 0011 10H4a2 2 0 00-2 2v1.5C2 15.55 4.09 17 7.5 17c.53 0 1.03-.04 1.5-.1v-3.4a2.5 2.5 0 012.04-2.46c.07-.36.21-.7.42-.99zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM11 5.5a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zm1 6v.5h-.5c-.83 0-1.5.67-1.5 1.5V15h2v-.5a.5.5 0 011 0v.5h3v-.5a.5.5 0 011 0v.5h2v-1.5c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5zm5.5 5h-2v.5a.5.5 0 01-1 0V16h-3v.5a.5.5 0 01-1 0V16h-2v1.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V16z",
    fill: primaryFill
  }));
};

export const PeopleToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleToolboxFilledIcon({}), 'PeopleToolboxFilled');

const PeopleToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.46 10.05A2 2 0 0011 10H4a2 2 0 00-2 2v1.5C2 15.55 4.09 17 7.5 17c.53 0 1.03-.04 1.5-.1v-1.01a9.6 9.6 0 01-1.5.11C4.58 16 3 14.9 3 13.5V12a1 1 0 011-1h7.05c.07-.35.21-.67.41-.95zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM13 6.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-2-1a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zm-6 0a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm7 6v.5h-.5c-.83 0-1.5.67-1.5 1.5V15h2v-.5a.5.5 0 011 0v.5h3v-.5a.5.5 0 011 0v.5h2v-1.5c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5zm5.5 5h-2v.5a.5.5 0 01-1 0V16h-3v.5a.5.5 0 01-1 0V16h-2v1.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V16z",
    fill: primaryFill
  }));
};

export const PeopleToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleToolboxRegularIcon({}), 'PeopleToolboxRegular');

const PersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0010 18c1.85 0 3.58-.39 4.87-1.2A4.35 4.35 0 0017 13a2 2 0 00-2-2H5z",
    fill: primaryFill
  }));
};

export const PersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonFilledIcon({}), 'PersonFilled');

const PersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0010 18c1.85 0 3.58-.39 4.87-1.2A4.35 4.35 0 0017 13a2 2 0 00-2-2H5zm-1 2a1 1 0 011-1h10a1 1 0 011 1c0 1.3-.62 2.28-1.67 2.95A8.16 8.16 0 0110 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 014 13z",
    fill: primaryFill
  }));
};

export const PersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonRegularIcon({}), 'PersonRegular');

const Person5FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0010 18c.82 0 1.62-.08 2.37-.23l-.3-.34a1.5 1.5 0 01.51-2.28.25.25 0 00.06-.4l-.17-.16a1.5 1.5 0 01-.47-1.21l.2-2.38H5zm8.75-1a.5.5 0 00-.5.46l-.25 3a.5.5 0 00.57.54l.24-.04a139.91 139.91 0 011.72-.22c.58-.05.95.17 1.17.49.24.33.35.83.28 1.33-.07.5-.31.93-.67 1.18-.35.25-.87.38-1.65.13a2.49 2.49 0 01-.55-.28 2.2 2.2 0 01-.48-.4.5.5 0 00-.77.63 3.46 3.46 0 001.5 1c1.01.33 1.88.2 2.53-.26.63-.45.98-1.16 1.08-1.86.1-.7-.04-1.47-.45-2.05a2.2 2.2 0 00-2.07-.9l-1.19.14-.21.03.16-1.92h3.04a.5.5 0 100-1h-3.5z",
    fill: primaryFill
  }));
};

export const Person5Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Person5FilledIcon({}), 'Person5Filled');

const Person5RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0010 18c.82 0 1.62-.08 2.37-.23l-.3-.34a1.5 1.5 0 01-.28-.57c-.56.1-1.16.14-1.79.14a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 014 13a1 1 0 011-1h7.12l.08-1H5zm8.75-1a.5.5 0 00-.5.46l-.25 3a.5.5 0 00.57.54l.24-.04a139.91 139.91 0 011.72-.22c.58-.05.95.17 1.17.49.24.33.35.83.28 1.33-.07.5-.31.93-.67 1.18-.35.25-.87.38-1.65.13a2.49 2.49 0 01-.55-.28 2.2 2.2 0 01-.48-.4.5.5 0 00-.77.63 3.46 3.46 0 001.5 1c1.01.33 1.88.2 2.53-.26.63-.45.98-1.16 1.08-1.86.1-.7-.04-1.47-.45-2.05a2.2 2.2 0 00-2.07-.9l-1.19.14-.21.03.16-1.92h3.04a.5.5 0 100-1h-3.5z",
    fill: primaryFill
  }));
};

export const Person5Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Person5RegularIcon({}), 'Person5Regular');

const Person6FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6a4 4 0 118 0 4 4 0 01-8 0zm-3 7a2 2 0 012-2h6.43a3.73 3.73 0 00-.43 1.75v3c0 .8.25 1.53.67 2.14-.54.07-1.1.11-1.67.11a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 013 13zm10-.25a1.75 1.75 0 013.11-1.1.5.5 0 00.78-.63A2.75 2.75 0 0012 12.75v3a2.75 2.75 0 101-2.12v-.88zm1.75 4.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5z",
    fill: primaryFill
  }));
};

export const Person6Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Person6FilledIcon({}), 'Person6Filled');

const Person6RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6a4 4 0 118 0 4 4 0 01-8 0zm4-3a3 3 0 100 6 3 3 0 000-6zM3 13a2 2 0 012-2h6.43c-.16.31-.28.65-.36 1H5.01A1 1 0 004 13c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 0010 17c.41 0 .8-.02 1.2-.06.1.34.27.66.47.95-.54.07-1.1.11-1.67.11a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 013 13zm10-.25a1.75 1.75 0 013.11-1.1.5.5 0 00.78-.63A2.75 2.75 0 0012 12.75v3a2.75 2.75 0 101-2.12v-.88zm1.75 4.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5z",
    fill: primaryFill
  }));
};

export const Person6Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Person6RegularIcon({}), 'Person6Regular');

const PersonAccountsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18h.05a2.51 2.51 0 01-.05-.5v-4a2.5 2.5 0 012.04-2.46l.01-.04H4.01zm8 .5v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const PersonAccountsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonAccountsFilledIcon({}), 'PersonAccountsFilled');

const PersonAccountsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18h.05a2.51 2.51 0 01-.05-.5V17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.5c.37-.5.91-.84 1.54-.96l.01-.04H4.01zm8 .5v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const PersonAccountsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonAccountsRegularIcon({}), 'PersonAccountsRegular');

const PersonAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm10.5 8a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 010 1H15v1.5a.5.5 0 01-1 0V15h-1.5a.5.5 0 010-1H14v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const PersonAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonAddFilledIcon({}), 'PersonAddFilled');

const PersonAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm10.5 8a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 010 1H15v1.5a.5.5 0 01-1 0V15h-1.5a.5.5 0 010-1H14v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const PersonAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonAddRegularIcon({}), 'PersonAddRegular');

const PersonArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm15 3.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const PersonArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonArrowLeftFilledIcon({}), 'PersonArrowLeftFilled');

const PersonArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm15 3.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const PersonArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonArrowLeftRegularIcon({}), 'PersonArrowLeftRegular');

const PersonArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm15 3.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const PersonArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonArrowRightFilledIcon({}), 'PersonArrowRightFilled');

const PersonArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm15 3.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const PersonArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonArrowRightRegularIcon({}), 'PersonArrowRightRegular');

const PersonAvailableFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 118 0 4 4 0 01-8 0zm-3 7a2 2 0 012-2h6.26a5.48 5.48 0 00-.05 6.94c-.4.04-.8.06-1.21.06a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 012 13zm17 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PersonAvailableFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonAvailableFilledIcon({}), 'PersonAvailableFilled');

const PersonAvailableRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 118 0 4 4 0 01-8 0zm4-3a3 3 0 100 6 3 3 0 000-6zM2 13a2 2 0 012-2h6.26c-.26.3-.48.64-.66 1H4a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 009 17l.6-.01c.17.34.37.66.61.95-.4.04-.8.06-1.21.06a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 012 13zm17 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PersonAvailableRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonAvailableRegularIcon({}), 'PersonAvailableRegular');

const PersonBoardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3V6a3 3 0 00-3-3H6zm4.75 3.25a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm1.75 4c0 .59-.15 2.5-3.5 2.5-3.36 0-3.5-1.93-3.5-2.5a1 1 0 011-1h5a1 1 0 011 1zM5.76 16A3 3 0 008 17h4.5a4.5 4.5 0 004.5-4.5V8a3 3 0 00-1-2.24v6.74a3.5 3.5 0 01-3.5 3.5H5.76z",
    fill: primaryFill
  }));
};

export const PersonBoardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonBoardFilledIcon({}), 'PersonBoardFilled');

const PersonBoardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 8.5a2 2 0 100-4 2 2 0 000 4zm0-1a1 1 0 110-2 1 1 0 010 2zM6.5 9C5.67 9 5 9.67 5 10.5c0 .33.04 1.05.62 1.68.59.63 1.63 1.07 3.38 1.07s2.79-.43 3.37-1.06A2.4 2.4 0 0013 10.5c0-.83-.67-1.5-1.5-1.5h-5zM6 10.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5 0 .25-.03.66-.36 1-.32.35-1.04.75-2.64.75s-2.32-.4-2.64-.75a1.41 1.41 0 01-.36-1zM3 6a3 3 0 013-3h6a3 3 0 013 3v6a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm3-2a2 2 0 00-2 2v6c0 1.1.9 2 2 2h6a2 2 0 002-2V6a2 2 0 00-2-2H6zm2 13a3 3 0 01-2.24-1h6.74a3.5 3.5 0 003.5-3.5V5.76A3 3 0 0117 8v4.5a4.5 4.5 0 01-4.5 4.5H8z",
    fill: primaryFill
  }));
};

export const PersonBoardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonBoardRegularIcon({}), 'PersonBoardRegular');

const PersonCallFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.88 0 1.73-.09 2.52-.27-.06-.43.02-.88.23-1.27l.01-.02.08-.14.59-.86c.44-.66 1.23-1 2.02-.83l.02.01.16.04.53.18a3.2 3.2 0 00.7-1.2l-.48-.46a2.07 2.07 0 01-.57-2A2 2 0 0014 11H4zm11.83.26l.4-.94a.96.96 0 011.08-.59l.1.03.5.16c.49.16.87.58 1 1.11.28 1.27-.07 2.81-1.06 4.63-.99 1.82-2.07 2.9-3.25 3.28a1.4 1.4 0 01-1.32-.27l-.1-.1-.38-.38c-.32-.33-.4-.85-.17-1.26l.05-.09.58-.84a.95.95 0 01.98-.4l.1.02 1.05.35a4.03 4.03 0 001.53-2.46l.03-.22-.88-.83c-.29-.28-.4-.7-.27-1.1l.03-.1z",
    fill: primaryFill
  }));
};

export const PersonCallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonCallFilledIcon({}), 'PersonCallFilled');

const PersonCallRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 118 0 4 4 0 01-8 0zm4-3a3 3 0 100 6 3 3 0 000-6zM2 13a2 2 0 012-2h10a2 2 0 01.81.17c-.1.44-.07.91.1 1.33h-.04A1 1 0 0014 12H4a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 009 17c.96 0 1.86-.11 2.65-.33-.14.34-.18.7-.13 1.06-.79.18-1.64.27-2.52.27a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 012 13zm13.83-1.74l.4-.94a.96.96 0 011.08-.59l.1.03.5.16c.49.16.87.58 1 1.11.28 1.27-.07 2.81-1.06 4.63-.99 1.82-2.07 2.9-3.25 3.28a1.4 1.4 0 01-1.32-.27l-.1-.1-.38-.38c-.32-.33-.4-.85-.17-1.26l.05-.09.58-.84a.95.95 0 01.98-.4l.1.02 1.05.35a4.03 4.03 0 001.53-2.46l.03-.22-.88-.83c-.29-.28-.4-.7-.27-1.1l.03-.1z",
    fill: primaryFill
  }));
};

export const PersonCallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonCallRegularIcon({}), 'PersonCallRegular');

const PersonChatFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8a8.54 8.54 0 004 1.17l.36-1.2a5.48 5.48 0 01.77-5.77H5zm14 3.5a4.5 4.5 0 01-6.68 3.94l-1.8.54a.4.4 0 01-.5-.5l.54-1.8A4.5 4.5 0 1119 14.5zM12.5 13a.5.5 0 000 1h4a.5.5 0 000-1h-4zm-.5 2.5c0 .28.22.5.5.5h2a.5.5 0 000-1h-2a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PersonChatFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonChatFilledIcon({}), 'PersonChatFilled');

const PersonChatRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8a8.54 8.54 0 004 1.17l.3-.98a7.74 7.74 0 01-3.76-1.04A3.36 3.36 0 014 13a1 1 0 011-1h4.6c.18-.36.4-.7.66-1H5zm14 3.5a4.5 4.5 0 01-6.68 3.94l-1.8.54a.4.4 0 01-.5-.5l.54-1.8A4.5 4.5 0 1119 14.5zM12.5 13a.5.5 0 000 1h4a.5.5 0 000-1h-4zm-.5 2.5c0 .28.22.5.5.5h2a.5.5 0 000-1h-2a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PersonChatRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonChatRegularIcon({}), 'PersonChatRegular');

const PersonCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a2 2 0 114 0 2 2 0 01-4 0zm-.5 3h5c.83 0 1.5.67 1.5 1.5 0 1.12-.46 2.01-1.21 2.61-.74.6-1.74.89-2.79.89a4.43 4.43 0 01-2.79-.89A3.25 3.25 0 016 11.5c0-.83.67-1.5 1.5-1.5z",
    fill: primaryFill
  }));
};

export const PersonCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonCircleFilledIcon({}), 'PersonCircleFilled');

const PersonCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 7a2 2 0 114 0 2 2 0 01-4 0zm-.5 3h5c.83 0 1.5.67 1.5 1.5 0 1.12-.46 2.01-1.21 2.61-.74.6-1.74.89-2.79.89a4.43 4.43 0 01-2.79-.89A3.25 3.25 0 016 11.5c0-.83.67-1.5 1.5-1.5zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const PersonCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonCircleRegularIcon({}), 'PersonCircleRegular');

const PersonClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 118 0 4 4 0 01-8 0zm-3 7a2 2 0 012-2h6.26a5.48 5.48 0 00-.05 6.94c-.4.04-.8.06-1.21.06a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 012 13zm17 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const PersonClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonClockFilledIcon({}), 'PersonClockFilled');

const PersonClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 118 0 4 4 0 01-8 0zm4-3a3 3 0 100 6 3 3 0 000-6zM2 13a2 2 0 012-2h6.26c-.26.3-.48.64-.66 1H4a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 009 17l.6-.01c.17.34.37.66.61.95-.4.04-.8.06-1.21.06a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 012 13zm17 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const PersonClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonClockRegularIcon({}), 'PersonClockRegular');

const PersonDeleteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 118 0 4 4 0 01-8 0zm-3 7a2 2 0 012-2h6.26a5.48 5.48 0 00-.05 6.94c-.4.04-.8.06-1.21.06a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 012 13zm17 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const PersonDeleteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonDeleteFilledIcon({}), 'PersonDeleteFilled');

const PersonDeleteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 118 0 4 4 0 01-8 0zm4-3a3 3 0 100 6 3 3 0 000-6zM2 13a2 2 0 012-2h6.26c-.26.3-.48.64-.66 1H4a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 009 17l.6-.01c.17.34.37.66.61.95-.4.04-.8.06-1.21.06a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 012 13zm17 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const PersonDeleteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonDeleteRegularIcon({}), 'PersonDeleteRegular');

const PersonEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8a8.46 8.46 0 003.88 1.16c0-.1.02-.2.05-.3l.37-1.5a3.2 3.2 0 01.84-1.49L13.94 11H5.01zm5.98 4.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const PersonEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonEditFilledIcon({}), 'PersonEditFilled');

const PersonEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8a8.46 8.46 0 003.88 1.16c0-.1.02-.2.05-.3l.17-.68a7.59 7.59 0 01-3.56-1.03A3.36 3.36 0 014 13a1 1 0 011-1h7.94l1-1H5.01zm5.98 4.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const PersonEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonEditRegularIcon({}), 'PersonEditRegular');

const PersonFeedbackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 12c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4-3.14 0-5-2.03-5-4v-.5c0-.83.67-1.5 1.5-1.5h7zM7 5.5A2.75 2.75 0 117 11a2.75 2.75 0 010-5.5zM16 2a2 2 0 012 1.85V6a2 2 0 01-1.85 2H14.5l-1.2 1.6a1 1 0 01-1.78-.38l-.01-.1V9l-.01-1.07-.08-.01a2 2 0 01-1.4-1.6l-.01-.17L10 6V4a2 2 0 011.85-2H16z",
    fill: primaryFill
  }));
};

export const PersonFeedbackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonFeedbackFilledIcon({}), 'PersonFeedbackFilled');

const PersonFeedbackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 12c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4-3.14 0-5-2.03-5-4v-.5c0-.83.67-1.5 1.5-1.5h7zm0 1h-7a.5.5 0 00-.5.5v.5c0 1.44 1.43 3 4 3 2.57 0 4-1.56 4-3v-.5a.5.5 0 00-.5-.5zM7 5.5A2.75 2.75 0 117 11a2.75 2.75 0 010-5.5zM16 2a2 2 0 012 1.85V6a2 2 0 01-1.85 2H14.5l-1.2 1.6a1 1 0 01-1.78-.38l-.01-.1V9l-.01-1.07-.08-.01a2 2 0 01-1.4-1.6l-.01-.17L10 6V4a2 2 0 011.85-2H16zM7 6.5A1.75 1.75 0 107 10a1.75 1.75 0 000-3.5zM16 3h-4a1 1 0 00-1 .88V6a1 1 0 00.88 1h.62v2L14 7h2a1 1 0 001-.88V4a1 1 0 00-.88-1H16z",
    fill: primaryFill
  }));
};

export const PersonFeedbackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonFeedbackRegularIcon({}), 'PersonFeedbackRegular');

const PersonInfoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm9.88 1.5a.62.62 0 111.24 0 .62.62 0 01-1.24 0zm1.12 4a.5.5 0 01-1 0v-2a.5.5 0 011 0v2zm-5-2a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm1 0a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    fill: primaryFill
  }));
};

export const PersonInfoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonInfoFilledIcon({}), 'PersonInfoFilled');

const PersonInfoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm9.88 1.5a.62.62 0 111.24 0 .62.62 0 01-1.24 0zm1.12 4a.5.5 0 01-1 0v-2a.5.5 0 011 0v2zm-5-2a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm1 0a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    fill: primaryFill
  }));
};

export const PersonInfoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonInfoRegularIcon({}), 'PersonInfoRegular');

const PersonKeyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A8.46 8.46 0 009 17.96V17c0-.41.16-.78.44-1.06l2.58-2.58a3.72 3.72 0 01.51-2.36H5.01zm5.15 7.85c.1.1.21.15.35.15h2c.11 0 .2-.03.27-.07.07-.04.12-.1.15-.17a.86.86 0 00.06-.24l.02-.25V18l.56-.02a.47.47 0 00.3-.12c.07-.07.11-.17.12-.3L14 17h.5c.1 0 .2-.02.27-.07a.5.5 0 00.15-.17.65.65 0 00.07-.24 2.34 2.34 0 00.01-.5v-.2c.17.07.35.11.52.14a2.87 2.87 0 002.62-.86A3.11 3.11 0 0019 13a2.94 2.94 0 00-.88-2.13 3 3 0 00-5.03 2.84l-2.94 2.94c-.1.1-.15.21-.15.35v1.5c0 .14.05.25.15.35zm7.13-7.13c.15.14.22.32.22.53 0 .2-.07.39-.22.53a.72.72 0 01-.53.22.72.72 0 01-.53-.22.72.72 0 01-.22-.53c0-.2.07-.39.22-.53a.72.72 0 01.53-.22c.2 0 .39.07.53.22z",
    fill: primaryFill
  }));
};

export const PersonKeyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonKeyFilledIcon({}), 'PersonKeyFilled');

const PersonKeyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A8.46 8.46 0 009 17.96V17v-.04a7.42 7.42 0 01-3.33-1A3.36 3.36 0 014 13a1 1 0 011-1h7.11a3.65 3.65 0 01.42-1H5.01zm5.15 7.85c.1.1.21.15.35.15h2c.11 0 .2-.03.27-.07.07-.04.12-.1.15-.17a.86.86 0 00.06-.24l.02-.25V18l.56-.02a.47.47 0 00.3-.12c.07-.07.11-.17.12-.3L14 17h.5c.1 0 .2-.02.27-.07a.5.5 0 00.15-.17.65.65 0 00.07-.24 2.34 2.34 0 00.01-.5v-.2c.17.07.35.11.52.14a2.87 2.87 0 002.62-.86A3.11 3.11 0 0019 13a2.94 2.94 0 00-.88-2.13 3 3 0 00-5.03 2.84l-2.94 2.94c-.1.1-.15.21-.15.35v1.5c0 .14.05.25.15.35zm7.13-7.13c.15.14.22.32.22.53 0 .2-.07.39-.22.53a.72.72 0 01-.53.22.72.72 0 01-.53-.22.72.72 0 01-.22-.53c0-.2.07-.39.22-.53a.72.72 0 01.53-.22c.2 0 .39.07.53.22z",
    fill: primaryFill
  }));
};

export const PersonKeyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonKeyRegularIcon({}), 'PersonKeyRegular');

const PersonLightbulbFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6a4 4 0 118 0 4 4 0 01-8 0zm-3 7a2 2 0 012-2h6.54a3.98 3.98 0 00.85 5.03l.33 1.66c-.85.2-1.77.31-2.72.31a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 013 13zm15 0a3 3 0 01-1.3 2.47l-.1.53h-3.2l-.1-.53A3 3 0 1118 13zm-4.4 4l.24 1.2c.1.46.5.8.98.8h.36a1 1 0 00.98-.8l.24-1.2h-2.8z",
    fill: primaryFill
  }));
};

export const PersonLightbulbFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonLightbulbFilledIcon({}), 'PersonLightbulbFilled');

const PersonLightbulbRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6a4 4 0 118 0 4 4 0 01-8 0zm4-3a3 3 0 100 6 3 3 0 000-6zM3 13a2 2 0 012-2h6.54c-.18.3-.32.65-.41 1H5A1 1 0 004 13c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 0010 17c.91 0 1.76-.1 2.52-.3l.2.99c-.85.2-1.77.31-2.72.31a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 013 13zm15 0a3 3 0 01-1.3 2.47l-.1.53h-3.2l-.1-.53A3 3 0 1118 13zm-4.4 4l.24 1.2c.1.46.5.8.98.8h.36a1 1 0 00.98-.8l.24-1.2h-2.8z",
    fill: primaryFill
  }));
};

export const PersonLightbulbRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonLightbulbRegularIcon({}), 'PersonLightbulbRegular');

const PersonLockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 118 0 4 4 0 01-8 0zm-3 7a2 2 0 012-2h8.67a3 3 0 00-.17 1v.06A2 2 0 0011 14v3.84c-.64.1-1.31.16-2 .16a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 012 13zm11.5 0v-1a2 2 0 114 0v1h.5a1 1 0 011 1v4a1 1 0 01-1 1h-5a1 1 0 01-1-1v-4a1 1 0 011-1h.5zm1-1v1h2v-1a1 1 0 10-2 0zm1.75 4a.75.75 0 10-1.5 0 .75.75 0 001.5 0z",
    fill: primaryFill
  }));
};

export const PersonLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonLockFilledIcon({}), 'PersonLockFilled');

const PersonLockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 118 0 4 4 0 01-8 0zm4-3a3 3 0 100 6 3 3 0 000-6zM2 13a2 2 0 012-2h8.67a3 3 0 00-.17 1H4a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 009 17c.7 0 1.38-.06 2-.18v1.02c-.64.1-1.31.16-2 .16a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 012 13zm11.5 0v-1a2 2 0 114 0v1h.5a1 1 0 011 1v4a1 1 0 01-1 1h-5a1 1 0 01-1-1v-4a1 1 0 011-1h.5zm1-1v1h2v-1a1 1 0 10-2 0zm1.75 4a.75.75 0 10-1.5 0 .75.75 0 001.5 0z",
    fill: primaryFill
  }));
};

export const PersonLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonLockRegularIcon({}), 'PersonLockRegular');

const PersonMailFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18v-5c0-1.1.9-2 2-2H4zm10.51 4.93l-4.5-2.63c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5l-4.49 2.43zm.23 1.01l4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3.05l4.25 2.48c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const PersonMailFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMailFilledIcon({}), 'PersonMailFilled');

const PersonMailRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18v-1a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.27A2 2 0 0111 11H4zm10.51 4.93l-4.5-2.63c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5l-4.49 2.43zm.23 1.01l4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3.05l4.25 2.48c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const PersonMailRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMailRegularIcon({}), 'PersonMailRegular');

const PersonMoneyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A8.46 8.46 0 009 17.96V14c0-1.1.9-2 2-2h5.73A2 2 0 0015 11H5zm14 3.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5zm-1 3v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5zm0-3a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zm-6.5-.5a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const PersonMoneyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMoneyFilledIcon({}), 'PersonMoneyFilled');

const PersonMoneyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A8.46 8.46 0 009 17.96v-1a7.42 7.42 0 01-3.33-1A3.36 3.36 0 014 13a1 1 0 011-1h11.73A2 2 0 0015 11H5zm14 3.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5zm-1 3v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5zm0-3a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zm-6.5-.5a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const PersonMoneyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMoneyRegularIcon({}), 'PersonMoneyRegular');

const PersonNoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8 1.1.69 2.5 1.07 4.03 1.17A3 3 0 019 17v-4c0-.77.29-1.47.76-2H5.01zm5 2c0-1.1.9-2 2-2h5a2 2 0 012 2v4a2 2 0 01-2 2h-5a2 2 0 01-2-2v-4zm6.5 3h-4a.5.5 0 100 1h4a.5.5 0 100-1zm-4-3a.5.5 0 100 1h4a.5.5 0 100-1h-4z",
    fill: primaryFill
  }));
};

export const PersonNoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonNoteFilledIcon({}), 'PersonNoteFilled');

const PersonNoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8 1.1.69 2.5 1.07 4.03 1.17A3 3 0 019 17v-.04a7.42 7.42 0 01-3.33-1A3.36 3.36 0 014 13a1 1 0 011-1h4.17a3 3 0 01.6-1H5zm5 2c0-1.1.9-2 2-2h5a2 2 0 012 2v4a2 2 0 01-2 2h-5a2 2 0 01-2-2v-4zm6.5 3h-4a.5.5 0 100 1h4a.5.5 0 100-1zm-4-3a.5.5 0 100 1h4a.5.5 0 100-1h-4z",
    fill: primaryFill
  }));
};

export const PersonNoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonNoteRegularIcon({}), 'PersonNoteRegular');

const PersonPillFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm2.88 9l-2.94 2.94a3.62 3.62 0 00-.75 4.03 8.59 8.59 0 01-4.06-1.17A4.35 4.35 0 013 13a2 2 0 012-2h7.88zm5.47-.35a2.62 2.62 0 00-3.7 0l-4 4a2.62 2.62 0 003.7 3.7l4-4a2.62 2.62 0 000-3.7zm-3 .7a1.62 1.62 0 112.3 2.3L16 15.29 13.7 13l1.65-1.65zm-1.5 4.3c.2.2.2.5 0 .7l-1 1a.5.5 0 01-.7-.7l1-1c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const PersonPillFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonPillFilledIcon({}), 'PersonPillFilled');

const PersonPillRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm5.88 5H5A2 2 0 003 13c0 1.7.83 2.97 2.13 3.8 1.1.7 2.52 1.08 4.06 1.17a3.61 3.61 0 01-.28-1.02 7.35 7.35 0 01-3.24-1A3.36 3.36 0 014 13a1 1 0 011-1h6.88l1-1zm5.47-.35a2.62 2.62 0 00-3.7 0l-4 4a2.62 2.62 0 003.7 3.7l4-4a2.62 2.62 0 000-3.7zm-3 .7a1.62 1.62 0 112.3 2.3L16 15.29 13.7 13l1.65-1.65zm-1.5 4.3c.2.2.2.5 0 .7l-1 1a.5.5 0 01-.7-.7l1-1c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const PersonPillRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonPillRegularIcon({}), 'PersonPillRegular');

const PersonProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm6 3.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm2.4 2.8l4.9-4.9a3.5 3.5 0 01-4.9 4.9zm-.7-.7a3.5 3.5 0 014.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const PersonProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonProhibitedFilledIcon({}), 'PersonProhibitedFilled');

const PersonProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm6 3.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm2.4 2.8l4.9-4.9a3.5 3.5 0 01-4.9 4.9zm-.7-.7a3.5 3.5 0 014.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const PersonProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonProhibitedRegularIcon({}), 'PersonProhibitedRegular');

const PersonQuestionMarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.62-2a.62.62 0 11-1.24 0 .62.62 0 011.24 0zm1.23-3.55c0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 01-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0c-.01-1.13.8-1.95 1.85-1.95 1.03 0 1.85.85 1.85 1.95zM9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4z",
    fill: primaryFill
  }));
};

export const PersonQuestionMarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonQuestionMarkFilledIcon({}), 'PersonQuestionMarkFilled');

const PersonQuestionMarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm10.5 8a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm.62-2a.62.62 0 10-1.24 0 .62.62 0 001.24 0zm1.23-3.55c0-1.1-.82-1.95-1.85-1.95-1.05 0-1.86.82-1.85 1.96a.5.5 0 101-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32z",
    fill: primaryFill
  }));
};

export const PersonQuestionMarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonQuestionMarkRegularIcon({}), 'PersonQuestionMarkRegular');

const PersonSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm6.64 2.92a2 2 0 001.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.71 4.71 0 010-1.01l.46-.12zm4.86.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const PersonSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSettingsFilledIcon({}), 'PersonSettingsFilled');

const PersonSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm6.64 2.92a2 2 0 001.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.71 4.71 0 010-1.01l.46-.12zm4.86.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const PersonSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSettingsRegularIcon({}), 'PersonSettingsRegular');

const PersonSubtractFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8a9.14 9.14 0 005.13 1.2 5.48 5.48 0 010-7H5zm14 3.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-7 0c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PersonSubtractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSubtractFilledIcon({}), 'PersonSubtractFilled');

const PersonSubtractRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8a9.14 9.14 0 005.13 1.2 5.5 5.5 0 01-.66-1 7.87 7.87 0 01-3.93-1.05A3.36 3.36 0 014 13a1 1 0 011-1h4.6c.18-.36.4-.7.66-1H5zm14 3.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-7 0c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PersonSubtractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSubtractRegularIcon({}), 'PersonSubtractRegular');

const PersonSupportFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.53 4a4 4 0 11-.14 3.72A1.5 1.5 0 015.5 8H5v.26c0 .19.07.36.2.5A.75.75 0 115.67 10 1.74 1.74 0 014 8.26V4.5c0-.28.23-.5.5-.5h2.03zM5 7h.5a.5.5 0 00.5-.5v-.37a4.08 4.08 0 010-.26V5H5v2zm-2 6a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 0110 18a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 013 13z",
    fill: primaryFill
  }));
};

export const PersonSupportFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSupportFilledIcon({}), 'PersonSupportFilled');

const PersonSupportRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.53 4a4 4 0 11-.14 3.72A1.5 1.5 0 015.5 8H5v.26c0 .19.07.36.2.5A.75.75 0 115.67 10 1.74 1.74 0 014 8.26V4.5c0-.28.23-.5.5-.5h2.03zM7 6.13a3 3 0 100-.24v.24zm-1-.26v-.85H5v2h.5a.5.5 0 00.5-.5v-.37a4.08 4.08 0 010-.28zM3 13a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 0110 18a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 013 13zm2-1a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 0010 17c1.74 0 3.26-.36 4.33-1.05A3.36 3.36 0 0016 13a1 1 0 00-1-1H5z",
    fill: primaryFill
  }));
};

export const PersonSupportRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSupportRegularIcon({}), 'PersonSupportRegular');

const PersonSwapFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.29 0 .57 0 .85-.03l-1.41-1.4a1.5 1.5 0 010-2.13l2-2A1.5 1.5 0 0112.9 14h1.18a1.5 1.5 0 011.65-1.98A2 2 0 0014 11H4zm7.85 6.85a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7L10.71 15h5.58l-1.14-1.15a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L16.29 16h-5.58l1.14 1.15c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const PersonSwapFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSwapFilledIcon({}), 'PersonSwapFilled');

const PersonSwapRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.29 0 .57 0 .85-.03L8.88 17a8.07 8.07 0 01-4.2-1.05A3.36 3.36 0 013 13a1 1 0 011-1h10a1 1 0 01.67.25c.32-.21.7-.3 1.07-.23A2 2 0 0014 11H4zm7.85 6.85a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7L10.71 15h5.58l-1.14-1.15a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L16.29 16h-5.58l1.14 1.15c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const PersonSwapRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSwapRegularIcon({}), 'PersonSwapRegular');

const PersonTagFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 116.65 3h-.14c-.8 0-1.52.38-1.98.96A4 4 0 015 6zm4.05 5H4.01A2 2 0 002 13c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.8 0 1.58-.07 2.31-.22l-1.6-1.63A2.52 2.52 0 019 14.4v-2.87c0-.18.02-.35.05-.52zm.95 3.4c0 .39.15.77.43 1.05l3.04 3.1c.58.59 1.52.6 2.12.03l2.95-2.84c.6-.58.62-1.55.02-2.15l-3.1-3.14a1.5 1.5 0 00-1.08-.45h-2.87c-.83 0-1.51.68-1.51 1.51v2.88zm2.75-.9a.75.75 0 110-1.5.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const PersonTagFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTagFilledIcon({}), 'PersonTagFilled');

const PersonTagRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 116.65 3h-.14c-.8 0-1.52.38-1.98.96A4 4 0 015 6zm4-3a3 3 0 100 6 3 3 0 000-6zm.05 8H4.01A2 2 0 002 13c0 1.7.83 2.97 2.14 3.8A9.14 9.14 0 009 18c.8 0 1.58-.07 2.31-.22l-.85-.87c-.47.06-.95.09-1.46.09a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5v-.48c0-.18.02-.35.05-.52zm.95 3.4c0 .39.15.77.43 1.05l3.04 3.1c.58.59 1.52.6 2.12.03l2.95-2.84c.6-.58.62-1.55.02-2.15l-3.1-3.14a1.5 1.5 0 00-1.08-.45h-2.87c-.83 0-1.51.68-1.51 1.51v2.88zm2.75-.9a.75.75 0 110-1.5.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const PersonTagRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTagRegularIcon({}), 'PersonTagRegular');

const PersonVoiceFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.85 1.15a.5.5 0 00-.7.7 6.6 6.6 0 011.72 4.65 6.6 6.6 0 01-1.72 4.65.5.5 0 00.7.7 7.6 7.6 0 002.03-5.35 7.6 7.6 0 00-2.03-5.35zm-2 2a.5.5 0 00-.7.7c.63.64.97 1.62.97 2.65 0 1.03-.34 2.01-.97 2.65a.5.5 0 00.7.7 4.76 4.76 0 001.28-3.35c0-1.22-.41-2.49-1.28-3.35zM4 7a4 4 0 118 0 4 4 0 01-8 0zm-3 7a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 018 19a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 011 14z",
    fill: primaryFill
  }));
};

export const PersonVoiceFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonVoiceFilledIcon({}), 'PersonVoiceFilled');

const PersonVoiceRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.85 1.15a.5.5 0 00-.7.7 6.6 6.6 0 011.72 4.65 6.6 6.6 0 01-1.72 4.65.5.5 0 00.7.7 7.6 7.6 0 002.03-5.35 7.6 7.6 0 00-2.03-5.35zm-2 2a.5.5 0 00-.7.7c.63.64.97 1.62.97 2.65 0 1.03-.34 2.01-.97 2.65a.5.5 0 00.7.7 4.76 4.76 0 001.28-3.35c0-1.22-.41-2.49-1.28-3.35zM4 7a4 4 0 118 0 4 4 0 01-8 0zm4-3a3 3 0 100 6 3 3 0 000-6zM1 14a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 018 19a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 011 14zm2-1a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 008 18c1.74 0 3.26-.36 4.33-1.05A3.36 3.36 0 0014 14a1 1 0 00-1-1H3z",
    fill: primaryFill
  }));
};

export const PersonVoiceRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonVoiceRegularIcon({}), 'PersonVoiceRegular');

const PhoneFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-7zM9 14h2a.5.5 0 010 1H9a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const PhoneFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneFilledIcon({}), 'PhoneFilled');

const PhoneRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 14a.5.5 0 000 1h2a.5.5 0 000-1H9zM7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 4a1 1 0 011-1h6a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4z",
    fill: primaryFill
  }));
};

export const PhoneRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneRegularIcon({}), 'PhoneRegular');

const PhoneAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 01-1.24-3H7.5a.5.5 0 010-1h1.52A5.5 5.5 0 0114 9.02V3.5c0-.83-.67-1.5-1.5-1.5h-7zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PhoneAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneAddFilledIcon({}), 'PhoneAddFilled');

const PhoneAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h7c.83 0 1.5.67 1.5 1.5v5.52c-.34.03-.68.1-1 .19V3.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h4.1c.18.36.4.7.66 1H5.5A1.5 1.5 0 014 16.5v-13zM9.02 14a5.57 5.57 0 000 1H7.5a.5.5 0 010-1h1.52zm9.98.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PhoneAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneAddRegularIcon({}), 'PhoneAddRegular');

const PhoneArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h7c.83 0 1.5.67 1.5 1.5v5.52A5.5 5.5 0 009.02 14H7.5a.5.5 0 000 1h1.52c.1 1.13.55 2.17 1.24 3H5.5A1.5 1.5 0 014 16.5v-13zM14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const PhoneArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneArrowRightFilledIcon({}), 'PhoneArrowRightFilled');

const PhoneArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 01-.66-1H5.5a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7c.32-.08.66-.15 1-.18V3.5c0-.83-.67-1.5-1.5-1.5h-7zM9 14.5c0-.17 0-.34.02-.5H7.5a.5.5 0 000 1h1.52a5.57 5.57 0 01-.02-.5zm5.5-4.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const PhoneArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneArrowRightRegularIcon({}), 'PhoneArrowRightRegular');

const PhoneCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L12.5 6.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7zM6.5 2h2.76A5.5 5.5 0 0015 10.8v5.7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13C5 2.67 5.67 2 6.5 2zM8 14.5c0 .28.22.5.5.5h3a.5.5 0 000-1h-3a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PhoneCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneCheckmarkFilledIcon({}), 'PhoneCheckmarkFilled');

const PhoneCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L12.5 6.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7zM9.25 2H6.5C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5.7c-.32.08-.66.15-1 .18v5.52a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h2.1c.18-.36.4-.7.66-1zM8 14.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneCheckmarkRegularIcon({}), 'PhoneCheckmarkRegular');

const PhoneDesktopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v3h2.5A2.5 2.5 0 019 9.5V13h3v2H9v1h5.5a.5.5 0 000-1H13v-2h3a2 2 0 002-2V4a2 2 0 00-2-2H6zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C8 8.67 7.33 8 6.5 8h-3zm.5 7.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktopFilledIcon({}), 'PhoneDesktopFilled');

const PhoneDesktopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3h10a1 1 0 011 1v7a1 1 0 01-1 1H9v1h3v2H9v1h5.5a.5.5 0 000-1H13v-2h3a2 2 0 002-2V4a2 2 0 00-2-2H6a2 2 0 00-2 2v3h1V4a1 1 0 011-1zM4.5 15a.5.5 0 000 1h1a.5.5 0 000-1h-1zM2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 012 16.5v-7zM3.5 9a.5.5 0 00-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-3z",
    fill: primaryFill
  }));
};

export const PhoneDesktopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktopRegularIcon({}), 'PhoneDesktopRegular');

const PhoneDesktopAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26V11a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1H9v-1h3v-2H9V9.5A2.5 2.5 0 006.5 7H4V4c0-1.1.9-2 2-2h4.26a5.5 5.5 0 004.24 9zm-11-3C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C8 8.67 7.33 8 6.5 8h-3zm.5 7.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktopAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktopAddFilledIcon({}), 'PhoneDesktopAddFilled');

const PhoneDesktopAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm2 7.5v-.6c.36-.18.7-.4 1-.66V11a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1H9v-1h3v-2H9v-1h7a1 1 0 001-1zm-6.74-9c-.26.3-.48.64-.66 1H6a1 1 0 00-1 1v3H4V4c0-1.1.9-2 2-2h4.26zM4 15.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm-2-6C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 012 16.5v-7zM3.5 9a.5.5 0 00-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-3z",
    fill: primaryFill
  }));
};

export const PhoneDesktopAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktopAddRegularIcon({}), 'PhoneDesktopAddRegular');

const PhoneDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 01-1.24-3H7.5a.5.5 0 010-1h1.52A5.5 5.5 0 0114 9.02V3.5c0-.83-.67-1.5-1.5-1.5h-7zm9 17a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 01-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const PhoneDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDismissFilledIcon({}), 'PhoneDismissFilled');

const PhoneDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 01-.66-1H5.5a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7c.32-.08.66-.15 1-.18V3.5c0-.83-.67-1.5-1.5-1.5h-7zM9 14.5c0-.17 0-.34.02-.5H7.5a.5.5 0 000 1h1.52a5.57 5.57 0 01-.02-.5zm10 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const PhoneDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDismissRegularIcon({}), 'PhoneDismissRegular');

const PhoneEraserFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.58 1.44a1.5 1.5 0 012.12 0l1.86 1.86a1.5 1.5 0 010 2.12l-5.14 5.14a1.5 1.5 0 01-2.12 0L9.44 8.7a1.5 1.5 0 010-2.12l5.14-5.14zm-4.43 5.84a.5.5 0 000 .71L12 9.85c.2.2.51.2.7 0l1.3-1.29L11.44 6l-1.3 1.3zM12.6 2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5.11a2.5 2.5 0 01-3.4-.12L8.72 9.4a2.5 2.5 0 010-3.54L12.6 2zm-2.1 12.5a.5.5 0 01-.5.5H8a.5.5 0 010-1h2c.28 0 .5.22.5.5z",
    fill: primaryFill
  }));
};

export const PhoneEraserFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneEraserFilledIcon({}), 'PhoneEraserFilled');

const PhoneEraserRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.58 1.44a1.5 1.5 0 012.12 0l1.86 1.86a1.5 1.5 0 010 2.12l-5.14 5.14a1.5 1.5 0 01-2.12 0L9.44 8.7a1.5 1.5 0 010-2.12l5.14-5.14zm-4.43 5.84a.5.5 0 000 .71L12 9.85c.2.2.51.2.7 0l1.3-1.29L11.44 6l-1.3 1.3zm2.38-5.2A2 2 0 0012 2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2v-4.61c-.3.26-.64.43-1 .53V16a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1h5.6l.93-.93zM7.5 14.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1H8a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneEraserRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneEraserRegularIcon({}), 'PhoneEraserRegular');

const PhoneLaptopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10V8a2 2 0 00-2-2H3V4.5zM10 15h7.5a.5.5 0 000-1H10v1zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8zM5 15a.5.5 0 000 1h1a.5.5 0 000-1H5z",
    fill: primaryFill
  }));
};

export const PhoneLaptopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptopFilledIcon({}), 'PhoneLaptopFilled');

const PhoneLaptopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10v-1h5.5a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5V6H3V4.5zM10 15h7.5a.5.5 0 000-1H10v1zm-5 0a.5.5 0 000 1h1a.5.5 0 000-1H5zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8zM3.5 8a.5.5 0 00-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-4z",
    fill: primaryFill
  }));
};

export const PhoneLaptopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptopRegularIcon({}), 'PhoneLaptopRegular');

const PhoneLinkSetupFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v5.52A5.5 5.5 0 0010.26 18H6.5A1.5 1.5 0 015 16.5v-13zm7.07 7.94a2 2 0 01-1.44 2.48l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PhoneLinkSetupFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLinkSetupFilledIcon({}), 'PhoneLinkSetupFilled');

const PhoneLinkSetupRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h3.26a5.5 5.5 0 01-.66-1H7a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1v5.02a5.57 5.57 0 011 0V4a2 2 0 00-2-2H7zm5.07 9.44a2 2 0 01-1.44 2.48l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PhoneLinkSetupRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLinkSetupRegularIcon({}), 'PhoneLinkSetupRegular');

const PhoneLockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v5.54A3 3 0 0011.5 12v.06A2 2 0 0010 14H8.5a.5.5 0 000 1H10v3H6.5A1.5 1.5 0 015 16.5v-13zm7.5 8.5v1H12a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1v-4a1 1 0 00-1-1h-.5v-1a2 2 0 10-4 0zm1 1v-1a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PhoneLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLockFilledIcon({}), 'PhoneLockFilled');

const PhoneLockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v5.04a3.02 3.02 0 00-1 0V4a1 1 0 00-1-1H7a1 1 0 00-1 1v12a1 1 0 001 1h3v1H7a2 2 0 01-2-2V4zm3.5 10H10v1H8.5a.5.5 0 010-1zm4-2v1H12a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1v-4a1 1 0 00-1-1h-.5v-1a2 2 0 10-4 0zm1 1v-1a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PhoneLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLockRegularIcon({}), 'PhoneLockRegular');

const PhonePageHeaderFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v1H5V4zm0 2v10c0 1.1.9 2 2 2h6a2 2 0 002-2V6H5z",
    fill: primaryFill
  }));
};

export const PhonePageHeaderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePageHeaderFilledIcon({}), 'PhonePageHeaderFilled');

const PhonePageHeaderRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 5h8v11a1 1 0 01-1 1H7a1 1 0 01-1-1V5z",
    fill: primaryFill
  }));
};

export const PhonePageHeaderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePageHeaderRegularIcon({}), 'PhonePageHeaderRegular');

const PhonePaginationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V4zm3 11a.5.5 0 100-1 .5.5 0 000 1zm2 0a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 10-1 0 .5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const PhonePaginationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePaginationFilledIcon({}), 'PhonePaginationFilled');

const PhonePaginationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 15a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zM7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 4a1 1 0 011-1h6a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4z",
    fill: primaryFill
  }));
};

export const PhonePaginationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePaginationRegularIcon({}), 'PhonePaginationRegular');

const PhoneScreenTimeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 01-1.24-3H7.5a.5.5 0 010-1h1.52A5.5 5.5 0 0114 9.02V3.5c0-.83-.67-1.5-1.5-1.5h-7zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneScreenTimeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneScreenTimeFilledIcon({}), 'PhoneScreenTimeFilled');

const PhoneScreenTimeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 01-.66-1H5.5a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7c.32-.08.66-.15 1-.18V3.5c0-.83-.67-1.5-1.5-1.5h-7zM9 14.5c0 .17 0 .34.02.5H7.5a.5.5 0 010-1h1.52l-.02.5zm10 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneScreenTimeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneScreenTimeRegularIcon({}), 'PhoneScreenTimeRegular');

const PhoneShakeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.37 2.93a.5.5 0 11.5-.86 4.25 4.25 0 011.63 5.66.5.5 0 01-.88-.47 3.25 3.25 0 00-1.25-4.33zm-1 1.74a.5.5 0 11.5-.87c1.02.59 1.4 1.86.91 2.9a.5.5 0 01-.9-.42c.27-.58.06-1.29-.5-1.61zm-9.74 12.4a.5.5 0 11-.5.86 4.25 4.25 0 01-1.63-5.66.5.5 0 11.88.46 3.25 3.25 0 001.25 4.33zm1-1.74a.5.5 0 11-.5.87 2.25 2.25 0 01-.92-2.9.5.5 0 01.9.42c-.26.58-.05 1.28.52 1.61zm4.54-12.26a1.95 1.95 0 012.4 1.4l2.37 8.97a2.04 2.04 0 01-1.42 2.48l-3.69 1a1.95 1.95 0 01-2.4-1.4L5.08 6.57a2.04 2.04 0 011.42-2.49l3.68-1zm-.49 11.3c.07.27.34.43.6.36l1.79-.48a.51.51 0 00.36-.62.49.49 0 00-.6-.36l-1.78.49a.51.51 0 00-.37.62z",
    fill: primaryFill
  }));
};

export const PhoneShakeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneShakeFilledIcon({}), 'PhoneShakeFilled');